$(document).ready(function () {
	
	// --- Brake Rotor Selector Logic ---
	$(document).on('change', 'select#bike_model', function () {
		const bikeModel = $(this).val();
		const $brakeRotor = $('#brake_rotor');
		const $brakeRotorRow = $brakeRotor.closest('tr');

		// Map of bike models and their specific rotor options
		const specificRotors = {
			// FRONT-ROTORS
			"690 Enduro *FRONT*": [{ value: "300MM_FLOATING", label: "300mm Floating" }],
			"690 Enduro ABS *FRONT*": [{ value: "300MM_FLOATING", label: "300mm Floating" }],
			"790 Adventure *FRONT*": [{ value: "320MM_FLOATING", label: "320mm Floating" }],
			"790 Adventure R *FRONT*": [{ value: "320MM_FLOATING", label: "320mm Floating" }],
			"790 Adventure R Rally *FRONT*": [{ value: "320MM_FLOATING", label: "320mm Floating" }],
			"890 Adventure *FRONT*": [{ value: "320MM_FLOATING", label: "320mm Floating" }],
			"890 Adventure L *FRONT*": [{ value: "320MM_FLOATING", label: "320mm Floating" }],
			"890 Adventure R *FRONT*": [{ value: "320MM_FLOATING", label: "320mm Floating" }],
			"890 Adventure R Rally *FRONT*": [{ value: "320MM_FLOATING", label: "320mm Floating" }],
			"1090 Adventure *FRONT*": [{ value: "320MM_FLOATING", label: "320mm Floating" }],
			"1090 Adventure R *FRONT*": [{ value: "320MM_FLOATING", label: "320mm Floating" }],
			"1190 Adventure *FRONT*": [{ value: "320MM_FLOATING", label: "320mm Floating" }],
			"1190 Adventure R *FRONT*": [{ value: "320MM_FLOATING", label: "320mm Floating" }],
			"1290 Super Adventure *FRONT*": [{ value: "320MM_FLOATING", label: "320mm Floating" }],
			"1290 Super Adventure R *FRONT*": [{ value: "320MM_FLOATING", label: "320mm Floating" }],
			"DRZ400 SM *FRONT*": [
				{ value: "310MM_FIXED", label: "310mm FIXED" },
				{ value: "310MM_FLOATING", label: "310mm Floating" }
			],

			// REAR-ROTORS
			"CRF250L RALLY ABS *REAR*": [{ value: "298MM_FLOATING", label: "298mm Floating" }],
		};

		console.log('Selected bike model:', bikeModel);

		// Reset brake rotor field
		$brakeRotor.empty();
		$brakeRotorRow.hide();

		// Apply rotor options if a match exists
		if (specificRotors[bikeModel]) {
			specificRotors[bikeModel].forEach(obj => {
				const { value, label } = obj;
				console.log(`Matched rotor for ${bikeModel}:`, value);
	
				$brakeRotor.append(`<option value="${value}">${label}</option>`);
			})
			$brakeRotorRow.show();
		}
	});

	// --- Set rim lock to yes when a tire is selected
	$(document).on('change', 'select#mbtire', function() {
		const selectedTireValue = $(this).val();
		const rimLock = document.querySelector('#rim_lock');

		if (selectedTireValue != 'mbno') {
			rimLock.querySelector('option[value="Yes"]').setAttribute('selected', 'selected');
			rimLock.querySelector('option[value="No"]').removeAttribute('selected');
		} else {
			rimLock.querySelector('option[value="No"]').setAttribute('selected', 'selected');
			rimLock.querySelector('option[value="Yes"]').removeAttribute('selected');
		}
	});

	// --- remove standard hub style
	function removeStandardOption() {
		const select = document.getElementById("cush_drive");
		if (!select) return;

		const options = Array.from(select.options);
		options.forEach(option => {
			if (option.text.trim().toLowerCase() === "standard") {
			option.remove();
			}
		});
	}

	// --- remove ELITE RIM TYPE
	function enforceStandardRims() {
		const bikeModel = $('#bike_model').val();
		const rimType = $('#rim_type');

		if (bikeModel === 'SX 85 *FRONT*' || bikeModel === 'SX 85 *REAR*') {
			// Remove Elite option if exists
			rimType.find('option[value="Elite"]').remove();

			// Force select Standard if Elite was previously selected
			if (rimType.val() !== 'Standard') {
				rimType.val('Standard').trigger('change');
			}
		}
	}

	function createDisclaimerMessage (message, messageContainer) {
		const p = document.createElement('p');
		const spanOuter = document.createElement('span');
		const spanInner = document.createElement('span');
		spanInner.classList.add('inner-span');
		spanInner.style.color = 'rgb(249, 7, 29)';
		spanOuter.appendChild(spanInner);
		p.appendChild(spanOuter);

		spanInner.textContent = message;
		messageContainer.appendChild(p);
	}

	// --- Disclaimer message logic --- disclaimer-message
	$(document).on('change', 'select#bike_model', function () {
		const messageContainer = document.querySelector('.product-description');
		const bikeModel = $('select#bike_model').val();

		// Clear previous message
		const existing = messageContainer.querySelector('.inner-span');
		if (existing) existing.parentElement.parentElement.remove();

		switch (bikeModel) {
			case 'KLR650 Gen 1 *FRONT*':
				createDisclaimerMessage ('***MUST USE STOCK ROTOR***', messageContainer);
				break;
			default:
				// Do nothing
				break;
		}
	});

	// --- Remove tire option for KLR GRN 3
	$(document).on('change', 'select#bike_model', function() {
		const bikeModel = $('select#bike_model').val();
		const tireOption = $('#mbtiretr');

		switch (bikeModel) {
			case 'KLR650 Gen 3 *FRONT*':
			case 'KLR650 Gen 3 *REAR*':
				console.log('Tire option:', tireOption);
				tireOption.hide();
				break;
		
			default:
				break;
		}
	});

	// --- Hide front wheel for YZ 125 and YZ 250 < 1995

	function hideFrontWheel() {
		const exec = Number($(this).val()) < 1995 && $('select#bike_make').val() == "Yamaha";
	
		console.log('Running:', Number($(this).val()) < 1995, $('select#bike_make').val() == "Yamaha", exec, $('select#bike_model').val());
	
		if (exec) {
			if ($('select#bike_model').val().includes('YZ125') || $('select#bike_model').val().includes('YZ250')) {
				console.log('Running YZ125 or YZ250 detected');
				$('select#wheel_type').val('REAR').trigger('change');
				$('select#wheel_type').find('option[value="FRONT"]').hide();
			}
		} else {
			$('select#wheel_type').find('option[value="FRONT"]').show();
		}
	}

	$(document).on('change', '#bike_year', hideFrontWheel);
	$(document).on('change', '#bike_model', hideFrontWheel);
	$(document).on('change', '#bike_make', hideFrontWheel);

	// ----------------------------------------------------------//

	// --- set black color for DRX650SR 17X2.50 and 17X3.50 rims --- //
	function limitToBlackForDR650(category) {
		const targetRims = ['REAR 17X2.50', 'REAR 17X3.50'];
		const rimSize = $('#rim_size').val();
		const wheelType = $('#wheel_type').val();
		const bikeModel = $('#bike_model').val();

		const isWheelTypeRear = wheelType === 'REAR';
		const isTargetRim = targetRims.includes(rimSize);
		const isDR650Se = bikeModel === 'DR650SE *REAR*';

		const $powderTab = $('.rim-type-wrap[data-category="powder-coat"]');

		// ❌ RESET: Restore powder coat & exit
		if (!(isWheelTypeRear && isTargetRim && isDR650Se)) {
			$powderTab.show();
			return;
		}

		// 🔒 HIDE POWDER COAT TAB ALWAYS
		$powderTab.hide();

		// If the user was currently on Powder Coat, move them to Anodized
		if (category === 'powder-coat') {
			$('.rim-type-wrap[data-category="anodized"]').click();
			return;
		}

		// 🔥 SHOW ONLY Black ANODIZED (Black swatch, not powder coat)
		$('.color-swatch').removeClass('show');
		$('.color-swatch[data-category="anodized"][data-value="Black"]').addClass('show');
	}

	$(document).on('change', '#rim_size, #wheel_type, #bike_model', function() {
		limitToBlackForDR650($('.rim-type-wrap.active').attr('data-category'));
	});


	// -----------------------------------------------------------//

	$(document).on('change', '#bike_model', enforceStandardRims);
	$(document).on('change', '#rim_size', enforceStandardRims);
	

	$('#mbtiretr').show();
	setupTire();
	setupSprocket();
	$(document).on('change', 'select:not(#mbtire), input', function () {
		// console.log('Change');
		setupTire();
	});


	$(document).on('change', 'select, input', function () {
		var wheel_type = document.querySelector('#wheel_type').value;
		var rear_name = ['Rear', 'REAR'];
		if (rear_name.includes(wheel_type)) {
			document.querySelector('.sprocket').style.display = 'block';

			// Rear
		} else {
			document.querySelector('.sprocket').style.display = 'none';
			//Front
		}
	});

	function setupTire() {
		var selected_to = document.getElementById("mbtire").value;
		var rim_size = $('#rim_size').val();
		if (rim_size.split(' ')[1]) {
			rim_size = rim_size.split(' ')[1];
		}
		var wheel_type = $('#wheel_type').val();
		var rear_name = ['Rear', 'REAR'];
		var tire_options = [];
		if (['21x1.60', '21X1.60'].includes(rim_size)) {
			tire_options = [
				'DUNLOP D606 90/90-21',
				'DUNLOP MX34 80/100-21',
				'DUNLOP GEOMAX AT82 80/100-21',
				'SHINKO 241 21x275',
				'TUSK EMEX T-35 80/100-21',
				//OOS - 'IRC GX20 GEKKOTA 90/90-21',
				//OOS - 'SHINKO E804 90/90-21',
			];
		} else if (['21x1.85', '21X1.85'].includes(rim_size)) {
			tire_options = [
				'DUNLOP D606 90/90-21',
				'DUNLOP GEOMAX AT82 80/100-21',
				'DUNLOP MX34 80/100-21',
				'IRC GX20 GEKKOTA 90/90-21',
				'SHINKO 241 21x275',
				'TUSK EMEX T-35 80/100-21'
				//OOS - 'SHINKO E804 90/90-21',
			];
		} else if (['19x2.15', '19X2.15'].includes(rim_size) && rear_name.includes(wheel_type)) {
			tire_options = [
				'DUNLOP GEOMAX AT82 110/90-19',
				'DUNLOP GEOMAX AT82 120/90-19',
				'DUNLOP MX34 100/90-19',
				'DUNLOP MX34 110/90-19',
				'DUNLOP MX34 120/80-19',
				'SHINKO E804 100/90-19',
				'TUSK EMEX T-35 100/90-19',
				'TUSK EMEX T-35 110/90-19',
				'TUSK EMEX T-35 120/80-19'
			];
		} else if (['18x2.15', '18X2.15'].includes(rim_size) && rear_name.includes(wheel_type)) {
			tire_options = [
				'DUNLOP D606 120/90-18',
				'DUNLOP GEOMAX AT82 110/100-18',
				'DUNLOP GEOMAX AT82 120/90-18',
				'DUNLOP MX34 110/100-18',
				'DUNLOP MX34 120/90-18',
				'IRC VE-33 GEKKOTA 110/100-18',
				'SHINKO 241 18x4.00',
				'TUSK EMEX T-35 120/90-18',
				'TUSK EMEX T-35 100/100-18',
				'DUNLOP MX34 100/100-18'

			];
		} else if (['18x2.50', '18X2.50'].includes(rim_size) && rear_name.includes(wheel_type)) {
			tire_options = [
				'DUNLOP D606 120/90-18',
				'DUNLOP GEOMAX AT82 110/100-18',
				'DUNLOP GEOMAX AT82 120/90-18',
				'DUNLOP MX34 110/100-18',
				'DUNLOP MX34 120/90-18',
				'IRC VE-33 GEKKOTA 110/100-18',
				'SHINKO 241 18x4.00',
				'TUSK EMEX T-35 120/90-18'
			];
		} else if (['19x2.50', '19X2.50'].includes(rim_size) && rear_name.includes(wheel_type)) {
			tire_options = [
				'DUNLOP GEOMAX AT82 110/90-19',
				'DUNLOP GEOMAX AT82 120/90-19',
				'DUNLOP MX34 110/90-19',
				'DUNLOP MX34 120/80-19',
				'TUSK EMEX T-35 110/90-19',
				'TUSK EMEX T-35 120/80-19',
			];
		} 

		else if 
		(
			['16x1.85', '16X1.85'].includes(rim_size) && rear_name.includes(wheel_type)
			||
			['14x1.60', '14X1.60'].includes(rim_size) && rear_name.includes(wheel_type)
		) {
			tire_options = [
				'DUNLOP MX34 90/100-16',
				'DUNLOP MX34 90/100-14'
			];
		}

		else if 
		(
			['19x1.60', '19X1.60'].includes(rim_size)
			||
			['17x1.40', '17X1.40'].includes(rim_size)
		) {
			tire_options = [
				'DUNLOP MX34 70/100-19',
				'DUNLOP MX34 70/100-17'
			];
		}

		var selectElement = document.getElementById("mbtire");
		selectElement.innerHTML = '<option class="category" value="mbno">No</option>';
		selectElement.length = 1;
		tire_options.forEach(function (tireOption) {
			var option = document.createElement("option");
			option.value = tireOption;
			option.text = tireOption;
			if (tireOption == selected_to) {
				option.selected = true;
			}
			selectElement.add(option);
		});
	}

	function setupCush(){
		if(document.querySelector("#wheel_type").value == "REAR"){
			var selected_rim_size = document.querySelector('#rim_size').value.replaceAll('X','x').replaceAll(' ','');
			// console.log(`Selected size: ${selected_rim_size}`)
			if(selected_rim_size.includes('18x4.25') || selected_rim_size.includes('18x2.15') || selected_rim_size.includes('18x2.50') || selected_rim_size.includes('17x2.50')){
				var make = document.querySelector('#bike_make').value;
				var current_value = document.getElementById("cush_drive").value;
				var select = $('#cush_drive');
	
				var options = `<option class="category" value="unavailable">Standard</option>`;
				var has_cush = false;
				switch (make) {
					case 'Stark':						
						if(current_value == "unavailable"){
							options = `<option class="category" value="unavailable" selected>Standard</option><option class="category" value="Cush Drive">Cush Drive</option>`;
						}else{
							options = `<option class="category" value="unavailable">Standard</option><option class="category" value="Cush Drive" selected>Cush Drive</option>`;
						}
						has_cush = true;
						break;
					case 'Alta Redshift':
						if(current_value == "unavailable"){
							options = `<option class="category" value="unavailable" selected>Standard</option><option class="category" value="Cush Drive">Cush Drive</option>`;
						}else{
							options = `<option class="category" value="unavailable">Standard</option><option class="category" value="Cush Drive" selected>Cush Drive</option>`;
						}
						has_cush = true;
						break;
	
					case 'BMW':
						if(document.querySelector('#bike_model').value.includes('450X')){
							if(current_value == "unavailable"){
								options = `<option class="category" value="unavailable" selected>Standard</option><option class="category" value="Cush Drive">Cush Drive</option>`;
							}else{
								options = `<option class="category" value="unavailable">Standard</option><option class="category" value="Cush Drive" selected>Cush Drive</option>`;
							}
							has_cush = true;
						}
						break;
					case 'Beta':
						if(document.querySelector('#bike_model').value.includes('RR') || document.querySelector('#bike_model').value.includes('RS')){
							if(current_value == "unavailable"){
								options = `<option class="category" value="unavailable" selected>Standard</option><option class="category" value="Cush Drive">Cush Drive</option>`;
							}else{
								options = `<option class="category" value="unavailable">Standard</option><option class="category" value="Cush Drive" selected>Cush Drive</option>`;
							}
							has_cush = true;
						}
						break;
					case 'GasGas':
						var selectElement = document.querySelector('#bike_model');
						var selectedOptionText = selectElement.options[selectElement.selectedIndex].text;
						if(selectedOptionText == "ES500"){
								if (current_value == "unavailable") {
									options = `<option class="category" value="unavailable" selected>Standard</option><option class="category" value="Cush Drive">Cush Drive</option>`;
								} else {
									options = `<option class="category" value="unavailable">Standard</option><option class="category" value="Cush Drive" selected>Cush Drive</option>`;
								}
								has_cush = true;
						}
						else if(selectedOptionText == 'EC200' || selectedOptionText =='EC250' || selectedOptionText =='EC300' ){
							var selected_year = document.querySelector('#bike_year').value;
							
							if(selectedOptionText == 'EC200'){
								// Check year 2020-2025
								if(selected_year >= 2020 && selected_year <= 2025){
									if(current_value == "unavailable"){
										options = `<option class="category" value="unavailable" selected>Standard</option><option class="category" value="Cush Drive">Cush Drive</option>`;
									}else{
										options = `<option class="category" value="unavailable">Standard</option><option class="category" value="Cush Drive" selected>Cush Drive</option>`;
									}
									has_cush = true;
	
								}
							}else if(selectedOptionText == 'EC250'){
								// Check Year 2020-2025
								if(selected_year >= 2020 && selected_year <= 2025){
									if(current_value == "unavailable"){
										options = `<option class="category" value="unavailable" selected>Standard</option><option class="category" value="Cush Drive">Cush Drive</option>`;
									}else{
										options = `<option class="category" value="unavailable">Standard</option><option class="category" value="Cush Drive" selected>Cush Drive</option>`;
									}
									has_cush = true;
	
								}
							}else{
								// Check Year 2020-2025
								if(selected_year >= 2020 && selected_year <= 2025){
									if(current_value == "unavailable"){
										options = `<option class="category" value="unavailable" selected>Standard</option><option class="category" value="Cush Drive">Cush Drive</option>`;
									}else{
										options = `<option class="category" value="unavailable">Standard</option><option class="category" value="Cush Drive" selected>Cush Drive</option>`;
									}
									has_cush = true;
	
								}
	
							}
						}
						break;
					case 'Honda':
						var bikeModelsWithCushDrive = [
							'CR125',
							'CR250',
							'CRF250L',
							'CRF250L ABS',
							'CRF250L Rally',
							'CRF250R',
							'CRF250X',
							'CRF250RX',
							'CRF300L',
							'CRF300L ABS',
							'CRF300L Rally',
							'CRF450R',
							'CRF450R Works Edition',
							'CRF450L',
							'CRF450RL',
							'CRF450X',
							'CRF450RX',
							'CR500',
							'XR600',
							'XR650R',
							'XR650L',
							'CRF250L RALLY ABS',
							'CRF250R WORKS EDITION',
							'CRF300L Rally ABS',
							'XR400',
							'CRF450L /RL',
							'XR250R',
							'XR400R'
						];
						var selectElement = document.querySelector('#bike_model');
						var selectedOptionText = selectElement.options[selectElement.selectedIndex].text;

						console.log('Honda selected option on cush drive function:', selectedOptionText);
						
						if (bikeModelsWithCushDrive.includes(selectedOptionText)) {
							if (current_value == "unavailable") {
								options = `<option class="category" value="unavailable" selected>Standard</option><option class="category" value="Cush Drive">Cush Drive</option>`;
							} else {
								options = `<option class="category" value="unavailable">Standard</option><option class="category" value="Cush Drive" selected>Cush Drive</option>`;
							}
							has_cush = true;
						}
						break;
					case 'Husaberg':
						// var selectElement = document.querySelector('#bike_model');
						// var selectedOptionText = selectElement.options[selectElement.selectedIndex].text;
						// if(selectedOptionText == 'FE' | selectedOptionText == 'FC'){
						// 	if(current_value == "unavailable"){
						// 		options = `<option class="category" value="unavailable" selected>Standard</option><option class="category" value="Cush Drive">Cush Drive</option>`;
						// 	}else{
						// 		options = `<option class="category" value="unavailable">Standard</option><option class="category" value="Cush Drive" selected>Cush Drive</option>`;
						// 	}
						// 	has_cush = true;
						// }
						if(current_value == "unavailable"){
								options = `<option class="category" value="unavailable" selected>Standard</option><option class="category" value="Cush Drive">Cush Drive</option>`;
							}else{
								options = `<option class="category" value="unavailable">Standard</option><option class="category" value="Cush Drive" selected>Cush Drive</option>`;
							}
							has_cush = true;
						break;
					case 'Husqvarna':
						var bikeModelsWithCushDrive = [	
							'TC 410',
							'TE 150',
							'TC 300',
							'FC 250',
							'FE 250',
							'TE 250',
							'TE 250i',
							'TE 300', // From 2002 and up
							'TE 300i',
							'TX 300',
							'TX 300i',
							'FC 350',
							'FE 350',
							'FX 350',
							'FC 450',
							'FC 450 ROCKSTAR EDITION',
							'FE 450',
							'FE 501',
							'FX 450',
							'FE 501',
							'TXC 250',
							'TXC 310',
							'TXC 450',
							'TXC 510',
							'TXC 511',
							'701 ENDURO ABS', // cush Drive is the only option
							'NORDEN 901', // cush Drive is the only option
							'TC 450',
							'TC 510',
							'TX 250',
							'TE 410',
							'TE 450',
							'TE 510',
							'TE 511',
							'WR 250',
							'WR 360',
							'CR 125',
							'CR 150',
							'CR 250',
							'WRE 125'
						];
						var selectElement = document.querySelector('#bike_model');
						var selectedOptionText = selectElement.options[selectElement.selectedIndex].text;

						console.log('selectedOptionText:', selectedOptionText);

						if(selectedOptionText === "701 ENDURO ABS" || selectedOptionText === "NORDEN 901"){
							options = `<option class="category" value="Cush Drive" selected>Cush Drive</option>`;
							has_cush = true;
							removeStandardOption();
						}
						else if(selectedOptionText == "TX 300"){
							var selected_year = document.querySelector('#bike_year').value;
							
							// 2001-2025
							if(selected_year >= 2001 && selected_year <= 2025){
								if(current_value == "unavailable"){
									options = `<option class="category" value="unavailable" selected>Standard</option><option class="category" value="Cush Drive">Cush Drive</option>`;
								}else{
									options = `<option class="category" value="unavailable">Standard</option><option class="category" value="Cush Drive" selected>Cush Drive</option>`;
								}
								has_cush = true;
							}
						}
						// for 2014 to 2025 models only
						else if
						(
							selectedOptionText == "TX125" ||
							selectedOptionText == "TC 125" ||
							selectedOptionText == "TE 125" ||
							selectedOptionText == "TC 250" ||
							selectedOptionText == "TE 250" ||
							selectedOptionText == "TC 450"
						) {
							var selected_year = document.querySelector('#bike_year').value;

							// 2014
							if(selected_year >= 2014 && selected_year <= 2025){
								if(current_value == "unavailable"){
									options = `<option class="category" value="unavailable" selected>Standard</option><option class="category" value="Cush Drive">Cush Drive</option>`;
								}else{
									options = `<option class="category" value="unavailable">Standard</option><option class="category" value="Cush Drive" selected>Cush Drive</option>`;
								}
								has_cush = true;
							}
						}
						else if (bikeModelsWithCushDrive.includes(selectedOptionText)) {
							if (current_value == "unavailable") {
								options = `<option class="category" value="unavailable" selected>Standard</option><option class="category" value="Cush Drive">Cush Drive</option>`;
							} else {
								options = `<option class="category" value="unavailable">Standard</option><option class="category" value="Cush Drive" selected>Cush Drive</option>`;
							}
							has_cush = true;
						}
						break;
					case 'Kawasaki':
						var selectElement = document.querySelector('#bike_model');
						var selectedOptionText = selectElement.options[selectElement.selectedIndex].text;

						if(selectedOptionText == 'KLR650'){
							options = `<option class="category" value="Cush Drive" selected>Cush Drive</option>`;
							has_cush = true;
						}else if(selectedOptionText == 'KLX400'){
							if (current_value == "unavailable") {
								options = `<option class="category" value="unavailable" selected>Standard</option><option class="category" value="Cush Drive">Cush Drive</option>`;
							} else {
								options = `<option class="category" value="unavailable">Standard</option><option class="category" value="Cush Drive" selected>Cush Drive</option>`;
							}
							has_cush = true;
						}
						break;
					case 'Kove':
						var selectElement = document.querySelector('#bike_model');
						var selectedOptionText = selectElement.options[selectElement.selectedIndex].text;

						if(selectedOptionText == '450 Rally' || selectedOptionText == '450 Rally ABS'){
							options = `<option class="category" value="Cush Drive" selected>Cush Drive</option>`;
							has_cush = true;
						}
						break;
					case 'KTM':
						var selectElement = document.querySelector('#bike_model');
						var selectedOptionText = selectElement.options[selectElement.selectedIndex].text;
						var numbers = selectedOptionText.match(/\d+/g);
						
						if(selectedOptionText == "690 Enduro" 
							|| selectedOptionText == "690 Enduro ABS" 
							|| selectedOptionText == "790 ADVENTURE" 
							|| selectedOptionText == "790 Adventure R"
							|| selectedOptionText == "890 ADVENTURE"
							|| selectedOptionText == "890 Adventure R"
							|| selectedOptionText == "950 ADVENTURE"
							|| selectedOptionText == "990 ADVENTURE"
							|| selectedOptionText == "1190 ADVENTURE"
							|| selectedOptionText == "1090 Adventure R"
							|| selectedOptionText == "1290 ADVENTURE"
							|| selectedOptionText == "1290 Super Adventure R"
							|| selectedOptionText == "1290 Super Adventure S" ){
								options = `<option class="category" value="Cush Drive" selected>Cush Drive</option>`;
								has_cush = true;
						}
						else if (numbers) {
							var num = numbers.join('');
							if (num <= 530){
								if (current_value == "unavailable") {
									options = `<option class="category" value="unavailable" selected>Standard</option><option class="category" value="Cush Drive">Cush Drive</option>`;
								} else {
									options = `<option class="category" value="unavailable">Standard</option><option class="category" value="Cush Drive" selected>Cush Drive</option>`;
								}
								has_cush = true;
							}
						}
						
						break;	
					case 'Suzuki':
						var selectElement = document.querySelector('#bike_model');
						var selectedOptionText = selectElement.options[selectElement.selectedIndex].text;
						var bikeModelsWithCushDrive = [
							'DRZ400 SM',
							'DRZ400 SE',
							'DRZ400 E'
						]
	
						if(selectedOptionText == 'DR650' ){
							options = `<option class="category" value="Cush Drive" selected>Cush Drive</option>`;
							has_cush = true;
						}else if(bikeModelsWithCushDrive.includes(selectedOptionText)){
							if (current_value == "unavailable") {
								options = `<option class="category" value="unavailable" selected>Standard</option><option class="category" value="Cush Drive">Cush Drive</option>`;
							} else {
								options = `<option class="category" value="unavailable">Standard</option><option class="category" value="Cush Drive" selected>Cush Drive</option>`;
							}
							has_cush = true;
						}
						break;	
					case 'Yamaha':
						var selectElement = document.querySelector('#bike_model');
						var selectedOptionText = selectElement.options[selectElement.selectedIndex].text;
						var bikeModelsWithCushDrive = [
							'WR250F',
							'WR400',
							'WR426',
							'WR450F',
							'YZ125',
							'YZ250',
							'YZ250F',
							'YZ250FX',
							'YX250X',
							'YZ426',
							'YZ450F',
							'YZ450FX',
							'WR426'
						]
						if(bikeModelsWithCushDrive.includes(selectedOptionText)){
							if (current_value == "unavailable") {
								options = `<option class="category" value="unavailable" selected>Standard</option><option class="category" value="Cush Drive">Cush Drive</option>`;
							} else {
								options = `<option class="category" value="unavailable">Standard</option><option class="category" value="Cush Drive" selected>Cush Drive</option>`;
							}
							has_cush = true;
						}
						break;
					default:
						break;
				}
				if(has_cush){
					select.empty().append(options);
					document.getElementById("cush_drive").disabled = false;
					$('#cush_drive1').show(); 
				}else{
					select.empty().append('<option class="category" value="unavailable">Standard</option>');
					document.getElementById("cush_drive").disabled = true;
					$('#cush_drive1').hide(); 
	
				}				
			}else{				
				select = $('#cush_drive');
				select.empty().append('<option class="category" value="unavailable">Standard</option>');
				document.getElementById("cush_drive").disabled = true;
				$('#cush_drive1').hide(); 
			}
			
		}else{
			select = $('#cush_drive');
			select.empty().append('<option class="category" value="unavailable">Standard</option>');
			document.getElementById("cush_drive").disabled = true;
			$('#cush_drive1').hide(); 
		}
	}

	$(document).on('change', 'select:not(#cush_drive), input', function(){
      setupCush();
    });

	function setupSprocket(){
		// console.log('Running setupSprocket...');
		const wheel_type = document.querySelector("#wheel_type").value;
		var selectedMake = document.querySelector("#bike_make").value;
		var selectModelDOM = document.querySelector('#bike_model');
		var selectedModel = selectModelDOM.options[selectModelDOM.selectedIndex].text;
		var selectedYear = parseInt(document.querySelector('#bike_year').value);
		var preselected_value = document.querySelector('#sprocket_size').value;
		var availableSpokes = [];
		if(wheel_type == "REAR"){
			var select = $('#sprocket_size');
			var make = document.querySelector('#bike_make').value;
			switch (make) {
				case 'Rieju':
					availableSpokes = [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52];
					break;
				case 'Kayo':
					availableSpokes = [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52];
					break;
				case 'Stark':
					availableSpokes = [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53];
					break;				
				case 'Alta Redshift':
					availableSpokes = [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52];
					break;
				case 'BMW':
					availableSpokes = [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52];
					break;
				case 'Beta':
					availableSpokes = [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52];
					break;
				case 'GasGas':
					var spokesByModelYear = {
						"ES500": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"EC125": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"EC200 RANGER": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"200 XC": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"EC250 2T": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"EC250 4T": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"EC250 SIX DAYS": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"XC250": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"EC300 RANGER": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"EC300 SIX DAYS": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"XC300": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"EC450": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"EC200": {
							"2013": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2014": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2015": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2016": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2017": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2018": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2019": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2020": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2021": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2022": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2023": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2024": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2025": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"EC250": {
							"2008": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2009": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2010": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2011": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2012": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2013": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2014": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2015": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2016": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2017": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2018": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2019": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2020": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2021": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2022": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2023": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2024": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2025": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"EC300": {
							"2008": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2009": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2010": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2011": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2012": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2013": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2014": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2015": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2016": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2017": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2018": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2019": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2020": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2021": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2022": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2023": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2024": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2025": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						}
					};
					availableSpokes = [];
					if (spokesByModelYear[selectedModel]) {
						if(spokesByModelYear[selectedModel][selectedYear]){
							availableSpokes = spokesByModelYear[selectedModel][selectedYear];
						}else{
							availableSpokes = spokesByModelYear[selectedModel].default || [];
						}
					}			

					break;
				case 'Honda':
					var spokesByModelYear = {
						"CR125": {
							default: [39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"CR250": {
							default: [39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"CRF250L": {
							default: [39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"CRF250L ABS": {
							default: [39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"CRF250L Rally": {
							default: [39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"CRF250R": {
							default: [39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"CRF250X": {
							default: [39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"CRF250F": {
							default: [39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"CRF250RX": {
							default: [39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"CRF300L": {
							default: [39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"CRF300L ABS": {
							default: [39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"CRF300L Rally": {
							default: [39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"CRF300L Rally ABS": {
							default: [39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"CRF450R": {
							default: [39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"CRF450R Works Edition": {
							default: [39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"CRF450L": {
							default: [39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"CRF450RL": {
							default: [39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"CRF450X": {
							default: [39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"CRF450RX": {
							default: [39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"CR500": {
							default: [39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"XR600": {
							default: [39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"XR650R": {
							default: [39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"XR650L": {
							default: [39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"CRF250L RALLY ABS": {
							default: [39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"XR600R": {
							default: [39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"CRF250R WORKS EDITION": {
							default: [39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"XR400": {
							default: [39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"CRF450L /RL": {
							default: [39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"XR250R": {
							default: [39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"XR400R": {
							default: [39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						}
					};

					availableSpokes = [];
					if (spokesByModelYear[selectedModel]) {
						if(spokesByModelYear[selectedModel][selectedYear]){
							availableSpokes = spokesByModelYear[selectedModel][selectedYear];
						}else{
							availableSpokes = spokesByModelYear[selectedModel].default || [];
						}
					}

					break;
				case 'Husaberg':
					availableSpokes = [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52];
					break;
				case 'Husqvarna':
					// Define sprocket sizes for different models and years
					var spokesByModelYear = {
						"CR 125": {
							default: [40, 41, 42, 44, 47, 48, 49, 50, 51, 52]
						},
						"SM 125": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"TC 125": {
							"2000": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2001": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2002": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2003": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2004": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2005": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2006": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2007": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2008": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2009": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2010": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2011": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2012": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2013": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2014": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2015": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2016": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2017": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2018": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2019": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2020": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2021": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2022": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2023": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2024": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2025": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"TX 125": {
							"2000": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2001": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2002": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2003": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2004": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2005": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2006": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2007": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2008": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2009": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2010": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2011": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2012": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2013": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2014": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2015": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2016": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2017": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2018": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2019": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2020": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2021": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2022": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2023": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2024": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2025": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"TXC 125": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"WR 125": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"TE 150": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"FC 250": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"TC 250": {
							"2002": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2003": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2004": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2005": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2006": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2007": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2008": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2009": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2010": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2011": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2012": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2013": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
							"2014": [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2015": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2016": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2017": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2018": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2019": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2020": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2021": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2022": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2023": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2024": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
							"2025": [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"FE 125": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"FE 250": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"TE 250": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"TE 250i": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"SM 250": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"TXC 250": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"WR 250": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"CR 250": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"TE 300": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"TE 300i": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"TX 300": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"TX 300i": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"FC 350": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"FE 350": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"FX 350": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"SM 499": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"TC 499": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"TE 499": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"TXC 499": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"WR 499": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"CR 499": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"CR 450": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"FC 450": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"FC 450 Rockstar Edition": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"FE 450": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"FX 450": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"SM 450": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"TC 450": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"TE 450": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"TXC 450": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"WR 450": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"FE 501": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"SM 510": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"TC 510": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"TE 510": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"TXC 510": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"WR 510": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"CR 510": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"SM 610": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"TC 610": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"TE 610": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"TXC 610": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"WR 610": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"CR 610": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
						},
						"701 ENDURO ABS": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"TC 150": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"TX 150": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"FX 250": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"FX 450": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"TE 501": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"TC 85": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"TC 300": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"TC 410": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"TX 250": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"TE 125": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"TE 410": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"TE 511": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"WR 250": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"WR 360": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"CR 150": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"WRE 125": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"NORDEN 901": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"TXC 250": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"TXC 310": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"TXC 450": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"TXC 510": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"TXC 511": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},

					};


					if (spokesByModelYear[selectedModel]) {
						var modelData = spokesByModelYear[selectedModel];
						if (modelData[selectedYear]) {
							availableSpokes = modelData[selectedYear];
						} else {
							availableSpokes = modelData.default || [];
						}
					}


					break;
				case 'Kawasaki':
					var spokesByModelYear = {
						"KX125": {
							default: [40, 42, 44, 47, 48, 49, 50, 51, 52]
						},
						"KX250": {
							default: [40, 42, 44, 47, 48, 49, 50, 51, 52]
						},
						"KX250F": {
							default: [40, 42, 44, 47, 48, 49, 50, 51, 52]
						},
						"KX250X": {
							default: [40, 42, 44, 47, 48, 49, 50, 51, 52]
						},
						"KLX 300R": {
							default: [40, 42, 44, 47, 48, 49, 50, 51, 52]
						},
						"KLX400": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"KX450F": {
							default: [40, 42, 44, 47, 48, 49, 50, 51, 52]
						},
						"KX450X": {
							default: [40, 42, 44, 47, 48, 49, 50, 51, 52]
						},
						"KLX450R": {
							default: [40, 42, 44, 47, 48, 49, 50, 51, 52]
						},
						"KX500": {
							default: [40, 42, 44, 47, 48, 49, 50, 51, 52]
						},
						"KLR650": {
							default: [43]
						},
						"KDX200": {
							default: [40, 42, 44, 47, 48, 49, 50, 51, 52]
						},
						"KDX220": {
							default: [40, 42, 44, 47, 48, 49, 50, 51, 52]
						},
						"KDX250": {
							default: [40, 42, 44, 47, 48, 49, 50, 51, 52]
						}
					};
					if (spokesByModelYear[selectedModel]) {
						var modelData = spokesByModelYear[selectedModel];
						if (modelData[selectedYear]) {
							availableSpokes = modelData[selectedYear];
						} else {
							availableSpokes = modelData.default || [];
						}
					}
					break;
				case 'Kove':
					availableSpokes = [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52];
					break;
				case 'KTM':
					var numbers = selectedModel.match(/\d+/g);
					if(selectedModel == "690 Enduro" 
						|| selectedModel == "690 Enduro ABS" 
						|| selectedModel == "790 ADVENTURE" 
						|| selectedModel == "790 Adventure R"
						|| selectedModel == "890 ADVENTURE"
						|| selectedModel == "890 Adventure R"
					){
						availableSpokes = [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52];
							
							
					}else if(selectedModel == "950 ADVENTURE"
						|| selectedModel == "990 ADVENTURE"
						|| selectedModel == "1190 ADVENTURE"
						|| selectedModel == "1090 Adventure R"
						|| selectedModel == "1290 ADVENTURE"
						|| selectedModel == "1290 Super Adventure R"
						|| selectedModel == "1290 Super Adventure S" )
					{
						availableSpokes = [42];

					} else if (selectedModel === "SX 85") {
						availableSpokes = [45, 51];
					} else if (numbers) {
						var num = numbers.join('');
						if (num <= 530){
							availableSpokes = [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52];
						}
					}
					break;	
				case 'Sherco':
					availableSpokes = [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52];
					break;	
				case 'Suzuki':
					var spokesByModelYear = {
						"DRZ400 SM": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"DRZ400 SE": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"DRZ400 E": {
							default: [38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
						},
						"DR650": {
							default: [40, 42]
						},
						"RM125": {
							default: [40, 42, 44, 47, 48, 49, 50, 51, 52]
						},
						"RM250": {
							default: [40, 42, 44, 47, 48, 49, 50, 51, 52]
						},
						"RMZ250": {
							default: [40, 42, 44, 47, 48, 49, 50, 51]
						},
						"RMX450": {
							default: [40, 42, 44, 47, 48, 49, 50, 51]
						},
						"RMZ450": {
							default: [40, 42, 44, 47, 48, 49, 50, 51]
						},
						"RMX250": {
							default: [40, 42, 44, 47, 48, 49, 50, 51, 52]
						},
						"DRZ400": {
							default: [40, 42, 44, 47, 48, 49, 50, 51, 52]
						},
						"DRZ400 S": {
							default: [40, 42, 44, 47, 48, 49, 50, 51, 52]
						}
					};

					if (spokesByModelYear[selectedModel]) {
						var modelData = spokesByModelYear[selectedModel];
						if (modelData[selectedYear]) {
							availableSpokes = modelData[selectedYear];
						} else {
							availableSpokes = modelData.default || [];
						}
					}

					break;	
				case 'Yamaha':					
					var spokesByModelYear = {
						"WR250F": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]

						},
						"WR250R (Street Legal)": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]

						},
						"WR250X (Street Legal)": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]

						},
						"WR400": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]

						},
						"WR426": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]

						},
						"WR450F": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]

						},
						"YZ 125": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]

						},
						"YZ250": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]

						},
						"YZ250F": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]

						},
						"YZ250FX": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]

						},
						"YX250X": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]

						},
						"YZ426": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]

						},
						"YZ450F": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]

						},
						"YZ450FX": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]

						},
						"WR426": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]

						},
						"YZ125X": {
							default: [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]

						}
					};

					if (spokesByModelYear[selectedModel]) {
						var modelData = spokesByModelYear[selectedModel];
						if (modelData[selectedYear]) {
							availableSpokes = modelData[selectedYear];
						} else {
							availableSpokes = modelData.default || [];
						}
					}

					break;
				default:
					break;
			}

			// console.log("Make", make);
			// console.log("Model", selectedModel);
			// console.log("Year", selectedYear);
			// console.log("Available Spokes:", availableSpokes);

			if(availableSpokes.length > 0){
				var select = $('#sprocket_size');
				var spokedom = ``;
				availableSpokes.forEach(function(spoke){
					var v = `${spoke} Teeth`;
					if(preselected_value == v){
						spokedom+=`<option class="category" value="${v}" selected>${v}</option>`;
					}else{
						spokedom+=`<option class="category" value="${v}">${v}</option>`;
					}
				});		
				// Suzuki RM 125 & RM 250
				// Honda CR250L, CR300L, CR250L Rally, CR300L Rally, CRF250L Rally ABS
				// Suzuki DRZ400
				// Kawasaki KLX250, KLX300
				// All Beta models
				// All Reiju models
				var restrict_nospoke  = [
					'1989 - 98 RM125 * REAR *',
					'1989 - 98 RM250 * REAR *',
					'2017+ CRF250L *REAR*',
					'CRF250L RALLY ABS *REAR*',
					'CRF300L *REAR*',
					'2017+ CRF250L Rally *REAR*',
					'CRF300L Rally *REAR*',
					'XR600R *REAR*',
					'DRZ400 SM *REAR*',
					'2000 - 17 DRZ400 S * REAR *',
					'2000 - 17 DRZ400 SE * REAR *',
					'2000 - 17 DRZ400 E * REAR *',
					'2004 - 17 KX250F  *REAR*',
					'KX250XC *REAR*',
					'KLX 300R *REAR*',
					'125 RR *REAR*',
					'200 RR *REAR*',
					'250 RR *REAR*',
					'250 RX *REAR*',
					'300 RR *REAR*',
					'300 X-TRAINER *REAR*',
					'350 RR *REAR*',
					'350 RR-S *REAR*',
					'350 RX *REAR*',
					'390 RR *REAR*',
					'390 RR-S *REAR*',
					'400 RR *REAR*',
					'400 RR-S *REAR*',
					'430 RR *REAR*',
					'430 RR-S *REAR*',
					'450 RR *REAR*',
					'450 RR-S *REAR*',
					'450 RX *REAR*',
					'480 RR *REAR*',
					'498 RR *REAR*',
					'498 RR-S *REAR*',
					'500 RR-S *REAR*',
					'RS *REAR*',
					'CRF250L ABS *REAR*',
					'KDX200 *REAR*',
					'KDX220 *REAR*',
					'KDX250 *REAR*',
					'T4 230 *REAR*',
					'MR 200 *REAR*',
					'MR Pro 200 *REAR*',
					'MR Racing 200 *REAR*',
					'MR Ranger 200 *REAR*',
					'MR 300 *REAR*',
					'MR 6Days 250 *REAR*',
					'MR 6Days 300 *REAR*',
					'MR Alfredo Gómez Replica 300 *REAR*',
					'MR Pro 300 *REAR*',
					'MR Pro 300i *REAR*',
					'MR Racing 300 *REAR*',
					'MR Ranger 300 *REAR*',
					'2008 - 2017 125-300 SE-R * REAR *',
					'2008 - 2017 250-450 SEF-R * REAR *',
					'2008 - 2017 250-450 SER * REAR *',
					'SE 125 *REAR*',
					'SE 125 Factory *REAR*',
					'SE 125 Racing *REAR*',
					'SEF 125 *REAR*',
					'SE 250 *REAR*',
					'SE 250 Factory *REAR*',
					'SE 250 Racing *REAR*',
					'SEF 250 *REAR*',
					'SEF 250 Factory *REAR*',
					'SEF 250 Racing *REAR*',
					'SE 300 *REAR*',
					'SE 300 Factory *REAR*',
					'SE 300 Racing *REAR*',
					'SE 300 Xtrem *REAR*',
					'SEF 300 *REAR*',
					'SEF 300 Factory *REAR*',
					'SEF 300 Racing *REAR*',
					'SEF 450 *REAR*',
					'SEF 450 Factory *REAR*',
					'SEF 450 Racing *REAR*',
					'SEF 500 *REAR*',
					'SEF 500 Factory *REAR*',
					'SEF 500 Racing *REAR*',
					'2009 - 11 450X *REAR*',
					'CRF300L *REAR*',
					'CRF300L ABS *REAR*',
					'CRF300L Rally *REAR*',
					'CRF300L Rally ABS *REAR*',
					'2000 - 08 XR650R *REAR*',
					'1993 - 2017 XR650L *REAR*',
					'1989 - 98 RM125 * REAR *',
					'1989 - 98 RM250 * REAR *',
					'RMX250 *REAR*',
					'DRZ400 *REAR*',
					'2000 - 17 DRZ400 S * REAR *',
					'2000 - 17 DRZ400 E * REAR *',
				]

				var restrict_nospoke_years = {
					"GASGAS": 2019,
					"YAMAHA": 1998, 
				};

				// restrict no spoke yamaha 125 years 1986-1998

				var selected_model = $('#bike_model').val();

				// if(!restrict_nospoke.includes(selected_model)){
				// 	spokedom+=`<option class="category" value="no">No Sprocket</option>`;
				// }

				const make = selectedMake.toUpperCase();
				const yearRestriction = restrict_nospoke_years[make];
				const isRestrictedByYear = yearRestriction && selectedYear <= yearRestriction;

				console.log('selected make:', make);
				console.log('selected year:', selectedYear);
				console.log('restricted by year:', isRestrictedByYear);

				// ✅ Append "No Sprocket" only if NOT restricted by model or year
				if (
				!restrict_nospoke.includes(selected_model) && 
				!isRestrictedByYear
				) {
				spokedom += `<option class="category" value="no">No Sprocket</option>`;
				}

				select.empty().append(spokedom);
				$('#sprocket').show();

			}else{
				var select = $('#sprocket_size');
				select.empty().append('<option value="no">No Sprocket</option>');
				$('#sprocket').hide();
			}
		}else{
			var select = $('#sprocket_size');
			select.empty().append('<option value="no">No Sprocket</option>');

			$('#sprocket').hide();
		}
		document.querySelector('#sprocket_size').dispatchEvent(new Event('change'));
	}

	$(document).on('change', 'select:not(#sprocket_size), input', function(){
		setTimeout(function(){
			setupSprocket();
		}, 100);
  	});

	var images = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/";
	var new_base_price = 410;
	var base_price = 410;
	var new_base_price = 410;
	var base_price = 410;
	var role = $(".custom-variant-wrapper").attr('data-role');
	var dealerprice = 304;
	var dealerprice = 304;
	if (role == "true") {
		$('#price').text('$' + dealerprice);
	}
	$("#bike_make").prop("selectedIndex", 0);

	var mbtireFrontOptions = {
		"Dunlop MX34  80/100-21": "Dunlop MX34  80/100-21",
        "DUNLOP MX34 80/100-21": "DUNLOP MX34 80/100-21",
        "TUSK EMEX T-35 80/100-21": "TUSK EMEX T-35 80/100-21",
        "DUNLOP GEOMAX AT82 80/100-21": "DUNLOP GEOMAX AT82 80/100-21",
        "SHINKO 241 21x275": "SHINKO 241 21x275"
	};
	var mbtireRearOptions18 = {
		"Dunlop MX34 100/100-18": "Dunlop MX34 100/100-18",
		"Dunlop MX34 110/100-18": "Dunlop MX34 110/100-18",
        "SHINKO 241 18x4.00": "SHINKO 241 18x4.00",
        "DUNLOP MX34 120/90-18": "DUNLOP MX34 120/90-18",
        "TUSK EMEX T-35 120/90-18": "TUSK EMEX T-35 120/90-18",
        "DUNLOP GEOMAX AT82 120/90-18": "DUNLOP GEOMAX AT82 120/90-18",
        "DUNLOP GEOMAX AT82 110/100-18": "DUNLOP GEOMAX AT82 110/100-18",
        "SHINKO E805 120/90-18": "SHINKO E805 120/90-18",
        "DUNLOP D606 120/90-18": "DUNLOP D606 120/90-18",
        "IRC VE-33 GEKKOTA 110/100-18": "IRC VE-33 GEKKOTA 110/100-18",
        "TUSK EMEX T-35 100/100-18": "TUSK EMEX T-35 100/100-18"
	};
	var mbtireRearOptions19 = {
		"Dunlop MX34 100/100-19": "Dunlop MX34 100/100-19",
		"Dunlop MX34 110/100-19": "Dunlop MX34 110/100-19",
		"Dunlop MX34 120/100-19": "Dunlop MX34 120/100-19",
        "DUNLOP MX34 100/90-19": "DUNLOP MX34 100/90-19",
        "DUNLOP MX34 110/90-19": "DUNLOP MX34 110/90-19",
        "DUNLOP MX34 120/80-19": "DUNLOP MX34 120/80-19",
        "TUSK EMEX T-35 100/90-19": "TUSK EMEX T-35 100/90-19",
        "TUSK EMEX T-35 110/90-19": "TUSK EMEX T-35 110/90-19",
        "TUSK EMEX T-35 120/80-19": "TUSK EMEX T-35 120/80-19",
        "DUNLOP GEOMAX AT82 120/90-19": "DUNLOP GEOMAX AT82 120/90-19",
        "DUNLOP GEOMAX AT82 110/90-19": "DUNLOP GEOMAX AT82 110/90-19",
        "SHINKO E804 100/90-19": "SHINKO E804 100/90-19"
	}
    var mbtireRearOptions17 = {
        "SHINKO E805 130/80-17": "SHINKO E805 130/80-17",
        "DUNLOP D606 130/90-17": "DUNLOP D606 130/90-17"
    }
	var ktm85FrontOptions = {
		"DUNLOP MX34 70/100-19": "DUNLOP MX34 70/100-19",
		"DUNLOP MX34 70/100-17": "DUNLOP MX34 70/100-17" 
	}
	var ktm85RearOptions = {
		"DUNLOP MX34 90/100-16": "DUNLOP MX34 90/100-16",
		"DUNLOP MX34 90/100-14": "DUNLOP MX34 90/100-14"
	}

	function applyEliteBlackRimOnly() {
		if ($('#rim_type').val() !== 'Elite') {
			return false;
		}

		var $rimColorSwatches = $('.rim_color_wrapper .color-swatch');
		if (!$rimColorSwatches.length) {
			$rimColorSwatches = $('.color-swatch');
		}

		$('.rim-type-wrap.powder-coat, .rim-type-wrap[data-category="powder-coat"]').hide().removeClass('active');
		$('.rim-type-wrap.anodized, .rim-type-wrap[data-category="anodized"]').show().addClass('active');

		$rimColorSwatches.removeClass('show active').hide();
		var $blackRim = $rimColorSwatches.filter('[data-category="anodized"][data-value="Black"]').first();
		if (!$blackRim.length) {
			$blackRim = $rimColorSwatches.filter('[data-value="Black"]').first();
		}

		$blackRim.addClass('show active').show();
		$('#rim_color').val('Black');
		return true;
	}

	function showColors(category) {
		// console.log(category)
		$('.color-swatch').removeClass('show');
		$('.color-swatch[data-category="' + category + '"]').addClass('show');
		$('.color-swatch[data-category="all"]').addClass('show');
		applyEliteBlackRimOnly();
	}

	showColors('anodized');


	function updateRimSizeOptions() {
		var selectedValue = $('#cush_drive').val();
		var is_disabled = $('#cush_drive').attr('disabled');
		if (selectedValue === 'Cush Drive' && $('#wheel_type').val() == "REAR" && is_disabled != "disabled") {
			$('#rim_size option').each(function () {
				if ($(this).val() !== 'REAR 18x2.15' && $(this).val() !== 'REAR 18x2.50'  && $(this).val() !== '18X2.50 (OEM SIZE)') {
					$(this).prop('disabled', true);
				} else {
					$(this).prop('disabled', false);
				}
			});
		} else {
			$('#rim_size option').prop('disabled', false);
		}
	}

	function updateCushDriveOption() {
		var selectedRim = $('#rim_size').val();
		var selectedBike = $('#bike_make').val();
		if (selectedBike !== 'Kove') {
			if (selectedRim !== 'REAR 18x2.15' && selectedRim !== 'REAR 18x2.50') {

				// $('#cush_drive option[value="Cush Drive"]').prop('disabled', true);
				$('#cush_drive').val('unavailable').change();
			} else {
				// $('#cush_drive option[value="Cush Drive"]').prop('disabled', false);
			}
		} else {
			// $('#cush_drive option[value="unavailable"]').prop('disabled', true);
			$('#cush_drive').val('Cush Drive').change();
		}
	}

	function updateRimType(){
		var select = $("#rim_type");
		var sizes = ["21x1.85", "18x2.50", "19x2.50", "19x3.00", "18X2.50 (OEM SIZE)", "REAR 17x2.50 (OEM Size)"];
		var selectedSize = $('#rim_size').val();
		var exists = sizes.some(size => selectedSize.includes(size));
		if(exists){
			select
			.empty()
			.append(
				'<option class="category" value="Elite">Elite</option>'
			).trigger('change');
		}else{
			select
			.empty()
			.append(
				'<option class="category" selected="selected" value="Standard">Standard</option><option class="category" value="Elite">Elite</option>'
			).trigger('change');
		}
	}

	// Disable/Enable rim_size options based on cush_drive selection
	$('#cush_drive').change(function () {
		updateRimSizeOptions();
	});

	// Disable/Enable Cush Drive based on rim_size selection
	$('#rim_size').change(function () {
		updateCushDriveOption();
		updateRimType();
	});
	$('#bike_model').change(function () {
		updateCushDriveOption();
	});

	$('#bike_make').change(function () {
		updateCushDriveOption();
		updateRimSizeOptions();
	});

	$('#wheel_type').change(function () {
		updateCushDriveOption();
		updateRimSizeOptions();
	});


	$('.rim-type-wrap').click(function () {
		$('.rim-type-wrap').removeClass('active');
		$(this).addClass('active');
		var category = $(this).attr('data-category');
		showColors(category);
			// >>>> ADD HERE <<<<
	limitToBlackForDR650(category);
		if (category == "anodized") {
			document.querySelector('#selected-rim-type-label').innerText = "Anodized"
		} else {
			document.querySelector('#selected-rim-type-label').innerText = "Powder coat"

		}
		$('.color-swatch[data-category="' + category + '"].show').eq(0).click();
	});

	//husqvarna = hq
	var hqf1 = 'CR 125 *FRONT*';
	var hqf2 = 'SM 125 *FRONT*';
	var hqf3 = 'TC125 *FRONT*';
	var hqf4 = 'TE 125 *FRONT*';
	var hqf5 = 'TX125 *FRONT*';
	var hqf6 = 'TXC 125 *FRONT*';
	var hqf7 = 'WR 125 *FRONT*';
	var hqf8 = 'TE150 *FRONT*';
	var hqf9 = 'FC 250 *FRONT*';
	var hqf10 = 'TC 250 *FRONT*';
	var hqf11 = 'FE 250 *FRONT*';
	var hqf12 = 'TE 250 *FRONT*';
	var hqf13 = 'TE250I *FRONT*';
	var hqf14 = 'SM 250 *FRONT*';
	var hqf15 = 'TXC 250 *FRONT*';
	var hqf16 = 'WR 250 *FRONT*';
	var hqf17 = 'CR 250 *FRONT*';
	var hqf18 = '2014 - 17 TE300 *FRONT*';
	var hqf19 = 'TE300I *FRONT*';
	var hqf20 = 'TX300 *FRONT*';
	var hqf21 = 'TX300i *FRONT*';
	var hqf22 = 'FC350 *FRONT*';
	var hqf23 = 'FE350 *FRONT*';
	var hqf24 = 'FX350 *FRONT*';
	var hqf25 = 'SM 449 *FRONT*';
	var hqf26 = 'TC 449 *FRONT*';
	var hqf27 = 'TE 449 *FRONT*';
	var hqf28 = 'TXC 449 *FRONT*';
	var hqf29 = 'WR 449 *FRONT*';
	var hqf30 = 'CR 449 *FRONT*';
	var hqf31 = 'CR 450 *FRONT*';
	var hqf32 = '2014 - 17 FC450 *FRONT*';
	var hqf33 = 'FC450 Rockstar Edition *FRONT*';
	var hqf34 = 'FE450 *FRONT*';
	var hqf35 = 'FX450 *FRONT*';
	var hqf36 = 'SM 450 *FRONT*';
	var hqf37 = 'TC 450 *FRONT*';
	var hqf38 = 'TE 450 *FRONT*';
	var hqf39 = 'TXC 450 *FRONT*';
	var hqf40 = 'WR 450 *FRONT*';
	var hqf41 = '2014 - 17 FE501 *FRONT*';
	var hqf42 = 'SM 510 *FRONT*';
	var hqf43 = 'TC 510 *FRONT*';
	var hqf44 = 'TE 510 *FRONT*';
	var hqf45 = 'TXC 510 *FRONT*';
	var hqf46 = 'WR 510 *FRONT*';
	var hqf47 = 'CR 510 *FRONT*';
	var hqf48 = 'SM 610 *FRONT*';
	var hqf49 = 'TC 610 *FRONT*';
	var hqf50 = 'TE 610 *FRONT*';
	var hqf51 = 'TXC 610 *FRONT*';
	var hqf52 = 'WR 610 *FRONT*';
	var hqf53 = 'CR 610 *FRONT*';
	var hqf54 = '701 Enduro ABS *FRONT*';
	var hqr1 = 'CR 125 *REAR*';
	var hqr2 = 'SM 125 *REAR*';
	var hqr3 = '2014 - 17 TC125 *REAR*';
	var hqr4 = 'TE 125 *REAR*';
	var hqr5 = 'TX125 *REAR*';
	var hqr6 = 'TXC 125 *REAR*';
	var hqr7 = 'WR 125 *REAR*';
	var hqr8 = 'TE150 *REAR*';
	var hqr9 = '2014 - 17 FC 250 *REAR*';
	var hqr10 = '2014 - 17 TC 250 *REAR*';
	var hqr11 = '2014 - 17 FE 250 *REAR*';
	var hqr12 = '2014 - 17 TE 250 *REAR*';
	var hqr13 = 'TE250I *REAR*';
	var hqr14 = 'SM 250 *REAR*';
	var hqr15 = 'TXC 250 *REAR*';
	var hqr16 = 'WR 250 *REAR*';
	var hqr17 = 'CR 250 *REAR*';
	var hqr18 = '2014 - 17 TE300 *REAR*';
	var hqr19 = 'TE300I *REAR*';
	var hqr20 = 'TX300 *REAR*';
	var hqr21 = 'TX300i *REAR*';
	var hqr22 = 'FC350 *REAR*';
	var hqr23 = 'FE350 *REAR*';
	var hqr24 = 'FX350 *REAR*';
	var hqr25 = 'SM 449 *REAR*';
	var hqr26 = 'TC 449 *REAR*';
	var hqr27 = 'TE 449 *REAR*';
	var hqr28 = 'TXC 449 *REAR*';
	var hqr29 = 'WR 449 *REAR*';
	var hqr30 = 'CR 449 *REAR*';
	var hqr31 = 'CR 450 *REAR*';
	var hqr32 = '2014 - 17 FC450 *REAR*';
	var hqr33 = 'FC450 Rockstar Edition *REAR*';
	var hqr34 = 'FE450 *REAR*';
	var hqr35 = 'FX450 *REAR*';
	var hqr36 = 'SM 450 *REAR*';
	var hqr37 = 'TC 450 *REAR*';
	var hqr38 = 'TE 450 *REAR*';
	var hqr39 = 'TXC 450 *REAR*';
	var hqr40 = 'WR 450 *REAR*';
	var hqr41 = '2014 - 17 FE501 *REAR*';
	var hqr42 = 'SM 510 *REAR*';
	var hqr43 = 'TC 510 *REAR*';
	var hqr44 = 'TE 510 *REAR*';
	var hqr45 = 'TXC 510 *REAR*';
	var hqr46 = 'WR 510 *REAR*';
	var hqr47 = 'CR 510 *REAR*';
	var hqr48 = 'SM 610 *REAR*';
	var hqr49 = 'TC 610 *REAR*';
	var hqr50 = 'TE 610 *REAR*';
	var hqr51 = 'TXC 610 *REAR*';
	var hqr52 = 'WR 610 *REAR*';
	var hqr53 = 'CR 610 *REAR*';
	var hqr54 = '701 Enduro ABS *REAR*';
	//honda = hn
	var hnf1 = '1995 - 99 CR125, CR250 *FRONT*';
	var hnf2 = '2000 - 11 CR125, CR250 *FRONT*';
	var hnf3 = '2017+ CRF250L *FRONT*';
	var hnf4 = 'CRF250L ABS *FRONT*';
	var hnf5 = '2017+ CRF250L Rally *FRONT*';
	var hnf6 = '2004 - 14 CRF250R *FRONT*';
	var hnf7 = '2004 - 2017 CRF250X *FRONT*';
	var hnf8 = 'CRF250RX *FRONT*';
	var hnf9 = '1996 - 04 XR400 *FRONT*';
	var hnf10 = '2002 - 14 CRF450R *FRONT*';
	var hnf11 = 'CRF450R Works Edition *FRONT*';
	var hnf12 = 'CRF450L *FRONT*';
	var hnf13 = '2003 - 2017 CRF450X *FRONT*';
	var hnf14 = '2017+  CRF450RX *FRONT*';
	var hnf15 = '1995 - 01 CR500 *FRONT*';
	var hnf16 = '1991 - 00 XR600 *FRONT*';
	var hnf17 = '1993 - 2017 XR650L *FRONT*';
	var hnf18 = '2000 - 08 XR650R *FRONT*';
	var hnf20 = 'CRF450RL *FRONT*';
	var hnr1 = '1989 - 97 CR125, CR250 *REAR*';
	var hnr2 = '2000 - 12 CR125, CR250 *REAR*';
	var hnr3 = '2017+ CRF250L *REAR*';
	var hnr4 = 'CRF250L ABS *REAR*';
	var hnr5 = '2017+ CRF250L Rally *REAR*';
	var hnr6 = '2004 - 13 CRF250R *REAR*';
	var hnr7 = '2004 - 2017 CRF250X *REAR*';
	var hnr8 = 'CRF250RX *REAR*';
	var hnr9 = '1996 - 04 XR 400 *REAR*';
	var hnr10 = '2002 - 12 CRF450R *REAR*';
	var hnr11 = 'CRF450R Works Edition *REAR*';
	var hnr12 = 'CRF450L *REAR*';
	var hnr20 = 'CRF450RL *REAR*';
	var hnr13 = '2002 - 2017 CRF450X *REAR*';
	var hnr14 = '2017+ CRF450RX *REAR*';
	var hnr15 = '1989 - 01 CR500 *REAR*';
	var hnr16 = '1993 - 00 XR600 *REAR*';
	var hnr17 = '1993 - 2017 XR650L *REAR*';
	var hnr18 = '2000 - 08 XR650R *REAR*';
	//ktm = ktm
	var ktmf1 = 'EXC125 *FRONT*';
	var ktmf2 = 'EXC200 *FRONT*';
	var ktmf3 = 'EXC-F250 *FRONT*';
	var ktmf4 = 'XCF-W250 *FRONT*';
	var ktmf5 = 'EXC300 *FRONT*';
	var ktmf6 = 'EXC350 *FRONT*';
	var ktmf7 = 'XC-W300 TPI *FRONT*';
	var ktmf8 = 'EXC-F350 *FRONT*';
	var ktmf9 = 'EXC380 *FRONT*';
	var ktmf10 = 'EXC400 *FRONT*';
	var ktmf11 = 'EXC450 *FRONT*';
	var ktmf12 = 'EXC-F450 *FRONT*';
	var ktmf13 = 'EXC-F500 *FRONT*';
	var ktmf14 = 'EXC520 *FRONT*';
	var ktmf15 = 'EXC525 *FRONT*';
	var ktmf16 = 'EXC530 *FRONT*';
	var ktmf17 = 'EXC-R530 *FRONT*';
	var ktmf18 = 'XC150 *FRONT*';
	var ktmf19 = 'XC-W150 *FRONT*';
	var ktmf20 = 'XC200 *FRONT*';
	var ktmf21 = 'XC-W200 *FRONT*';
	var ktmf22 = 'XC250 *FRONT*';
	var ktmf23 = 'XC250 TPI *FRONT*';
	var ktmf24 = 'XC-W250 *FRONT*';
	var ktmf25 = 'XC-W250 TPI *FRONT*';
	var ktmf26 = 'XC-F250 *FRONT*';
	var ktmf27 = 'XC300 *FRONT*';
	var ktmf28 = 'XC300 TPI *FRONT*';
	var ktmf29 = 'XC-W300 *FRONT*';
	var ktmf30 = 'XC-W300 TPI Six Days *FRONT*';
	var ktmf31 = 'XC-F350 *FRONT*';
	var ktmf32 = 'XCF-W350 *FRONT*';
	var ktmf33 = 'XC400 *FRONT*';
	var ktmf34 = 'XC-W400 *FRONT*';
	var ktmf35 = 'XC-F450 *FRONT*';
	var ktmf36 = 'XC450 *FRONT*';
	var ktmf37 = 'XC-W450 *FRONT*';
	var ktmf38 = 'XC-W500 *FRONT*';
	var ktmf39 = 'XC-F505 *FRONT*';
	var ktmf40 = 'XC525 *FRONT*';
	var ktmf41 = 'XC-W525 *FRONT*';
	var ktmf42 = 'XC530 *FRONT*';
	var ktmf43 = 'XC-W530 *FRONT*';
	var ktmf44 = 'SX125 *FRONT*';
	var ktmf45 = 'SX144 *FRONT*';
	var ktmf46 = 'SX150 *FRONT*';
	var ktmf47 = 'SX200 *FRONT*';
	var ktmf48 = 'SX250 *FRONT*';
	var ktmf49 = 'SXF250 *FRONT*';
	var ktmf50 = 'SXF350 *FRONT*';
	var ktmf51 = 'SX380 *FRONT*';
	var ktmf52 = 'SX400 *FRONT*';
	var ktmf53 = 'SXC400 *FRONT*';
	var ktmf54 = 'SX450 *FRONT*';
	var ktmf55 = 'SX-RFS450 *FRONT*';
	var ktmf56 = 'SX-F450 *FRONT*';
	var ktmf57 = 'SX-F450 Factory Edition *FRONT*';
	var ktmf58 = 'SX-F505 *FRONT*';
	var ktmf59 = 'SX520 *FRONT*';
	var ktmf60 = 'SX525 *FRONT*';
	var ktmf61 = 'SXC625 *FRONT*';
	var ktmf62 = '690 Enduro *FRONT*';
	var ktmf63 = '690 Enduro ABS *FRONT*';
	var ktmf64 = '790 Adventure *FRONT*';
	var ktmf65 = '790 Adventure R *FRONT*';
	var ktmf66 = '950 Adventure *FRONT*';
	var ktmf67 = '990 Adventure *FRONT*';
	var ktmf68 = '1090 Adventure *FRONT*';
	var ktmf69 = '1190 Adventure *FRONT*';
	var ktmf70 = '1290 Adventure ABS *FRONT*';
	var ktmf71 = '1290 Adventure R *FRONT*';
	var ktmf72 = '1290 Super Adventure S *FRONT*';
	var ktmf73 = '690 Enduro ABS *FRONT*';

	var ktmr1 = 'EXC125 *REAR*';
	var ktmr2 = 'EXC200 *REAR*';
	var ktmr3 = 'EXC-F250 *REAR*';
	var ktmr4 = 'XCF-W250 *REAR*';
	var ktmr5 = 'EXC300 *REAR*';
	var ktmr6 = 'EXC350 *REAR*';
	var ktmr7 = 'XC-W300 TPI *REAR*';
	var ktmr8 = 'EXC-F350 *REAR*';
	var ktmr9 = 'EXC380 *REAR*';
	var ktmr10 = 'EXC400 *REAR*';
	var ktmr11 = 'EXC450 *REAR*';
	var ktmr12 = 'EXC-F450 *REAR*';
	var ktmr13 = 'EXC-F500 *REAR*';
	var ktmr14 = 'EXC520 *REAR*';
	var ktmr15 = 'EXC525 *REAR*';
	var ktmr16 = 'EXC530 *REAR*';
	var ktmr17 = 'EXC530 *REAR*';
	var ktmr18 = 'EXC-R530 *REAR*';
	var ktmr19 = 'XC150 *REAR*';
	var ktmr20 = 'XC-W150 *REAR*';
	var ktmr21 = 'XC200 *REAR*';
	var ktmr22 = 'XC-W200 *REAR*';
	var ktmr23 = 'XC250 *REAR*';
	var ktmr24 = 'XC250 TPI *REAR*';
	var ktmr25 = 'XC-W250 *REAR*';
	var ktmr26 = 'XC-W250 TPI *REAR*';
	var ktmr27 = 'XC-F250 *REAR*';
	var ktmr28 = 'XC300 *REAR*';
	var ktmr29 = 'XC300 TPI *REAR*';
	var ktmr30 = 'XC-W300 *REAR*';
	var ktmr31 = 'XC-W300 TPI Six Days *REAR*';
	var ktmr32 = 'XC-F350 *REAR*';
	var ktmr33 = 'XCF-W350 *REAR*';
	var ktmr34 = 'XC400 *REAR*';
	var ktmr35 = 'XC-W400 *REAR*';
	var ktmr36 = 'XC-F450 *REAR*';
	var ktmr37 = 'XC450 *REAR*';
	var ktmr38 = 'XC-W450 *REAR*';
	var ktmr39 = 'XC-W500 *REAR*';
	var ktmr40 = 'XC-F505 *REAR*';
	var ktmr41 = 'XC525 *REAR*';
	var ktmr42 = 'XC-W525 *REAR*';
	var ktmr43 = 'XC530 *REAR*';
	var ktmr44 = 'XC-W530 *REAR*';
	var ktmr45 = 'SX125 *REAR*';
	var ktmr46 = 'SX144 *REAR*';
	var ktmr47 = 'SX150 *REAR*';
	var ktmr48 = 'SX200 *REAR*';
	var ktmr49 = 'SX250 *REAR*';
	var ktmr50 = 'SXF250 *REAR*';
	var ktmr51 = 'SXF350 *REAR*';
	var ktmr52 = 'SX380 *REAR*';
	var ktmr53 = 'SX400 *REAR*';
	var ktmr54 = 'SXC400 *REAR*';
	var ktmr55 = 'SX450 *REAR*';
	var ktmr56 = 'SX-RFS450 *REAR*';
	var ktmr57 = 'SX-F450 *REAR*';
	var ktmr58 = 'SX-F450 Factory Edition *REAR*';
	var ktmr59 = 'SX-F505 *REAR*';
	var ktmr60 = 'SX520 *REAR*';
	var ktmr61 = 'SX525 *REAR*';
	var ktmr62 = 'SXC625 *REAR*';
	var ktmr63 = '2008 – 2013 KTM 690 ENDURO * REAR *';
	var ktmr64 = '2014 – 2017 KTM 690 ENDURO ABS * REAR *';
	var ktmr65 = '790 Adventure *REAR*';
	var ktmr66 = '790 Adventure R *REAR*';
	var ktmr67 = '950 Adventure *REAR*';
	var ktmr68 = '990 Adventure *REAR*';
	var ktmr69 = '1090 Adventure *REAR*';
	var ktmr70 = '1190 Adventure *REAR*';
	var ktmr71 = '1290 Adventure ABS *REAR*';
	var ktmr72 = '1290 Adventure R *REAR*';
	var ktmr73 = '1290 Super Adventure S *REAR*';
	var ktmr74 = '2014 – 2017 KTM 690 ENDURO ABS * REAR *';

	//Sprocket Hide Function
	function sprockethide() {
		if ($('select#sprocket_size').val() == "no") {
			$('#resultAreaID_1_7').hide();
		} else {
			$('#resultAreaID_1_7').show();
		}
	}

	var magnet_change = function () {
		var magnet = $('select#sm_magnets').val();
		if (magnet != "NO") {
			$("#resultAreaID_1_7").addClass("show");
			var image_name = images + "magnet-" + $('select#sm_magnets').val() + '-' + $('select#wheel_type').val() + ".png";
			var imageArr6 = [image_name];
			var divArr6 = ["resultAreaID_1_7"];
			// imageObj6 = new BL_ImageLoader(divArr6,imageArr6);
			$('#resultAreaID_1_7 img').attr('src', image_name);
		} else if (magnet == "NO") {
			$("#resultAreaID_1_7").hide();
		} else {}
	}

	function nipplespokecolor() {
		if ($('select#bike_model').val() == "790 Adventure *FRONT*" || $('select#bike_model').val() == "790 Adventure R *FRONT*" || $('select#bike_model').val() == "890 Adventure *FRONT*" || $('select#bike_model').val() == "890 Adventure R *FRONT*" || $('select#bike_model').val() == "950 Adventure *FRONT*" || $('select#bike_model').val() == "990 Adventure *FRONT*" || $('select#bike_model').val() == "1090 Adventure *FRONT*" || $('select#bike_model').val() == "1190 Adventure *FRONT*" || $('select#bike_model').val() == "1290 Adventure ABS *FRONT*" || $('select#bike_model').val() == "1290 Adventure R *FRONT*" || $('select#bike_model').val() == "1290 Super Adventure S *FRONT*" || $('select#bike_model').val() == "790 Adventure *REAR*" || $('select#bike_model').val() == "790 Adventure R *REAR*" || $('select#bike_model').val() == "890 Adventure *REAR*" || $('select#bike_model').val() == "890 Adventure R *REAR*" || $('select#bike_model').val() == "950 Adventure *REAR*" || $('select#bike_model').val() == "990 Adventure *REAR*" || $('select#bike_model').val() == "1090 Adventure *REAR*" || $('select#bike_model').val() == "1190 Adventure *REAR*" || $('select#bike_model').val() == "1290 Adventure ABS *REAR*" || $('select#bike_model').val() == "1290 Adventure R *REAR*" || $('select#bike_model').val() == "1290 Super Adventure S *REAR*") {
			var spoke_color_wrapper = $('.spoke_color_wrapper');
			spoke_color_wrapper.empty().append(`<div class="color-swatch active" title="Silver" data-value="Silver" style="background: url(${images}silver.svg?v=1717478021);"></div><div class="color-swatch" title="Black" data-value="Black" style="background: url(${images}black.svg?v=1717478021);"></div>`);
			var image_name = images + "/spokes-" + $('#spoke_color').val() + "-" + $('select#wheel_type').val() + ".png";
			$('#resultAreaID_1_2 img').attr('src', image_name);
		}
		if ($('select#rim_size').val() == "REAR 19x3.00") {
			// var select = $('#spoke_color');
			// select.empty().append('<option value="Silver">Silver</option>');
			var rim_color_wrapper = $('.rim_color_wrapper');
			rim_color_wrapper.empty().append(`<div class="color-swatch active show"  title="Silver" data-category="anodized"  data-value="Silver" style="background: url(${images}silver.svg?v=1717478021);">`);
			var image_name = images + "spokes-" + $('#spoke_color').val() + "-" + $('select#wheel_type').val() + ".png";
			$('#resultAreaID_1_2 img').attr('src', image_name);
		}
	}

	//Nipple Color depends upon Spoke Color
	function nipplecolorreset() {
		if (($('select#bike_model').val() == "790 Adventure *FRONT*" || $('select#bike_model').val() == "790 Adventure R *FRONT*" || $('select#bike_model').val() == "890 Adventure *FRONT*" || $('select#bike_model').val() == "890 Adventure R *FRONT*" || $('select#bike_model').val() == "950 Adventure *FRONT*" || $('select#bike_model').val() == "990 Adventure *FRONT*" || $('select#bike_model').val() == "1090 Adventure *FRONT*" || $('select#bike_model').val() == "1190 Adventure *FRONT*" || $('select#bike_model').val() == "1290 Adventure ABS *FRONT*" || $('select#bike_model').val() == "1290 Adventure R *FRONT*" || $('select#bike_model').val() == "1290 Super Adventure S *FRONT*" || $('select#bike_model').val() == "790 Adventure *REAR*" || $('select#bike_model').val() == "790 Adventure R *REAR*" || $('select#bike_model').val() == "890 Adventure *REAR*" || $('select#bike_model').val() == "890 Adventure R *REAR*" || $('select#bike_model').val() == "950 Adventure *REAR*" || $('select#bike_model').val() == "990 Adventure *REAR*" || $('select#bike_model').val() == "1090 Adventure *REAR*" || $('select#bike_model').val() == "1190 Adventure *REAR*" || $('select#bike_model').val() == "1290 Adventure ABS *REAR*" || $('select#bike_model').val() == "1290 Adventure R *REAR*" || $('select#bike_model').val() == "1290 Super Adventure S *REAR*") || $('select#rim_size').val() == "REAR 19x3.00") {
			if ($('#spoke_color').val() == "Silver") {
				var nipple_color_wrapper = $('.nipple_color_wrapper');
				nipple_color_wrapper.empty().append(`<div class="color-swatch active" data-value="Silver" style="background: url(${images}silver.svg?v=1717478021);">`);
				var image_name = images + "nipple-" + $('#nipple_color').val() + "-" + $('select#wheel_type').val() + ".png";
				$('#resultAreaID_1_3 img').attr('src', image_name);
			} else {
				var select = $('#nipple_color');
				// select.empty().append('<option class="category" value="Silver">Silver</option><option class="category" value="Black">Black</option><option class="category" value="Red"></option><option class="category" value="Blue">Blue</option><option class="category" value="Orange">Orange</option><option class="category" value="Green">Green</option><option class="category" value="Gold">Gold</option><option class="category" value="Purple">Purple</option><option class="category" value="Magnesium">Magnesium</option>');
			}
		}
	}


	var spoketitanium = function () {
		//Titanium Spoke Color Code
		//Bike Make 

		var bike = $('select#bike_year').val();
		var bikemodel = $('select#bike_model').val();
		if ($('select#bike_make').val() == "Husqvarna") {
			if (bikemodel == hqf1 || bikemodel == hqf2 || bikemodel == hqf3 || bikemodel == hqf4 || bikemodel == hqf5 || bikemodel == hqf6 || bikemodel == hqf7 || bikemodel == hqf8 || bikemodel == hqf9 || bikemodel == hqf10 || bikemodel == hqf11 || bikemodel == hqf12 || bikemodel == hqf13 || bikemodel == hqf14 || bikemodel == hqf15 || bikemodel == hqf16 || bikemodel == hqf17 || bikemodel == hqf18 || bikemodel == hqf19 || bikemodel == hqf20 || bikemodel == hqf21 || bikemodel == hqf22 || bikemodel == hqf23 || bikemodel == hqf24 || bikemodel == hqf25 || bikemodel == hqf26 || bikemodel == hqf27 || bikemodel == hqf28 || bikemodel == hqf29 || bikemodel == hqf30 || bikemodel == hqf31 || bikemodel == hqf32 || bikemodel == hqf33 || bikemodel == hqf34 || bikemodel == hqf35 || bikemodel == hqf36 || bikemodel == hqf37 || bikemodel == hqf38 || bikemodel == hqf39 || bikemodel == hqf40 || bikemodel == hqf41 || bikemodel == hqr1 || bikemodel == hqr2 || bikemodel == hqr3 || bikemodel == hqr4 || bikemodel == hqr5 || bikemodel == hqr6 || bikemodel == hqr7 || bikemodel == hqr8 || bikemodel == hqr9 || bikemodel == hqr10 || bikemodel == hqr11 || bikemodel == hqr12 || bikemodel == hqr13 || bikemodel == hqr14 || bikemodel == hqr15 || bikemodel == hqr16 || bikemodel == hqr17 || bikemodel == hqr18 || bikemodel == hqr19 || bikemodel == hqr20 || bikemodel == hqr21 || bikemodel == hqr22 || bikemodel == hqr23 || bikemodel == hqr24 || bikemodel == hqr25 || bikemodel == hqr26 || bikemodel == hqr27 || bikemodel == hqr28 || bikemodel == hqr29 || bikemodel == hqr30 || bikemodel == hqr31 || bikemodel == hqr32 || bikemodel == hqr33 || bikemodel == hqr34 || bikemodel == hqr35 || bikemodel == hqr36 || bikemodel == hqr37 || bikemodel == hqr38 || bikemodel == hqr39 || bikemodel == hqr40 || bikemodel == hqr41) {
				if (bike >= 2014 & bike <= 2020) {
					if ($('select#rim_size').val() == "FRONT 21x1.60" || $('select#rim_size').val() == "REAR 18x2.15" || $('select#rim_size').val() == "REAR 19x2.15" || $('select#rim_size').val() == "REAR 18x2.50" || $('select#rim_size').val() == "REAR 19x2.50" || $('select#rim_size').val() == "18X2.50 (OEM SIZE)") {
						var select = $('.spoke_color_wrapper');
						select.empty().append(`<div class="color-swatch active" data-value="Silver" style="background: url(${images}silver.svg?v=1717478021);"></div><div class="color-swatch" data-value="Black" style="background: url(${images}black.svg?v=1717478021);"></div><div class="color-swatch" data-value="Blue" style="background: url(${images}blue.svg?v=1717478021);"></div><div class="color-swatch" data-value="Green" style="background: url(${images}green.svg?v=1717478021);"></div><div class="color-swatch" data-value="Orange" style="background: url(${images}orange.svg?v=1717478021);"></div><div class="color-swatch" data-value="Red" style="background: url(${images}red.svg?v=1717478021);"></div><div class="color-swatch" data-value="White" style="background: url(${images}white.svg?v=1717478021);"></div><div class="color-swatch" data-value="Yellow" style="background: Yellow;"></div><div class="color-swatch" data-value="Flo-Yellow" style="background: url(${images}flo-yellow.svg?v=1717478021);"></div><div class="color-swatch" data-value="Titanium" style="background: url(${images}titanium.svg?v=1717478021);"></div>`);
					} else if ($('select#rim_size').val() != "REAR 19x3.00") {
						var select = $('.spoke_color_wrapper');
						select.empty().append(`<div class="color-swatch active" data-value="Silver" style="background: url(${images}silver.svg?v=1717478021);">Silver</div><div class="color-swatch" data-value="Black" style="background: url(${images}black.svg?v=1717478021);">Black</div><div class="color-swatch" data-value="Blue" style="background: url(${images}blue.svg?v=1717478021);">Blue</div><div class="color-swatch" data-value="Green" style="background: url(${images}green.svg?v=1717478021);">Green</div><div class="color-swatch" data-value="Orange" style="background: url(${images}orange.svg?v=1717478021);">Orange</div><div class="color-swatch" data-value="Red" style="background: url(${images}red.svg?v=1717478021);"></div><div class="color-swatch" data-value="White" style="background: url(${images}white.svg?v=1717478021);">White</div><div class="color-swatch" data-value="Yellow" style="background: Yellow;">Yellow</div><div class="color-swatch" data-value="Flo-Yellow" style="background: url(${images}flo-yellow.svg?v=1717478021);">Flo Yellow</div>`);
					}
				}

			}

		} else if ($('select#bike_make').val() == "Honda" || $('select#bike_make').val() == "KTM" || $('select#bike_make').val() == "Kawasaki" || $('select#bike_make').val() == "Yamaha") {
			if (bikemodel == hnf1 || bikemodel == hnf2 || bikemodel == hnf6 || bikemodel == hnf7 || bikemodel == hnf8 || bikemodel == hnf9 || bikemodel == hnf10 || bikemodel == hnf11 || bikemodel == hnf12 || bikemodel == hnf20 || bikemodel == hnf13 || bikemodel == hnf14 || bikemodel == hnr1 || bikemodel == hnr2 || bikemodel == hnr6 || bikemodel == hnr7 || bikemodel == hnr8 || bikemodel == hnr9 || bikemodel == hnr10 || bikemodel == hnr11 || bikemodel == hnr12 || bikemodel == hnr13 || bikemodel == hnr14 || bikemodel == ktmf1 || bikemodel == ktmf2 || bikemodel == ktmf3 || bikemodel == ktmf4 || bikemodel == ktmf5 || bikemodel == ktmf6 || bikemodel == ktmf7 || bikemodel == ktmf8 || bikemodel == ktmf9 || bikemodel == ktmf10 || bikemodel == ktmf11 || bikemodel == ktmf12 || bikemodel == ktmf13 || bikemodel == ktmf14 || bikemodel == ktmf15 || bikemodel == ktmf16 || bikemodel == ktmf17 || bikemodel == ktmf18 || bikemodel == ktmf19 || bikemodel == ktmf20 || bikemodel == ktmf21 || bikemodel == ktmf22 || bikemodel == ktmf23 || bikemodel == ktmf24 || bikemodel == ktmf25 || bikemodel == ktmf26 || bikemodel == ktmf27 || bikemodel == ktmf28 || bikemodel == ktmf29 || bikemodel == ktmf30 || bikemodel == ktmf31 || bikemodel == ktmf32 || bikemodel == ktmf33 || bikemodel == ktmf34 || bikemodel == ktmf35 || bikemodel == ktmf36 || bikemodel == ktmf37 || bikemodel == ktmf38 || bikemodel == ktmf39 || bikemodel == ktmf40 || bikemodel == ktmf41 || bikemodel == ktmf42 || bikemodel == ktmf43 || bikemodel == ktmf44 || bikemodel == ktmf45 || bikemodel == ktmf46 || bikemodel == ktmf47 || bikemodel == ktmf48 || bikemodel == ktmf49 || bikemodel == ktmf50 || bikemodel == ktmf51 || bikemodel == ktmf52 || bikemodel == ktmf53 || bikemodel == ktmf54 || bikemodel == ktmf55 || bikemodel == ktmf56 || bikemodel == ktmf57 || bikemodel == ktmf58 || bikemodel == ktmf59 || bikemodel == ktmf60 || bikemodel == ktmr1 || bikemodel == ktmr2 || bikemodel == ktmr3 || bikemodel == ktmr4 || bikemodel == ktmr5 || bikemodel == ktmr6 || bikemodel == ktmr7 || bikemodel == ktmr8 || bikemodel == ktmr9 || bikemodel == ktmr10 || bikemodel == ktmr11 || bikemodel == ktmr12 || bikemodel == ktmr13 || bikemodel == ktmr14 || bikemodel == ktmr15 || bikemodel == ktmr16 || bikemodel == ktmr17 || bikemodel == ktmr18 || bikemodel == ktmr19 || bikemodel == ktmr20 || bikemodel == ktmr21 || bikemodel == ktmr22 || bikemodel == ktmr23 || bikemodel == ktmr24 || bikemodel == ktmr25 || bikemodel == ktmr26 || bikemodel == ktmr27 || bikemodel == ktmr28 || bikemodel == ktmr29 || bikemodel == ktmr30 || bikemodel == ktmr31 || bikemodel == ktmr32 || bikemodel == ktmr33 || bikemodel == ktmr34 || bikemodel == ktmr35 || bikemodel == ktmr36 || bikemodel == ktmr37 || bikemodel == ktmr38 || bikemodel == ktmr39 || bikemodel == ktmr40 || bikemodel == ktmr41 || bikemodel == ktmr42 || bikemodel == ktmr43 || bikemodel == ktmr44 || bikemodel == ktmr45 || bikemodel == ktmr46 || bikemodel == ktmr47 || bikemodel == ktmr48 || bikemodel == ktmr49 || bikemodel == ktmr50 || bikemodel == ktmr51 || bikemodel == ktmr52 || bikemodel == ktmr53 || bikemodel == ktmr54 || bikemodel == ktmr55 || bikemodel == ktmr56 || bikemodel == ktmr57 || bikemodel == ktmr58 || bikemodel == ktmr59 || bikemodel == ktmr60 || bikemodel == ktmr61 || bikemodel == "2003 - 05 KX125 *FRONT*" || bikemodel == "2003 - 13 KX250 *FRONT*" || bikemodel == "2004 - 14 KX250F  *FRONT*" || bikemodel == "KX250XC *FRONT*" || bikemodel == "2006 - 14 KX450F/KLX450R *FRONT*" || bikemodel == "KX450XC *FRONT*" || bikemodel == "KLX 300R *FRONT*" || bikemodel == "KLX450R *FRONT*" || bikemodel == "2003 - 06 KX125 *REAR*" || bikemodel == "2003 - 13 KX250 *REAR*" || bikemodel == "2004 - 17 KX250F  *REAR*" || bikemodel == "KX250XC *REAR*" || bikemodel == "2006 - 17 KX450F *REAR*" || bikemodel == "KX450XC *REAR*" || bikemodel == "KLX 300R *REAR*" || bikemodel == "2007 - 09 KLX450R *REAR*" || bikemodel == "WR250F *FRONT*" || bikemodel == "1999 - 2000 WR400 *FRONT*" || bikemodel == "WR450F *FRONT*" || bikemodel == "YZ125 *FRONT*" || bikemodel == "YZ125R *FRONT*" || bikemodel == "YZ250 *FRONT*" || bikemodel == "YZ250R *FRONT*" || bikemodel == "2001 - 13 YZ250F *FRONT*" || bikemodel == "2017+ YZ250FX *FRONT*" || bikemodel == "2017+ YZ250X *FRONT*" || bikemodel == "1999 YZ400F *FRONT*" || bikemodel == "2000 - 2013 YZ426F/YZ450F *FRONT*" || bikemodel == "2014 - 2015 YZ250F/YZ450F *FRONT*" || bikemodel == "2016 - 2017 YZ450FX *FRONT*" || bikemodel == "WR426 *FRONT*" || bikemodel == "2001 - 17 WR250F *REAR*" || bikemodel == "1999 - 02 WR400/WR426 *REAR*" || bikemodel == "1999 - 02 WR426 *REAR*" || bikemodel == "2003 - 17 WR450F *REAR*" || bikemodel == "1986 - 98 YZ125, YZ250 *REAR*" || bikemodel == "1999 - 2017 YZ125, YZ250 *REAR*" || bikemodel == "2009 - 17 YZ250F *REAR*" || bikemodel == "2015 - 2017 YZ250FX *REAR*" || bikemodel == "2016 - 2017 YZ250X *REAR*" || bikemodel == "1999 YZ400F *REAR*" || bikemodel == "2000 - 08 YZ426F *REAR*" || bikemodel == "2009 - 15 YZ450F *REAR*" || bikemodel == "2016 - 2017 YZ450FX *REAR*" || bikemodel == "WR426 *REAR*") {
				if ($('select#rim_size').val() == "FRONT 21x1.60" || $('select#rim_size').val() == "REAR 18x2.15" || $('select#rim_size').val() == "REAR 19x2.15" || $('select#rim_size').val() == "REAR 18x2.50" || $('select#rim_size').val() == "REAR 19x2.50" || $('select#rim_size').val() == "REAR 18x4.25\"") {
					var select = $('.spoke_color_wrapper');
					select.empty().append(`<div class="color-swatch active" data-value="Silver" style="background: url(${images}silver.svg?v=1717478021);"></div><div class="color-swatch" data-value="Black" style="background: url(${images}black.svg?v=1717478021);"></div><div class="color-swatch" data-value="Blue" style="background: url(${images}blue.svg?v=1717478021);"></div><div class="color-swatch" data-value="Green" style="background: url(${images}green.svg?v=1717478021);"></div><div class="color-swatch" data-value="Orange" style="background: url(${images}orange.svg?v=1717478021);"></div><div class="color-swatch" data-value="Red" style="background: url(${images}red.svg?v=1717478021);"></div><div class="color-swatch" data-value="White" style="background: url(${images}white.svg?v=1717478021);"></div><div class="color-swatch" data-value="Yellow" style="background: Yellow;"></div><div class="color-swatch" data-value="Flo-Yellow" style="background: url(${images}flo-yellow.svg?v=1717478021);"></div><div class="color-swatch" data-value="Titanium" style="background: url(${images}titanium.svg?v=1717478021);"></div>`);
				}
			}

		}
		//Titanium Spoke Color Code End
	}
	// bike-make JVL
	$(document).on("change", "select#bike_make", function () {
		// alert('asd')
		$("select#hidden_bike_model").empty();
		switch ($("select#bike_make").val()) {
			case "Husqvarna": //Husqvarna
				models = {
					// FRONT
					"TC 85 *FRONT*": "TC 85",
					"TC 125 *FRONT*": "TC 125",
					"TC 250 *FRONT*": "TC 250",
					"TC 300 *FRONT*": "TC 300",
					"TC 410 *FRONT*": "TC 410",
					"TC 450 *FRONT*": "TC 450",
					"TC 510 *FRONT*": "TC 510",

					"FC 250 *FRONT*": "FC 250",
					"FC 350 *FRONT*": "FC 350",
					"FC 450 *FRONT*": "FC 450",

					"TX 250 *FRONT*": "TX 250",
					"TX 300 *FRONT*": "TX 300",

					"TXC 250 *FRONT*": "TXC 250",
					"TXC 310 *FRONT*": "TXC 310",
					"TXC 450 *FRONT*": "TXC 450",
					"TXC 510 *FRONT*": "TXC 510",
					"TXC 511 *FRONT*": "TXC 511",

					"TE 125 *FRONT*": "TE 125",
					"TE 150 *FRONT*": "TE 150",
					"TE 250 *FRONT*": "TE 250",
					"TE 300 *FRONT*": "TE 300",
					"TE 410 *FRONT*": "TE 410",
					"TE 450 *FRONT*": "TE 450",
					"TE 510 *FRONT*": "TE 510",
					"TE 511 *FRONT*": "TE 511",

					"FE 250 *FRONT*": "FE 250",
					"FE 350 *FRONT*": "FE 350",
					"FE 450 *FRONT*": "FE 450",
					"FE 501 *FRONT*": "FE 501",

					"FX 350 *FRONT*": "FX 350",
					"FX 450 *FRONT*": "FX 450",

					"WR 250 *FRONT*": "WR 250",
					"WR 360 *FRONT*": "WR 360",

					"CR 125 *FRONT*": "CR 125",
					"CR 150 *FRONT*": "CR 150",
					"CR 250 *FRONT*": "CR 250",

					"WRE 125 *FRONT*": "WRE 125",
					
					"701 ENDURO ABS *FRONT*": "701 ENDURO ABS",

					"NORDEN 901 *FRONT*": "NORDEN 901",

					// REAR
					"TC 85 *REAR*": "TC 85",
					"TC 125 *REAR*": "TC 125",
					"TC 250 *REAR*": "TC 250",
					"TC 300 *REAR*": "TC 300",
					"TC 410 *REAR*": "TC 410",
					"TC 450 *REAR*": "TC 450",
					"TC 510 *REAR*": "TC 510",

					"FC 250 *REAR*": "FC 250",
					"FC 350 *REAR*": "FC 350",
					"FC 450 *REAR*": "FC 450",

					"TX 250 *REAR*": "TX 250",
					"TX 300 *REAR*": "TX 300",

					"TXC 250 *REAR*": "TXC 250",
					"TXC 310 *REAR*": "TXC 310",
					"TXC 450 *REAR*": "TXC 450",
					"TXC 510 *REAR*": "TXC 510",
					"TXC 511 *REAR*": "TXC 511",

					"TE 125 *REAR*": "TE 125",
					"TE 150 *REAR*": "TE 150",
					"TE 250 *REAR*": "TE 250",
					"TE 300 *REAR*": "TE 300",
					"TE 410 *REAR*": "TE 410",
					"TE 450 *REAR*": "TE 450",
					"TE 510 *REAR*": "TE 510",
					"TE 511 *REAR*": "TE 511",

					"FE 250 *REAR*": "FE 250",
					"FE 350 *REAR*": "FE 350",
					"FE 450 *REAR*": "FE 450",
					"FE 501 *REAR*": "FE 501",

					"FX 350 *REAR*": "FX 350",
					"FX 450 *REAR*": "FX 450",

					"WR 250 *REAR*": "WR 250",
					"WR 360 *REAR*": "WR 360",

					"CR 125 *REAR*": "CR 125",
					"CR 150 *REAR*": "CR 150",
					"CR 250 *REAR*": "CR 250",

					"WRE 125 *REAR*": "WRE 125",
					"701 ENDURO ABS *REAR*": "701 ENDURO ABS",

					"NORDEN 901 *REAR*": "NORDEN 901"
				};
				hub_colors = {
					Silver: "Silver",
					Black: "Black",
					Red: "Red",
					Blue: "Blue",
					Gold: "Gold",
					Green: "Green",
					Orange: "Orange",
					Purple: "Purple",
					Magnesium: "Magnesium",
				};
				rim_colors = {
					Black: "Black",
					"Matte-Black": "Matte Black",
					'Blue': 'Blue',
					'Baby-Blue': 'Baby-Blue',
					'Orange': 'Orange',
					'Nardo-Grey': 'Nardo-Grey',
					'Yellow': 'Yellow',
					'Flo-Yellow': 'Flo Yellow',
					'White': 'White',
				};
				spoke_colors = {
					Silver: "Silver",
					Black: "Black",
					Blue: "Blue",
					Green: "Green",
					Orange: "Orange",
					Red: "Red",
					White: "White",
					Yellow: "Yellow",
					"Flo-Yellow": "Flo Yellow",
					"Titanium": "Titanium",
					'Nardo-Gray': 'Nardo Grey'
				};
				nipple_colors = {
					Silver: "Silver",
					Black: "Black",
					Red: "Red",
					Blue: "Blue",
					Orange: "Orange",
					Green: "Green",
					Gold: "Gold",
					Purple: "Purple",
					Magnesium: "Magnesium",
				};
				rim_size = {
					'FRONT 21x1.85': 'FRONT 21x1.85',
					"FRONT 21x1.60": "FRONT 21x1.60",
					"FRONT 19x2.15": "FRONT 19x2.15",
					"FRONT 19x2.50": "FRONT 19x2.50",
				};
				brake_rotor = {
					Wave: "Wave OEM Size",
				};
				break;
			case "Honda": //Honda
				models = {
					"1995 - 99 CR125, CR250 *FRONT*": "CR125",
					"2000 - 11 CR125, CR250 *FRONT*": "CR250",
					"2017+ CRF250L *FRONT*": "CRF250L",
					"CRF250L ABS *FRONT*": "CRF250L ABS",
					"2017+ CRF250L Rally *FRONT*": "CRF250L Rally",
					"CRF250L RALLY ABS *FRONT*": "CRF250L RALLY ABS",
					"2004 - 14 CRF250R *FRONT*": "CRF250R",
					"2004 - 2017 CRF250X *FRONT*": "CRF250X",
					"CRF250RX *FRONT*": "CRF250RX",
					"CRF250F *FRONT*": "CRF250F",
					"CRF250RWE *FRONT*": "CRF250R WORKS EDITION",
					"CRF300L *FRONT*": "CRF300L",
					"CRF300L ABS *FRONT*": "CRF300L ABS",
					"CRF300L Rally *FRONT*": "CRF300L Rally",
					"CRF300L Rally ABS *FRONT*": "CRF300L Rally ABS",
					/* '1996 - 04 XR250 *FRONT*' : 'XR250 (No Odometer)', */
					"1996 - 04 XR400 *FRONT*": "XR400 (No Odometer)",
					"2002 - 14 CRF450R *FRONT*": "CRF450R",
					"CRF450R Works Edition *FRONT*": "CRF450R Works Edition",
					"CRF450L *FRONT*": "CRF450L /RL",
					// "CRF450RL *FRONT*": "CRF450RL",
					"2003 - 2017 CRF450X *FRONT*": "CRF450X",
					"2017+  CRF450RX *FRONT*": "CRF450RX",
					"1995 - 01 CR500 *FRONT*": "CR500",
					"1991 - 00 XR600 *FRONT*": "XR600",
					"XR600R *FRONT*": "XR600R",
					"1993 - 2017 XR650L *FRONT*": "XR650L",
					"2000 - 08 XR650R *FRONT*": "XR650R (No Odometer)",
					"XR250R *FRONT*": "XR250R (NO SPEEDO DRIVE HUB)",
					"XR400R *FRONT*": "XR400R",
					// "CRF450RWE *FRONT*": "CRF450RWE",

					"1989 - 97 CR125, CR250 *REAR*": "CR125",
					"2000 - 12 CR125, CR250 *REAR*": "CR250",
					"2017+ CRF250L *REAR*": "CRF250L",
					"CRF250L ABS *REAR*": "CRF250L ABS",
					"2017+ CRF250L Rally *REAR*": "CRF250L Rally",
					"CRF250L RALLY ABS *REAR*": "CRF250L RALLY ABS",
					"2004 - 13 CRF250R *REAR*": "CRF250R",
					"2004 - 2017 CRF250X *REAR*": "CRF250X",
					"CRF250RX *REAR*": "CRF250RX",
					"CRF250F *REAR*": "CRF250F",
					"CRF250RWE *REAR*": "CRF250R WORKS EDITION",
					"CRF300L *REAR*": "CRF300L",
					"CRF300L ABS *REAR*": "CRF300L ABS",
					"CRF300L Rally *REAR*": "CRF300L Rally",
					"CRF300L Rally ABS *REAR*": "CRF300L Rally ABS",
					/*  '1996 - 04 XR 250 *REAR*' : 'XR250', */
					"1996 - 04 XR 400 *REAR*": "XR400",
					"2002 - 12 CRF450R *REAR*": "CRF450R",
					"CRF450R Works Edition *REAR*": "CRF450R Works Edition",
					"CRF450L *REAR*": "CRF450L /RL",
					// "CRF450RL *REAR*": "CRF450RL",
					"2002 - 2017 CRF450X *REAR*": "CRF450X",
					"2017+ CRF450RX *REAR*": "CRF450RX",
					"1989 - 01 CR500 *REAR*": "CR500",
					"1993 - 00 XR600 *REAR*": "XR600",
					"XR600R *REAR*": "XR600R",
					"1993 - 2017 XR650L *REAR*": "XR650L",
					"2000 - 08 XR650R *REAR*": "XR650R",
					"XR250R *REAR*": "XR250R",
					"XR400R *REAR*": "XR400R",
					// "CRF450RWE *REAR*": "CRF450RWE",
				};
				hub_colors = {
					Silver: "Silver",
					Black: "Black",
					Red: "Red",
					Blue: "Blue",
					Gold: "Gold",
					Green: "Green",
					Orange: "Orange",
					Purple: "Purple",
					Magnesium: "Magnesium",
				};
				rim_colors = {
					Black: "Black",
					"Matte-Black": "Matte Black",
					'Blue': 'Blue',
					'Baby-Blue': 'Baby-Blue',
					'Orange': 'Orange',
					'Nardo-Grey': 'Nardo-Grey',
					'Yellow': 'Yellow',
					'Flo-Yellow': 'Flo Yellow',
					'White': 'White',
				};
				spoke_colors = {
					Silver: "Silver",
					Black: "Black",
					Blue: "Blue",
					Green: "Green",
					Orange: "Orange",
					Red: "Red",
					White: "White",
					Yellow: "Yellow",
					"Flo-Yellow": "Flo Yellow",
					"Titanium": "Titanium",
					'Nardo-Gray': 'Nardo Grey'
				};
				nipple_colors = {
					Silver: "Silver",
					Black: "Black",
					Red: "Red",
					Blue: "Blue",
					Orange: "Orange",
					Green: "Green",
					Gold: "Gold",
					Purple: "Purple",
					Magnesium: "Magnesium",
				};
				rim_size = {
					'FRONT 21x1.85': 'FRONT 21x1.85',
					"FRONT 21x1.60": "FRONT 21x1.60",
					"FRONT 19x2.15": "FRONT 19x2.15",
					"FRONT 19x2.50": "FRONT 19x2.50",
				};
				brake_rotor = {
					Wave: "Wave",
				};
				break;
			case "Yamaha": //Yamaha
				// models = {
				// 	// FRONT

				// 	"WR250F *FRONT*": "WR250F",
				// 	"2008 - 17 WR250R (street legal) *FRONT*": "WR250R (Street Legal)",
				// 	'2008 - 17 WR250X (street legal converts to 21") *FRONT*': "WR250X (Street Legal)",
				// 	"1999 - 2000 WR400 *FRONT*": "WR400",
				// 	"WR450F *FRONT*": "WR450F",
				// 	"YZ125 *FRONT*": "YZ125",
				// 	"YZ125R *FRONT*": "YZ125R",
				// 	"YZ250 *FRONT*": "YZ250",
				// 	"YZ250R *FRONT*": "YZ250R (Two Stroke)",
				// 	"2001 - 13 YZ250F *FRONT*": "YZ250F",
				// 	"2017+ YZ250FX *FRONT*": "YZ250FX",
				// 	"2017+ YZ250X *FRONT*": "YZ250X (Two Stroke)",

				// 	"2000 - 2013 YZ426F/YZ450F *FRONT*": "YZ426F",
				// 	"2014 - 2015 YZ250F/YZ450F *FRONT*": "YZ450F",
				// 	"2016 - 2017 YZ450FX *FRONT*": "YZ450FX",
				// 	"WR426 *FRONT*": "WR426",

				// 	// REAR

				// 	"2001 - 17 WR250F *REAR*": "WR250F",
				// 	"2008 - 17 WR250R (street legal) *REAR*": "WR250R (Street Legal)",
				// 	'2008 - 16 WR250X (street legal converts to 18") *REAR*': "WR250X (Street Legal)",
				// 	"1999 - 02 WR400/WR426 *REAR*": "WR400",
				// 	"1999 - 02 WR426 *REAR*": "WR426",
				// 	"2003 - 17 WR450F *REAR*": "WR450F",
				// 	"1986 - 98 YZ125, YZ250 *REAR*": "YZ125",
				// 	"1999 - 2017 YZ125, YZ250 *REAR*": " YZ250",
				// 	"2009 - 17 YZ250F *REAR*": "YZ250F",
				// 	"2015 - 2017 YZ250FX *REAR*": "YZ250FX",
				// 	"2016 - 2017 YZ250X *REAR*": "YZ250X",

				// 	"2000 - 08 YZ426F *REAR*": "YZ426F",
				// 	"2009 - 15 YZ450F *REAR*": "YZ450F",
				// 	"2016 - 2017 YZ450FX *REAR*": "YZ450FX",
				// 	"WR426 *REAR*": "WR426",
				// };
				models = {
					// -------------- FRONT

					// YZ 125
					"YZ125 *FRONT*": "YZ125",
					"YZ125 Monster Energy Yamaha Racing Edition *FRONT*": "YZ125 Monster Energy Yamaha Racing Edition",
					"YZ125 50th Anniversary Edition *FRONT*": "YZ125 50th Anniversary Edition",
					"YZ125 70th Anniversary Edition *FRONT*": "YZ125 70th Anniversary Edition",
					"YZ125X *FRONT*": "YZ125X",

					// YZ 250
					"YZ250 *FRONT*": "YZ250",
					"YZ250 Monster Energy Yamaha Racing Edition *FRONT*": "YZ250 Monster Energy Yamaha Racing Edition",
					"YZ250 50th Anniversary Edition *FRONT*": "YZ250 50th Anniversary Edition",
					"YZ250 70th Anniversary Edition *FRONT*": "YZ250 70th Anniversary Edition",

					// YZ 250F
					"YZ250F *FRONT*": "YZ250F",
					"YZ250F Monster Energy Yamaha Racing Edition *FRONT*": "YZ250F Monster Energy Yamaha Racing Edition",
					"YZ250F 50th Anniversary Edition *FRONT*": "YZ250F 50th Anniversary Edition",
					"YZ250F 70th Anniversary Edition *FRONT*": "YZ250F 70th Anniversary Edition",

					// YZ 250FX / YZ 250X
					"YZ250FX *FRONT*": "YZ250FX",
					"YZ250X *FRONT*": "YZ250X",

					// WR
					"WR250F *FRONT*": "WR250F",
					"WR250R *FRONT*": "WR250R",
					"WR250X *FRONT*": "WR250X (Street Legal)",

					// WR400
					"WR400 *FRONT*": "WR400",

					// WR426F
					"WR426 *FRONT*": "WR426",

					// YZ426F
					"YZ426 *FRONT*": "YZ426",

					// WR450F
					"WR450F *FRONT*": "WR450F",

					// YZ450F
					"YZ450F *FRONT*": "YZ450F",
					"YZ450F Monster Energy Yamaha Racing Edition *FRONT*": "YZ450F Monster Energy Yamaha Racing Edition",
					"YZ450F 50th Anniversary Edition *FRONT*": "YZ450F 50th Anniversary Edition",
					"YZ450F 70th Anniversary Edition *FRONT*": "YZ450F 70th Anniversary Edition",

					// YZ450FX
					"YZ450FX *FRONT*": "YZ450FX",


					// -------------- REAR

					// YZ 125
					"YZ 125 *REAR*": "YZ 125",
					"YZ125 Monster Energy Yamaha Racing Edition *REAR*": "YZ125 Monster Energy Yamaha Racing Edition",
					"YZ125 50th Anniversary Edition *REAR*": "YZ125 50th Anniversary Edition",
					"YZ125 70th Anniversary Edition *REAR*": "YZ125 70th Anniversary Edition",
					"YZ125X *REAR*": "YZ125X",

					// YZ 250
					"YZ250 *REAR*": "YZ250",
					"YZ250 Monster Energy Yamaha Racing Edition *REAR*": "YZ250 Monster Energy Yamaha Racing Edition",
					"YZ250 50th Anniversary Edition *REAR*": "YZ250 50th Anniversary Edition",
					"YZ250 70th Anniversary Edition *REAR*": "YZ250 70th Anniversary Edition",

					// YZ 250F
					"YZ250F *REAR*": "YZ250F",
					"YZ250F Monster Energy Yamaha Racing Edition *REAR*": "YZ250F Monster Energy Yamaha Racing Edition",
					"YZ250F 50th Anniversary Edition *REAR*": "YZ250F 50th Anniversary Edition",
					"YZ250F 70th Anniversary Edition *REAR*": "YZ250F 70th Anniversary Edition",

					// YZ 250FX / YZ 250X
					"YZ250FX *REAR*": "YZ250FX",
					"YZ250X *REAR*": "YZ250X",

					// WR
					"WR250F *REAR*": "WR250F",
					"WR250R *REAR*": "WR250R",
					"WR250X *REAR*": "WR250X (Street Legal)",

					// WR400
					"WR400 *REAR*": "WR400",

					// WR426F
					"WR426 *REAR*": "WR426",

					// YZ426F
					"YZ426 *REAR*": "YZ426",

					// WR450F
					"WR450F *REAR*": "WR450F",

					// YZ450F
					"YZ450F *REAR*": "YZ450F",
					"YZ450F Monster Energy Yamaha Racing Edition *REAR*": "YZ450F Monster Energy Yamaha Racing Edition",
					"YZ450F 50th Anniversary Edition *REAR*": "YZ450F 50th Anniversary Edition",
					"YZ450F 70th Anniversary Edition *REAR*": "YZ450F 70th Anniversary Edition",

					// YZ450FX
					"YZ450FX *REAR*": "YZ450FX",
				};
				hub_colors = {
					Silver: "Silver",
					Black: "Black",
					Red: "Red",
					Blue: "Blue",
					Gold: "Gold",
					Green: "Green",
					Orange: "Orange",
					Purple: "Purple",
					Magnesium: "Magnesium",
				};
				rim_colors = {
					Black: "Black",
					"Matte-Black": "Matte Black",
					'Blue': 'Blue',
					'Baby-Blue': 'Baby-Blue',
					'Orange': 'Orange',
					'Nardo-Grey': 'Nardo-Grey',
					'Yellow': 'Yellow',
					'Flo-Yellow': 'Flo Yellow',
					'White': 'White',
				};
				spoke_colors = {
					Silver: "Silver",
					Black: "Black",
					Blue: "Blue",

					Green: "Green",
					Orange: "Orange",
					Red: "Red",
					White: "White",
					Yellow: "Yellow",
					"Flo-Yellow": "Flo Yellow",
					"Titanium": "Titanium",
					'Nardo-Gray': 'Nardo Grey'
				};
				nipple_colors = {
					Silver: "Silver",
					Black: "Black",
					Red: "Red",
					Blue: "Blue",
					Orange: "Orange",
					Green: "Green",
					Gold: "Gold",
					Purple: "Purple",
					Magnesium: "Magnesium",
				};
				rim_size = {
					'FRONT 21x1.85': 'FRONT 21x1.85',
					"FRONT 21x1.60": "FRONT 21x1.60",
					"FRONT 19x2.15": "FRONT 19x2.15",
					"FRONT 19x2.50": "FRONT 19x2.50",
				};
				brake_rotor = {
					Wave: "Wave",
					"270MM_FLOATING": "270mm Floating",
				};
				break;
			case "Kawasaki": //Kawasaki
				models = {
					"2003 - 05 KX125 *FRONT*": "KX125",
					"2003 - 13 KX250 *FRONT*": "KX250",
					"2004 - 14 KX250F  *FRONT*": "KX250F ",
					"KX250XC *FRONT*": "KX250XC",
					"KLX 300R *FRONT*": "KLX 300R",
					"2000 - 07 KLX400 *FRONT*": "KLX400",
					"2006 - 14 KX450F/KLX450R *FRONT*": "KX450F",
					"KX450XC *FRONT*": "KX450XC",
					"KLX450R *FRONT*": "KLX450R",
					"1994 - 04 KX500 *FRONT*": "KX500",
					// "KLR650 *FRONT*": "KLR650",
					"KX250X *FRONT*": "KX250X",
					"KX450X *FRONT*": "KX450X",

					"2003 - 06 KX125 *REAR*": "KX125",
					"KDX 200 *REAR*": "KDX 200",
					"KDX 220 *REAR*": "KDX 220",
					"KDX 250 *REAR*": "KDX 250",
					"2003 - 13 KX250 *REAR*": "KX250",
					"2004 - 17 KX250F  *REAR*": "KX250F",
					"KX250XC *REAR*": "KX250XC",
					"KLX 300R *REAR*": "KLX 300R",
					"2000 - 07 KLX400 *REAR*": "KLX400",
					"2006 - 17 KX450F *REAR*": "KX450F",
					"KX450XC *REAR*": "KX450XC",
					"2007 - 09 KLX450R *REAR*": "KLX450R",
					"1990 - 04 KX500 *REAR*": "KX500",
					// "KLR650 *REAR*": "KLR650",
					"KDX200 *REAR*": "KDX200",
					"KDX220 *REAR*": "KDX220",
					"KDX250 *REAR*": "KDX250",
					"KX250X *REAR*": "KX250X",
					"KX450X *REAR*": "KX450X",
					"KLR650 Gen 1 *FRONT*": "KLR650 Gen 1",
					"KLR650 Gen 1 *REAR*": "KLR650 Gen 1",
					"KLR650 Gen 2 *FRONT*": "KLR650 Gen 2",
					"KLR650 Gen 2 *REAR*": "KLR650 Gen 2",
					"KLR650 Gen 3 *FRONT*": "KLR650 Gen 3",
					"KLR650 Gen 3 *REAR*": "KLR650 Gen 3",


				};
				hub_colors = {
					Silver: "Silver",
					Black: "Black",
					Red: "Red",
					Blue: "Blue",
					Gold: "Gold",
					Green: "Green",
					Orange: "Orange",
					Purple: "Purple",
					Magnesium: "Magnesium",
				};
				rim_colors = {
					Black: "Black",
					"Matte-Black": "Matte Black",
					'Blue': 'Blue',
					'Baby-Blue': 'Baby-Blue',
					'Orange': 'Orange',
					'Nardo-Grey': 'Nardo-Grey',
					'Yellow': 'Yellow',
					'Flo-Yellow': 'Flo Yellow',
					'White': 'White',
				};
				spoke_colors = {
					Silver: "Silver",
					Black: "Black",
					Blue: "Blue",
					Green: "Green",
					Orange: "Orange",
					Red: "Red",
					White: "White",
					Yellow: "Yellow",
					"Flo-Yellow": "Flo Yellow",
					"Titanium": "Titanium",
					'Nardo-Gray': 'Nardo Grey'
				};
				nipple_colors = {
					Silver: "Silver",
					Black: "Black",
					Red: "Red",
					Blue: "Blue",
					Orange: "Orange",
					Green: "Green",
					Gold: "Gold",
					Purple: "Purple",
					Magnesium: "Magnesium",
				};
				rim_size = {
					'FRONT 21x1.85': 'FRONT 21x1.85',
					"FRONT 21x1.60": "FRONT 21x1.60",
					"FRONT 19x2.15": "FRONT 19x2.15",
					"FRONT 19x2.50": "FRONT 19x2.50",
				};
				brake_rotor = {
					Wave: "Wave",
				};
				break;
			case "KTM": //KTM
				// models = {

				// 	"500 EXC *FRONT*": "500 EXC",
				// 	"500 EXC-F *FRONT*": "500 EXC-F",
				// 	"500 XCF-W *FRONT*": "500 XCF-W",
				// 	"500 XC-W *FRONT*": "500 XC-W",

				// 	"500 EXC *REAR*": "500 EXC",
				// 	"500 EXC-F *REAR*": "500 EXC-F",
				// 	"500 XCF-W *REAR*": "500 XCF-W",
				// 	"500 XC-W *REAR*": "500 XC-W",

				// 	"XC 125 *FRONT*": "XC 125",
				// 	"XC 125 *REAR*": "XC 125",
				// 	"EXC 150 *FRONT*": "EXC 150",
				// 	"EXC 150 *REAR*": "EXC 150",
				// 	"EXC 250 *FRONT*": "EXC 250",
				// 	"EXC 250 *REAR*": "EXC 250",
				// 	"EXC 250 Six Days *FRONT*": "EXC 250 Six Days",
				// 	"EXC 250 Six Days *REAR*": "EXC 250 Six Days",


				// 	"EXC125 *FRONT*": "125 EXC",
				// 	"EXC200 *FRONT*": "200 EXC",
				// 	"EXC-F250 *FRONT*": "EXC-F250",
				// 	"XCF-W250 *FRONT*": "250 XCF-W",
				// 	"EXC300 *FRONT*": "300 EXC",
				// 	"EXC 300 Six Days *FRONT*": "EXC 300 Six Days",
				// 	"EXC 300 Six Days *REAR*": "EXC 300 Six Days",

				// 	"EXC-F 350 Six Days *FRONT*": "EXC-F 350 Six Days",
				// 	"EXC-F 350 Six Days *REAR*": "EXC-F 350 Six Days",

				// 	"EXC-F 350 Erzbergrodeo *FRONT*": "EXC-F 350 Erzbergrodeo",
				// 	"EXC-F 350 Erzbergrodeo *REAR*": "EXC-F 350 Erzbergrodeo",

				// 	"SX-F 350 *FRONT*": "SX-F 350",
				// 	"SX-F 350 *REAR*": "SX-F 350",

				// 	"XC-F 350 *FRONT*": "XC-F 350",
				// 	"XC-F 350 *REAR*": "XC-F 350",

				// 	"EXC 400 *FRONT*": "EXC 400",
				// 	"EXC 400 *REAR*": "EXC 400",

				// 	"EXC-F 450 *FRONT*": "EXC-F 450",
				// 	"EXC-F 450 *REAR*": "EXC-F 450",

				// 	"EXC-F500 *FRONT*": "EXC-F500",
				// 	"EXC-F500 *REAR*": "EXC500",

				// 	"EXC-F500 Six Days *FRONT*": "EXC-F 500 Six Days",
				// 	"EXC-F500 Six Days *REAR*": "EXC-F 500 Six Days",

				// 	"EXC-F 500 Erzbergrodeo *FRONT*": "EXC-F 500 Erzbergrodeo",
				// 	"EXC-F 500 Erzbergrodeo *REAR*": "EXC-F 500 Erzbergrodeo",


				// 	"SX-F 450 *FRONT*": "SX-F 450",
				// 	"SX-F 450 *REAR*": "SX-F 450",

				// 	"EXC350 *FRONT*": "EXC350",
				// 	"XC-W300 TPI *FRONT*": "XC-W300 TPI",
				// 	"EXC-F350 *FRONT*": "350 EXC-F",
				// 	"EXC380 *FRONT*": "EXC380",
				// 	"EXC400 *FRONT*": "400 EXC",
				// 	"EXC450 *FRONT*": "450 EXC",
				// 	"EXC-F450 *FRONT*": "EXC-F450 Six Days",
				// 	"EXC-F500 *FRONT*": "EXC-F500",
				// 	"EXC520 *FRONT*": "EXC520",
				// 	"EXC525 *FRONT*": "EXC525",
				// 	"EXC530 *FRONT*": "EXC530",
				// 	"EXC-R530 *FRONT*": "EXC-R530",
				// 	"XC150 *FRONT*": "150 XC",
				// 	"XC-W150 *FRONT*": "150 XC-W",
				// 	"XC200 *FRONT*": "200 XC",
				// 	"XC-W200 *FRONT*": "200 XC-W",
				// 	"XC250 *FRONT*": "250 XC",
				// 	"XC250 TPI *FRONT*": "XC250 TPI",
				// 	"XC-W250 *FRONT*": "250 XC-W",
				// 	"XC-W250 TPI *FRONT*": "XC-W250 TPI",
				// 	"XC-F250 *FRONT*": "250 XC-F",
				// 	"XC300 *FRONT*": "300 XC",
				// 	"XC300 TPI *FRONT*": "XC300 TPI",
				// 	"XC-W300 *FRONT*": "300 XC-W",
				// 	"XC-W300 TPI Six Days *FRONT*": "XC-W300 TPI Six Days",
				// 	"XC-F350 *FRONT*": "350 XC-F",
				// 	"XCF-W350 *FRONT*": "350 XCF-W",
				// 	"XC400 *FRONT*": "XC400",
				// 	"XC-W400 *FRONT*": "XC-W400",
				// 	"XC-F450 *FRONT*": "450 XC-F",
				// 	"XC450 *FRONT*": "XC450",
				// 	"XC-W450 *FRONT*": "400 XC-W",
				// 	"XC-W500 *FRONT*": "XC-W500",
				// 	"XC-F505 *FRONT*": "XC-F505",
				// 	"XC525 *FRONT*": "XC525",
				// 	"XC-W525 *FRONT*": "XC-W525",
				// 	"XC530 *FRONT*": "XC530",
				// 	"XC-W530 *FRONT*": "XC-W530",
				// 	"SX 85 *FRONT*": "SX 85",
				// 	"SX 85 *REAR*": "SX 85",
				// 	"SX125 *FRONT*": "125 SX",
				// 	"SX144 *FRONT*": "144 SX",
				// 	"SX150 *FRONT*": "150 SX",
				// 	"SX200 *FRONT*": "200 SX",
				// 	"SX250 *FRONT*": "250 SX",
				// 	"SXF250 *FRONT*": "SXF250",
				// 	"SX-F 250 Factory Edition *FRONT*": "SX-F 250 Factory Edition",
				// 	"SX-F 250 Factory Edition *REAR*": "SX-F 250 Factory Edition",

				// 	"SXF350 *FRONT*": "SXF350",
				// 	"SX380 *FRONT*": "SX380",
				// 	"SX400 *FRONT*": "SX400",
				// 	"SXC400 *FRONT*": "SXC400",
				// 	"SX450 *FRONT*": "450 SX",
				// 	"SX-RFS450 *FRONT*": "SX-RFS450",
				// 	"SX-F450 *FRONT*": "450 SX-F",
				// 	"SX-F450 Factory Edition *FRONT*": "450 SX-F FACTORY EDITION",
				// 	"SX-F505 *FRONT*": "SX-F505",
				// 	"SX520 *FRONT*": "SX520",
				// 	"SX525 *FRONT*": "SX525",
				// 	"SXC625 *FRONT*": "SXC625",
				// 	"690 Enduro *FRONT*": "690 Enduro",
				// 	"690 Enduro ABS *FRONT*": "690 Enduro ABS",
				// 	"790 Adventure *FRONT*": "790 ADVENTURE",
				// 	"790 Adventure R *FRONT*": "790 Adventure R",
				// 	"790 Adventure R Rally *FRONT*": "790 Adventure R Rally",
					

				// 	"890 Adventure *FRONT*": "890 ADVENTURE",
				// 	"890 Adventure R *FRONT*": "890 Adventure R",
				// 	"890 Adventure R Rally *FRONT*": "890 Adventure R Rally",
				// 	"890 Adventure L *FRONT*": "890 Adventure L",
				// 	// 950 adventure
				// 	"950 Adventure *FRONT*": "950 ADVENTURE",
				// 	"950 Adventure S *FRONT*": "950 Adventure S",
				// 	// 990 adventure FRONT
				// 	"990 Adventure *FRONT*": "990 ADVENTURE",
				// 	"990 Adventure R *FRONT*": "990 Adventure R",
				// 	"990 Adventure Baja *FRONT*": "990 Adventure Baja",
				// 	"990 Adventure Dakar *FRONT*": "990 Adventure Dakar",
				// 	"1090 Adventure *FRONT*": "1090 Adventure",
				// 	"1090 Adventure R *FRONT*": "1090 Adventure R",
				// 	"1190 Adventure *FRONT*": "1190 ADVENTURE",
				// 	"1190 Adventure R *FRONT*": "1190 Adventure R",
				// 	"1290 Adventure ABS *FRONT*": "1290 ADVENTURE",
				// 	"1290 Super Adventure *FRONT*": "1290 Super Adventure",
				// 	"1290 Super Adventure R *FRONT*": "1290 Super Adventure R",
				// 	"1290 Super Adventure S *FRONT*": "1290 Super Adventure S",
				// 	"690 Enduro ABS *FRONT*": "690 Enduro ABS",

				// 	"EXC125 *REAR*": "125 EXC",
				// 	"EXC200 *REAR*": "200 EXC",
				// 	"EXC-F250 *REAR*": "EXC-F250",
				// 	"XCF-W250 *REAR*": "250 XCF-W",
				// 	"EXC300 *REAR*": "300 EXC",
				// 	"EXC350 *REAR*": "EXC350",
				// 	"XC-W300 TPI *REAR*": "XC-W300 TPI",
				// 	"EXC-F350 *REAR*": "350 EXC-F",
				// 	"EXC380 *REAR*": "EXC380",
				// 	"EXC400 *REAR*": "400 EXC",
				// 	"EXC450 *REAR*": "450 EXC",
				// 	"EXC-F450 *REAR*": "EXC-F450 Six Days",
				// 	"EXC-F500 *REAR*": "EXC500",
				// 	"EXC520 *REAR*": "EXC520",
				// 	"EXC525 *REAR*": "EXC525",
				// 	"EXC530 *REAR*": "EXC530",
				// 	"EXC-R530 *REAR*": "EXC-R530",
				// 	"XC150 *REAR*": "150 XC",
				// 	"XC-W150 *REAR*": "150 XC-W",
				// 	"XC200 *REAR*": "200 XC",
				// 	"XC-W200 *REAR*": "200 XC-W",
				// 	"XC250 *REAR*": "250 XC",
				// 	"XC250 TPI *REAR*": "XC250 TPI",
				// 	"XC-W250 *REAR*": "250 XC-W",
				// 	"XC-W250 TPI *REAR*": "XC-W250 TPI",
				// 	"XC-F250 *REAR*": "250 XC-F",
				// 	"XC300 *REAR*": "300 XC",
				// 	"XC300 TPI *REAR*": "XC300 TPI",
				// 	"XC-W300 *REAR*": "300 XC-W",
				// 	"XC-W300 TPI Six Days *REAR*": "XC-W300 TPI Six Days",
				// 	"XC-F350 *REAR*": "350 XC-F",
				// 	"XCF-W350 *REAR*": "350 XCF-W",
				// 	"XC400 *REAR*": "XC400",
				// 	"XC-W400 *REAR*": "XC-W400",
				// 	"XC-F450 *REAR*": "450 XC-F",
				// 	"XC450 *REAR*": "XC450",
				// 	"XC-W450 *REAR*": "400 XC-W",
				// 	"XC-W500 *REAR*": "XC-W500",
				// 	"XC-F505 *REAR*": "XC-F505",
				// 	"XC525 *REAR*": "XC525",
				// 	"XC-W525 *REAR*": "XC-W525",
				// 	"XC530 *REAR*": "XC530",
				// 	"XC-W530 *REAR*": "XC-W530",
				// 	"SX125 *REAR*": "125 SX",
				// 	"SX144 *REAR*": "144 SX",
				// 	"SX150 *REAR*": "150 SX",
				// 	"SX200 *REAR*": "200 SX",
				// 	"SX250 *REAR*": "250 SX",
				// 	"SXF250 *REAR*": "SXF250",
				// 	"SXF350 *REAR*": "SXF350",
				// 	"SX380 *REAR*": "SX380",
				// 	"SX400 *REAR*": "SX400",
				// 	"SXC400 *REAR*": "SXC400",
				// 	"SX450 *REAR*": "450 SX",
				// 	"SX-RFS450 *REAR*": "SX-RFS450",
				// 	"SX-F450 *REAR*": "450 SX-F",
				// 	"SX-F450 Factory Edition *REAR*": "450 SX-F FACTORY EDITION",
				// 	"SX-F505 *REAR*": "SX-F505",
				// 	"SX520 *REAR*": "SX520",
				// 	"SX525 *REAR*": "SX525",
				// 	"SXC625 *REAR*": "SXC625",
				// 	"2008 – 2013 KTM 690 ENDURO * REAR *": "690 Enduro",
				// 	"2014 – 2017 KTM 690 ENDURO ABS * REAR *": "690 Enduro ABS",
				// 	"790 Adventure *REAR*": "790 ADVENTURE",
				// 	"790 Adventure R *REAR*": "790 Adventure R",
				// 	"790 Adventure R Rally *REAR*": "790 Adventure R Rally",
				// 	"890 Adventure *REAR*": "890 ADVENTURE",
				// 	"890 Adventure R *REAR*": "890 Adventure R",
				// 	"890 Adventure R Rally *REAR*": "890 Adventure R Rally",
				// 	"890 Adventure L *REAR*": "890 Adventure L",
				// 	// 950 adventure REAR
				// 	"950 Adventure *REAR*": "950 ADVENTURE",
				// 	"950 Adventure S *REAR*": "950 Adventure S",
				// 	// 990 adventure REAR
				// 	"990 Adventure *REAR*": "990 ADVENTURE",
				// 	"990 Adventure R *REAR*": "990 Adventure R",
				// 	"990 Adventure Baja *REAR*": "990 Adventure Baja",
				// 	"990 Adventure Dakar *REAR*": "990 Adventure Dakar",
				// 	"1090 Adventure *REAR*": "1090 Adventure",
				// 	"1090 Adventure R *REAR*": "1090 Adventure R",
				// 	"1190 Adventure *REAR*": "1190 ADVENTURE",
				// 	"1190 Adventure R *REAR*": "1190 Adventure R",
				// 	"1290 Adventure ABS *REAR*": "1290 ADVENTURE",
				// 	"1290 Adventure R *REAR*": "1290 Adventure R",
				// 	"1290 Super Adventure *REAR*": "1290 Super Adventure",
				// 	"1290 Super Adventure R *REAR*": "1290 Super Adventure R",
				// 	"1290 Super Adventure S *REAR*": "1290 Super Adventure S",
				// 	"2014 – 2017 KTM 690 ENDURO ABS * REAR *": "690 Enduro ABS",
				// };
				models = {

					// -------------------------------------------------
					// ----------------------- FRONT --------------------
					// -------------------------------------------------

					// EXC 125
					"EXC125 *FRONT*": "125 EXC",

					// EXC 150
					"EXC 150 *FRONT*": "EXC 150",

					// EXC 200
					"EXC200 *FRONT*": "200 EXC",

					// EXC 250
					"EXC 250 *FRONT*": "EXC 250",

					// EXC 250 Six Days
					"EXC 250 Six Days *FRONT*": "EXC 250 Six Days",

					// EXC 300
					"EXC300 *FRONT*": "300 EXC",

					// EXC 300 Six Days
					"EXC 300 Six Days *FRONT*": "EXC 300 Six Days",

					// EXC 400
					"EXC 400 *FRONT*": "EXC 400",

					// EXC 520
					"EXC520 *FRONT*": "EXC520",

					// EXC-F 350
					"EXC-F350 *FRONT*": "350 EXC-F",

					// EXC-F 350 Erzbergrodeo
					"EXC-F 350 Erzbergrodeo *FRONT*": "EXC-F 350 Erzbergrodeo",

					// EXC-F 350 Six Days
					"EXC-F 350 Six Days *FRONT*": "EXC-F 350 Six Days",

					// EXC-F 450
					"EXC-F 450 *FRONT*": "EXC-F 450",

					// EXC-F 450 Six Days
					"EXC-F450 *FRONT*": "EXC-F450 Six Days",

					// EXC-F 500
					"EXC-F500 *FRONT*": "EXC-F500",

					// EXC-F 500 Erzbergrodeo
					"EXC-F 500 Erzbergrodeo *FRONT*": "EXC-F 500 Erzbergrodeo",

					// EXC-F 500 Six Days
					"EXC-F500 Six Days *FRONT*": "EXC-F 500 Six Days",

					// SMR 450  (NO EXISTE EN TU OBJETO → NO INCLUIDO)

					// SX 85
					"SX 85 *FRONT*": "SX 85",

					// SX 125
					"SX125 *FRONT*": "125 SX",

					// SX 150
					"SX150 *FRONT*": "150 SX",

					// SX 250
					"SX250 *FRONT*": "250 SX",

					// SX-F 250
					"SXF250 *FRONT*": "SXF250",

					// SX-F 250 Factory Edition
					"SX-F 250 Factory Edition *FRONT*": "SX-F 250 Factory Edition",

					// SX-F 350
					"SXF350 *FRONT*": "SXF350",

					// SX-F 450
					"SX-F450 *FRONT*": "450 SX-F",

					// SX-F 450 Factory Edition
					"SX-F450 Factory Edition *FRONT*": "450 SX-F FACTORY EDITION",

					// XC 125
					"XC 125 *FRONT*": "XC 125",

					// XC 150
					"XC150 *FRONT*": "150 XC",

					// XC 250
					"XC250 *FRONT*": "250 XC",

					// XC 300
					"XC300 *FRONT*": "300 XC",

					// XC-F 250
					"XC-F250 *FRONT*": "250 XC-F",

					// XC-F 350
					"XC-F350 *FRONT*": "350 XC-F",

					// XC-F 450
					"XC-F450 *FRONT*": "450 XC-F",

					// XC-W 150
					"XC-W150 *FRONT*": "150 XC-W",

					// XC-W 250
					"XC-W250 *FRONT*": "250 XC-W",

					// XC-W 300
					"XC-W300 *FRONT*": "300 XC-W",

					// 690 Enduro
					"690 Enduro *FRONT*": "690 Enduro",

					// 690 Enduro ABS
					"690 Enduro ABS *FRONT*": "690 Enduro ABS",

					// 790 Adventure
					"790 Adventure *FRONT*": "790 ADVENTURE",

					// 790 Adventure R
					"790 Adventure R *FRONT*": "790 Adventure R",

					// 790 Adventure R Rally
					"790 Adventure R Rally *FRONT*": "790 Adventure R Rally",

					// 890 Adventure
					"890 Adventure *FRONT*": "890 ADVENTURE",

					// 890 Adventure L
					"890 Adventure L *FRONT*": "890 Adventure L",

					// 890 Adventure R
					"890 Adventure R *FRONT*": "890 Adventure R",

					// 890 Adventure R Rally
					"890 Adventure R Rally *FRONT*": "890 Adventure R Rally",

					// 950 Adventure
					"950 Adventure *FRONT*": "950 ADVENTURE",

					// 950 Adventure S
					"950 Adventure S *FRONT*": "950 Adventure S",

					// 990 Adventure
					"990 Adventure *FRONT*": "990 ADVENTURE",

					// 990 Adventure Baja
					"990 Adventure Baja *FRONT*": "990 Adventure Baja",

					// 990 Adventure Dakar
					"990 Adventure Dakar *FRONT*": "990 Adventure Dakar",

					// 990 Adventure R
					"990 Adventure R *FRONT*": "990 Adventure R",

					// 1090 Adventure
					"1090 Adventure *FRONT*": "1090 Adventure",

					// 1090 Adventure R
					"1090 Adventure R *FRONT*": "1090 Adventure R",

					// 1190 Adventure
					"1190 Adventure *FRONT*": "1190 ADVENTURE",

					// 1190 Adventure R
					"1190 Adventure R *FRONT*": "1190 Adventure R",

					// 1290 Super Adventure
					"1290 Super Adventure *FRONT*": "1290 Super Adventure",

					// 1290 Super Adventure R
					"1290 Super Adventure R *FRONT*": "1290 Super Adventure R",


					// -------------------------------------------------
					// ----------------------- REAR ---------------------
					// -------------------------------------------------

					// EXC 125
					"EXC125 *REAR*": "125 EXC",

					// EXC 150
					"EXC 150 *REAR*": "EXC 150",

					// EXC 200
					"EXC200 *REAR*": "200 EXC",

					// EXC 250
					"EXC 250 *REAR*": "EXC 250",

					// EXC 250 Six Days
					"EXC 250 Six Days *REAR*": "EXC 250 Six Days",

					// EXC 300
					"EXC300 *REAR*": "300 EXC",

					// EXC 300 Six Days
					"EXC 300 Six Days *REAR*": "EXC 300 Six Days",

					// EXC 400
					"EXC 400 *REAR*": "EXC 400",

					// EXC 520
					"EXC520 *REAR*": "EXC520",

					// EXC-F 350
					"EXC-F350 *REAR*": "350 EXC-F",

					// EXC-F 350 Erzbergrodeo
					"EXC-F 350 Erzbergrodeo *REAR*": "EXC-F 350 Erzbergrodeo",

					// EXC-F 350 Six Days
					"EXC-F 350 Six Days *REAR*": "EXC-F 350 Six Days",

					// EXC-F 450
					"EXC-F 450 *REAR*": "EXC-F 450",

					// EXC-F 450 Six Days
					"EXC-F450 *REAR*": "EXC-F450 Six Days",

					// EXC-F 500
					"EXC-F500 *REAR*": "EXC500",

					// EXC-F 500 Erzbergrodeo
					"EXC-F 500 Erzbergrodeo *REAR*": "EXC-F 500 Erzbergrodeo",

					// EXC-F 500 Six Days
					"EXC-F500 Six Days *REAR*": "EXC-F 500 Six Days",

					// SX 85
					"SX 85 *REAR*": "SX 85",

					// SX 125
					"SX125 *REAR*": "125 SX",

					// SX 150
					"SX150 *REAR*": "150 SX",

					// SX 250
					"SX250 *REAR*": "250 SX",

					// SX-F 250
					"SXF250 *REAR*": "SXF250",

					// SX-F 250 Factory Edition
					"SX-F 250 Factory Edition *REAR*": "SX-F 250 Factory Edition",

					// SX-F 350
					"SXF350 *REAR*": "SXF350",

					// SX-F 450
					"SX-F450 *REAR*": "450 SX-F",

					// SX-F 450 Factory Edition
					"SX-F450 Factory Edition *REAR*": "450 SX-F FACTORY EDITION",

					// XC 125
					"XC 125 *REAR*": "XC 125",

					// XC 150
					"XC150 *REAR*": "150 XC",

					// XC 250
					"XC250 *REAR*": "250 XC",

					// XC 300
					"XC300 *REAR*": "300 XC",

					// XC-F 250
					"XC-F250 *REAR*": "250 XC-F",

					// XC-F 350
					"XC-F350 *REAR*": "350 XC-F",

					// XC-F 450
					"XC-F450 *REAR*": "450 XC-F",

					// XC-W 150
					"XC-W150 *REAR*": "150 XC-W",

					// XC-W 250
					"XC-W250 *REAR*": "250 XC-W",

					// XC-W 300
					"XC-W300 *REAR*": "300 XC-W",

					// 690 Enduro
					"2008 – 2013 KTM 690 ENDURO * REAR *": "690 Enduro",

					// 690 Enduro ABS
					"2014 – 2017 KTM 690 ENDURO ABS * REAR *": "690 Enduro ABS",

					// 790 Adventure
					"790 Adventure *REAR*": "790 ADVENTURE",

					// 790 Adventure R
					"790 Adventure R *REAR*": "790 Adventure R",

					// 790 Adventure R Rally
					"790 Adventure R Rally *REAR*": "790 Adventure R Rally",

					// 890 Adventure
					"890 Adventure *REAR*": "890 ADVENTURE",

					// 890 Adventure L
					"890 Adventure L *REAR*": "890 Adventure L",

					// 890 Adventure R
					"890 Adventure R *REAR*": "890 Adventure R",

					// 890 Adventure R Rally
					"890 Adventure R Rally *REAR*": "890 Adventure R Rally",

					// 950 Adventure
					"950 Adventure *REAR*": "950 ADVENTURE",

					// 950 Adventure S
					"950 Adventure S *REAR*": "950 Adventure S",

					// 990 Adventure
					"990 Adventure *REAR*": "990 ADVENTURE",

					// 990 Adventure Baja
					"990 Adventure Baja *REAR*": "990 Adventure Baja",

					// 990 Adventure Dakar
					"990 Adventure Dakar *REAR*": "990 Adventure Dakar",

					// 990 Adventure R
					"990 Adventure R *REAR*": "990 Adventure R",

					// 1090 Adventure
					"1090 Adventure *REAR*": "1090 Adventure",

					// 1090 Adventure R
					"1090 Adventure R *REAR*": "1090 Adventure R",

					// 1190 Adventure
					"1190 Adventure *REAR*": "1190 ADVENTURE",

					// 1190 Adventure R
					"1190 Adventure R *REAR*": "1190 Adventure R",

					// 1290 Super Adventure
					"1290 Super Adventure *REAR*": "1290 Super Adventure",

					// 1290 Super Adventure R
					"1290 Super Adventure R *REAR*": "1290 Super Adventure R",
				};
				hub_colors = {
					Silver: "Silver",
					Black: "Black",
					Red: "Red",
					Blue: "Blue",
					Gold: "Gold",
					Green: "Green",
					Orange: "Orange",
					Purple: "Purple",
					Magnesium: "Magnesium",
				};
				rim_colors = {
					Black: "Black",
					"Matte-Black": "Matte Black",
					'Blue': 'Blue',
					'Baby-Blue': 'Baby-Blue',
					'Orange': 'Orange',
					'Nardo-Grey': 'Nardo-Grey',
					'Yellow': 'Yellow',
					'Flo-Yellow': 'Flo Yellow',
					'White': 'White',
				};
				spoke_colors = {
					Silver: "Silver",
					Black: "Black",
					Blue: "Blue",
					Green: "Green",
					Orange: "Orange",
					Red: "Red",
					White: "White",
					Yellow: "Yellow",
					"Flo-Yellow": "Flo Yellow",
					"Titanium": "Titanium",
					'Nardo-Gray': 'Nardo Grey'
				};
				nipple_colors = {
					Silver: "Silver",
					Black: "Black",
					Red: "Red",
					Blue: "Blue",
					Orange: "Orange",
					Green: "Green",
					Gold: "Gold",
					Purple: "Purple",
					Magnesium: "Magnesium",
				};
				rim_size = {
					'FRONT 21x1.85': 'FRONT 21x1.85',
					"FRONT 21x1.60": "FRONT 21x1.60",
					"FRONT 19x2.15": "FRONT 19x2.15",
					"FRONT 19x2.50": "FRONT 19x2.50",
				};
				brake_rotor = {
					Wave: "Wave",
					"270MM_FLOATING": "270mm Floating",
				};
				break;
			case "Triumph": //Triumph
				models = {
					"TF250-X *FRONT*": "TF250-X",
					"TF250-RC *FRONT*": "TF250-RC",
					"TF250-X *REAR*": "TF250-X",
					"TF250-RC *REAR*": "TF250-RC",
					"TF250-E *FRONT*": "TF250-E",
					"TF250-E *REAR*": "TF250-E",
					"TF450-E *FRONT*": "TF450-E",
					"TF450-E *REAR*": "TF450-E",
					"TF450-RC *FRONT*": "TF450-RC",
					"TF450-RC *REAR*": "TF450-RC",
				};
				hub_colors = {
					Silver: "Silver",
					Black: "Black",
					Red: "Red",
					Blue: "Blue",
					Gold: "Gold",
					Green: "Green",
					Orange: "Orange",
					Purple: "Purple",
					Magnesium: "Magnesium",
				};
				rim_colors = {
					Black: "Black",
					"Matte-Black": "Matte Black",
					'Blue': 'Blue',
					'Baby-Blue': 'Baby-Blue',
					'Orange': 'Orange',
					'Nardo-Grey': 'Nardo-Grey',
					'Yellow': 'Yellow',
					'Flo-Yellow': 'Flo Yellow',
					'White': 'White',
				};
				spoke_colors = {
					Silver: "Silver",
					Black: "Black",
					Blue: "Blue",
					Green: "Green",
					Orange: "Orange",
					Red: "Red",
					White: "White",
					Yellow: "Yellow",
					"Flo-Yellow": "Flo Yellow",
					"Titanium": "Titanium",
					'Nardo-Gray': 'Nardo Grey'
				};
				nipple_colors = {
					Silver: "Silver",
					Black: "Black",
					Red: "Red",
					Blue: "Blue",
					Orange: "Orange",
					Green: "Green",
					Gold: "Gold",
					Purple: "Purple",
					Magnesium: "Magnesium",
				};
				rim_size = {
					'FRONT 21x1.85': 'FRONT 21x1.85',
					"FRONT 21x1.60": "FRONT 21x1.60",
					"FRONT 19x2.15": "FRONT 19x2.15",
					"FRONT 19x2.50": "FRONT 19x2.50",
				};
				brake_rotor = {
					Wave: "Wave",
					"270MM_FLOATING": "270mm Floating",
				};
				break;
			case "Suzuki": // SUZUKI
				models = {
					// FRONT
					"DRZ400 *FRONT*": "DRZ400",
					"DRZ400 SM *FRONT*": "DRZ400 SM",
					"2000 - 17 DRZ400 S *FRONT*": "DRZ400 S",
					"2000 - 17 DRZ400 SE *FRONT*": "DRZ400 SE",
					"2000 - 17 DRZ400 E *FRONT*": "DRZ400 E",
					// "1996 - 2017 DR650 *FRONT*": "DR650",
					"1996 - 07 RM125 *FRONT*": "RM125",
					"1996 - 2009 RM250 *FRONT*": "RM250",
					"2004 - 06 RMZ250 *FRONT*": "RMZ250",
					"RMX250 *FRONT*": "RMX250",
					"2017+ RMX450 *FRONT*": "RMX450",
					"2005 - 17 RMZ450 *FRONT*": "RMZ450",

					// REAR
					"DRZ400 *REAR*": "DRZ400",
					"DRZ400 SM *REAR*": "DRZ400 SM",
					"2000 - 17 DRZ400 S * REAR *": "DRZ400 S",
					"2000 - 17 DRZ400 SE * REAR *": "DRZ400 SE",
					"2000 - 17 DRZ400 E * REAR *": "DRZ400 E",
					// "1996 - 2017 DR650 * REAR *": "DR650",
					"1989 - 98 RM125 * REAR *": "RM125",
					"1989 - 98 RM250 * REAR *": "RM250",
					"2004 - 06 RMZ250 * REAR *": "RMZ250",
					"RMX250 *REAR*": "RMX250",
					"2017+ RMX450 * REAR *": "RMX450",
					"2005 - 17 RMZ450 * REAR *": "RMZ450",

					"DR650SE *FRONT*": "DR650SE",
					"DR650SE *REAR*": "DR650SE",
				};
				hub_colors = {
					Silver: "Silver",
					Black: "Black",
					Red: "Red",
					Blue: "Blue",
					Gold: "Gold",
					Green: "Green",
					Orange: "Orange",
					Purple: "Purple",
					Magnesium: "Magnesium",
				};
				rim_colors = {
					Black: "Black",
					"Matte-Black": "Matte Black",
					'Blue': 'Blue',
					'Baby-Blue': 'Baby-Blue',
					'Orange': 'Orange',
					'Nardo-Grey': 'Nardo-Grey',
					'Yellow': 'Yellow',
					'Flo-Yellow': 'Flo Yellow',
					'White': 'White',
				};
				spoke_colors = {
					Silver: "Silver",
					Black: "Black",
					Blue: "Blue",
					Green: "Green",
					Orange: "Orange",
					Red: "Red",
					White: "White",
					Yellow: "Yellow",
					"Flo-Yellow": "Flo Yellow",
					"Titanium": "Titanium",
					'Nardo-Gray': 'Nardo Grey'
				};
				nipple_colors = {
					Silver: "Silver",
					Black: "Black",
					Red: "Red",
					Blue: "Blue",
					Orange: "Orange",
					Green: "Green",
					Gold: "Gold",
					Purple: "Purple",
					Magnesium: "Magnesium",
				};
				rim_size = {
					'FRONT 21x1.85': 'FRONT 21x1.85',
					"FRONT 21x1.60": "FRONT 21x1.60",
					"FRONT 19x2.15": "FRONT 19x2.15",
					"FRONT 19x2.50": "FRONT 19x2.50",
				};
				brake_rotor = {
					Wave: "Wave",
				};
				break;
			case "Suzuki": // SUZUKI
				models = {
					"450 Rally *FRONT*": "450 Rally",
					"450 Rally ABS *FRONT*": "450 Rally ABS",

					"450 Rally *REAR*": "450 Rally",
					"450 Rally ABS *REAR*": "450 Rally ABS",

				}
				break;
			case "Husaberg": //Husaberg
				models = {
					// "2004 - 14 All FE/FC *FRONT*": "FC",
					// "FE *FRONT*": "FE",
					// "2004 - 14 All FE/FC *REAR*": "FC",
					// "FE *REAR*": "FE",

					"TE125 *FRONT*": "TE125",
					"TE125 *REAR*": "TE125",

					"FE250 *FRONT*": "FE250",
					"FE250 *REAR*": "FE250",

					"TE250 *FRONT*": "TE250",
					"TE250 *REAR*": "TE250",

					"TE300 *FRONT*": "TE300",
					"TE300 *REAR*": "TE300",

					"FE350 *FRONT*": "FE350",
					"FE350 *REAR*": "FE350",

					"FE390 *FRONT*": "FE390",
					"FE390 *REAR*": "FE390",

					"FC450 *FRONT*": "FC450",
					"FC450 *REAR*": "FC450",

					"FE450 *FRONT*": "FE450",
					"FE450 *REAR*": "FE450",

					"FE450e *FRONT*": "FE450e",
					"FE450e *REAR*": "FE450e",

					"FX450 *FRONT*": "FX450",
					"FX450 *REAR*": "FX450",

					"FE570 *FRONT*": "FE570",
					"FE570 *REAR*": "FE570",

					"FE650 *FRONT*": "FE650",
					"FE650 *REAR*": "FE650",

				};
				hub_colors = {
					Silver: "Silver",
					Black: "Black",
					Red: "Red",
					Blue: "Blue",
					Gold: "Gold",
					Green: "Green",
					Orange: "Orange",
					Purple: "Purple",
					Magnesium: "Magnesium",
				};
				rim_colors = {
					Black: "Black",
					"Matte-Black": "Matte Black",
					'Blue': 'Blue',
					'Baby-Blue': 'Baby-Blue',
					'Orange': 'Orange',
					'Nardo-Grey': 'Nardo-Grey',
					'Yellow': 'Yellow',
					'Flo-Yellow': 'Flo Yellow',
					'White': 'White',
				};
				spoke_colors = {
					Silver: "Silver",
					Black: "Black",
					Blue: "Blue",
					Green: "Green",
					Orange: "Orange",
					Red: "Red",
					White: "White",
					Yellow: "Yellow",
					"Flo-Yellow": "Flo Yellow",
					"Titanium": "Titanium",
					'Nardo-Gray': 'Nardo Grey'
				};
				nipple_colors = {
					Silver: "Silver",
					Black: "Black",
					Red: "Red",
					Blue: "Blue",
					Orange: "Orange",
					Green: "Green",
					Gold: "Gold",
					Purple: "Purple",
					Magnesium: "Magnesium",
				};
				rim_size = {
					'FRONT 21x1.85': 'FRONT 21x1.85',
					"FRONT 21x1.60": "FRONT 21x1.60",
					"FRONT 19x2.15": "FRONT 19x2.15",
					"FRONT 19x2.50": "FRONT 19x2.50",
				};
				brake_rotor = {
					Wave: "Wave",
				};
				break;
			case "GasGas": //Gas Gas
				models = {
					// FRONT

					"EC125 *FRONT*": "EC125",
					"EC200 *FRONT*": "EC200",
					"EC200 RANGER *FRONT*": "EC200 RANGER",
					"EC250 *FRONT*": "EC250",
					"EC250 SIX DAYS *FRONT*": "EC250 SIX DAYS",
					"EC250F *FRONT*": "EC250F",
					"EC300GP *FRONT*": "EC300GP",
					"EC300 *FRONT*": "EC300",
					"EC300 RANGER *FRONT*": "EC300 RANGER",
					"EC300 SIX DAYS *FRONT*": "EC300 SIX DAYS",
					"EC350F *FRONT*" : "EC350F",
					"EC450 *FRONT*": "EC450",
					"EC450F *FRONT*" : "EC450F",
					"EC500F *FRONT*" : "EC500F",
					"ES500 *FRONT*": "ES500",
					"ES700 *FRONT*": "ES700",
					"EX250 *FRONT*": "EX250",
					"EX250F *FRONT*": "EX250F",
					"EX300 *FRONT*": "EX300",
					"EX350F *FRONT*": "EX350F",
					"EX450F *FRONT*": "EX450F",
					"MC125 *FRONT*": "MC125",
					"MC250 *FRONT*": "MC250",
					"MC250F *FRONT*": "MC250F",
					"MC350F *FRONT*": "MC350F",
					"MC450F *FRONT*": "MC450F",
					"MC85 *FRONT*": "MC85",
					
					// "Gas XC200 *FRONT*": "200 XC",
					// "Gas XC250 *FRONT*": "XC250",
					// "Gas XC300 *FRONT*": "XC300",					

					// REAR

					"EC125 *REAR*": "EC125",
					"EC200 *REAR*": "EC200",
					"EC200 RANGER *REAR*": "EC200 RANGER",
					"EC250 *REAR*": "EC250",
					"EC250 SIX DAYS *REAR*": "EC250 SIX DAYS",
					"EC250F *REAR*": "EC250F",
					"EC300GP *REAR*": "EC300GP",
					"EC300 *REAR*": "EC300",
					"EC300 RANGER *REAR*": "EC300 RANGER",
					"EC300 SIX DAYS *REAR*": "EC300 SIX DAYS",
					"EC350F *REAR*" : "EC350F",
					"EC450 *REAR*": "EC450",
					"EC450F *REAR*" : "EC450F",
					"EC500F *REAR*" : "EC500F",
					"ES500 *REAR*": "ES500",
					"ES700 *REAR*": "ES700",
					"EX250 *REAR*": "EX250",
					"EX250F *REAR*": "EX250F",
					"EX300 *REAR*": "EX300",
					"EX350F *REAR*": "EX350F",
					"EX450F *REAR*": "EX450F",
					"MC125 *REAR*": "MC125",
					"MC250 *REAR*": "MC250",
					"MC250F *REAR*": "MC250F",
					"MC350F *REAR*": "MC350F",
					"MC450F *REAR*": "MC450F",
					"MC85 *REAR*": "MC85",
					
					// "Gas XC200 *REAR*": "200 XC",
					// "Gas XC250 *REAR*": "XC250",
					// "Gas XC300 *REAR*": "XC300",

				};
				hub_colors = {
					Silver: "Silver",
					Black: "Black",
					Red: "Red",
					Blue: "Blue",
					Gold: "Gold",
					Green: "Green",
					Orange: "Orange",
					Purple: "Purple",
					Magnesium: "Magnesium",
				};
				rim_colors = {
					Black: "Black",
					"Matte-Black": "Matte Black",
					'Blue': 'Blue',
					'Baby-Blue': 'Baby-Blue',
					'Orange': 'Orange',
					'Nardo-Grey': 'Nardo-Grey',
					'Yellow': 'Yellow',
					'Flo-Yellow': 'Flo Yellow',
					'White': 'White',
				};
				spoke_colors = {
					Silver: "Silver",
					Black: "Black",
					Blue: "Blue",
					Green: "Green",
					Orange: "Orange",
					Red: "Red",
					White: "White",
					Yellow: "Yellow",
					"Flo-Yellow": "Flo Yellow",
					"Titanium": "Titanium",
					'Nardo-Gray': 'Nardo Grey'
				};
				nipple_colors = {
					Silver: "Silver",
					Black: "Black",
					Red: "Red",
					Blue: "Blue",
					Orange: "Orange",
					Green: "Green",
					Gold: "Gold",
					Purple: "Purple",
					Magnesium: "Magnesium",
				};
				rim_size = {
					'FRONT 21x1.85': 'FRONT 21x1.85',
					"FRONT 21x1.60": "FRONT 21x1.60",
					"FRONT 19x2.15": "FRONT 19x2.15",
					"FRONT 19x2.50": "FRONT 19x2.50",
				};
				brake_rotor = {
					Wave: "Wave",
				};
				break;

			case "BMW": //BMW
				models = {
					"2009 - 11 450X *FRONT*": "450X",
					"2009 - 11 450X *REAR*": "450X",
				};
				hub_colors = {
					Silver: "Silver",
					Black: "Black",
					Red: "Red",
					Blue: "Blue",
					Gold: "Gold",
					Green: "Green",
					Orange: "Orange",
					Purple: "Purple",
					Magnesium: "Magnesium",
				};
				rim_colors = {
					Black: "Black",
					"Matte-Black": "Matte Black",
					'Blue': 'Blue',
					'Baby-Blue': 'Baby-Blue',
					'Orange': 'Orange',
					'Nardo-Grey': 'Nardo-Grey',
					'Yellow': 'Yellow',
					'Flo-Yellow': 'Flo Yellow',
					'White': 'White',
				};
				spoke_colors = {
					Silver: "Silver",
					Black: "Black",
					Blue: "Blue",
					Green: "Green",
					Orange: "Orange",
					Red: "Red",
					White: "White",
					Yellow: "Yellow",
					"Flo-Yellow": "Flo Yellow",
					"Titanium": "Titanium",
					'Nardo-Gray': 'Nardo Grey'
				};
				nipple_colors = {
					Silver: "Silver",
					Black: "Black",
					Red: "Red",
					Blue: "Blue",
					Orange: "Orange",
					Green: "Green",
					Gold: "Gold",
					Purple: "Purple",
					Magnesium: "Magnesium",
				};
				rim_size = {
					'FRONT 21x1.85': 'FRONT 21x1.85',
					"FRONT 21x1.60": "FRONT 21x1.60",
					"FRONT 19x2.15": "FRONT 19x2.15",
					"FRONT 19x2.50": "FRONT 19x2.50",
				};
				brake_rotor = {
					Wave: "Wave",
				};
				break;

			case "Beta": //Beta
				models = {
					//Front
					"125 RR *FRONT*": "125 RR",
					"200 RR *FRONT*": "200 RR",
					"250 RR *FRONT*": "250 RR",
					"250 RX *FRONT*": "250 RX",
					"300 RR *FRONT*": "300 RR",
					"300 X-TRAINER *FRONT*": "300 X-TRAINER (must use OEM front wheel spacers)",
					"350 RR *FRONT*": "350 RR",
					"350 RR-S *FRONT*": "350 RR-S",
					"350 RX *FRONT*": "350 RX",
					"390 RR *FRONT*": "390 RR",
					"390 RR-S *FRONT*": "390 RR-S",
					"400 RR *FRONT*": "400 RR",
					"400 RR-S *FRONT*": "400 RR-S",
					"430 RR *FRONT*": "430 RR",
					"430 RR-S *FRONT*": "430 RR-S",
					"450 RR *FRONT*": "450 RR",
					"450 RR-S *FRONT*": "450 RR-S",
					"450 RX *FRONT*": "450 RX",
					"480 RR *FRONT*": "480 RR",
					"498 RR *FRONT*": "498 RR",
					"498 RR-S *FRONT*": "498 RR-S",
					"500 RR-S *FRONT*": "500 RR-S",
					"RS *FRONT*": "RS",

					// Rear
					"125 RR *REAR*": "125 RR",
					"200 RR *REAR*": "200 RR",
					"250 RR *REAR*": "250 RR",
					"250 RX *REAR*": "250 RX",
					"300 RR *REAR*": "300 RR",
					"300 X-TRAINER *REAR*": "300 X-TRAINER",
					"350 RR *REAR*": "350 RR",
					"350 RR-S *REAR*": "350 RR-S",
					"350 RX *REAR*": "350 RX",
					"390 RR *REAR*": "390 RR",
					"390 RR-S *REAR*": "390 RR-S",
					"400 RR *REAR*": "400 RR",
					"400 RR-S *REAR*": "400 RR-S",
					"430 RR *REAR*": "430 RR",
					"430 RR-S *REAR*": "430 RR-S",
					"450 RR *REAR*": "450 RR",
					"450 RR-S *REAR*": "450 RR-S",
					"450 RX *REAR*": "450 RX",
					"480 RR *REAR*": "480 RR",
					"498 RR *REAR*": "498 RR",
					"498 RR-S *REAR*": "498 RR-S",
					"500 RR-S *REAR*": "500 RR-S",
					"RS *REAR*": "RS",
				};
				hub_colors = {
					Silver: "Silver",
					Black: "Black",
					Red: "Red",
					Blue: "Blue",
					Gold: "Gold",
					Green: "Green",
					Orange: "Orange",
					Purple: "Purple",
					Magnesium: "Magnesium",
				};
				rim_colors = {
					Black: "Black",
					"Matte-Black": "Matte Black",
					'Blue': 'Blue',
					'Baby-Blue': 'Baby-Blue',
					'Orange': 'Orange',
					'Nardo-Grey': 'Nardo-Grey',
					'Yellow': 'Yellow',
					'Flo-Yellow': 'Flo Yellow',
					'White': 'White',
				};
				spoke_colors = {
					Silver: "Silver",
					Black: "Black",
					Blue: "Blue",
					Green: "Green",
					Orange: "Orange",
					Red: "Red",
					White: "White",
					Yellow: "Yellow",
					"Flo-Yellow": "Flo Yellow",
					"Titanium": "Titanium",
					'Nardo-Gray': 'Nardo Grey'
				};
				nipple_colors = {
					Silver: "Silver",
					Black: "Black",
					Red: "Red",
					Blue: "Blue",
					Orange: "Orange",
					Green: "Green",
					Gold: "Gold",
					Purple: "Purple",
					Magnesium: "Magnesium",
				};
				rim_size = {
					'FRONT 21x1.85': 'FRONT 21x1.85',
					"FRONT 21x1.60": "FRONT 21x1.60",
					"FRONT 19x2.15": "FRONT 19x2.15",
					"FRONT 19x2.50": "FRONT 19x2.50",
				};
				brake_rotor = {
					Wave: "Wave",
				};
				break;

			case "TM": //TM
				models = {
					"2008 - 2017 MX 125-530 (will not fit SM) *FRONT": "MX",
					"2008 - 2017 EN 125-530 (will not fit SM) *FRONT": "EN",

					"2008 - 2017 MX 125-530 (will not fit SM) * REAR *": "MX",
					"2008 - 2017 EN 125-530 (will not fit SM) * REAR *": "EN",
				};
				hub_colors = {
					Silver: "Silver",
					Black: "Black",
					Red: "Red",
					Blue: "Blue",
					Gold: "Gold",
					Green: "Green",
					Orange: "Orange",
					Purple: "Purple",
					Magnesium: "Magnesium",
				};
				rim_colors = {
					Black: "Black",
					"Matte-Black": "Matte Black",
					'Blue': 'Blue',
					'Baby-Blue': 'Baby-Blue',
					'Orange': 'Orange',
					'Nardo-Grey': 'Nardo-Grey',
					'Yellow': 'Yellow',
					'Flo-Yellow': 'Flo Yellow',
					'White': 'White',
				};
				spoke_colors = {
					Silver: "Silver",
					Black: "Black",
					Blue: "Blue",
					Green: "Green",
					Orange: "Orange",
					Red: "Red",
					White: "White",
					Yellow: "Yellow",
					"Flo-Yellow": "Flo Yellow",
					"Titanium": "Titanium",
					'Nardo-Gray': 'Nardo Grey'
				};
				nipple_colors = {
					Silver: "Silver",
					Black: "Black",
					Red: "Red",
					Blue: "Blue",
					Orange: "Orange",
					Green: "Green",
					Gold: "Gold",
					Purple: "Purple",
					Magnesium: "Magnesium",
				};
				rim_size = {
					'FRONT 21x1.85': 'FRONT 21x1.85',
					"FRONT 21x1.60": "FRONT 21x1.60",
					"FRONT 19x2.15": "FRONT 19x2.15",
					"FRONT 19x2.50": "FRONT 19x2.50",
				};
				brake_rotor = {
					Wave: "Wave",
					"270MM_FLOATING": "270mm Floating",
				};
				break;
			case "Sherco": //Sherco
				models = {
					// "2008 - 2017 125-300 SE-R *FRONT": "SE",
					// "2008 - 2017 250-450 SEF-R *FRONT": "SEF",
					// "2008 - 2017 250-450 SER *FRONT": "SER",

					// "2008 - 2017 125-300 SE-R * REAR *": "SE",
					// "2008 - 2017 250-450 SEF-R * REAR *": "SEF",
					// "2008 - 2017 250-450 SER * REAR *": "SER",

					"SE 125 *FRONT*": "SE 125",
					"SE 125 *REAR*": "SE 125",

					"SE 125 Factory *FRONT*": "SE 125 Factory",
					"SE 125 Factory *REAR*": "SE 125 Factory",

					"SE 125 Racing *FRONT*": "SE 125 Racing",
					"SE 125 Racing *REAR*": "SE 125 Racing",

					"SEF 125 *FRONT*": "SEF 125",
					"SEF 125 *REAR*": "SEF 125",

					"SE 250 *FRONT*": "SE 250",
					"SE 250 *REAR*": "SE 250",

					"SE 250 Factory *FRONT*": "SE 250 Factory",
					"SE 250 Factory *REAR*": "SE 250 Factory",

					"SE 250 Racing *FRONT*": "SE 250 Racing",
					"SE 250 Racing *REAR*": "SE 250 Racing",

					"SEF 250 *FRONT*": "SEF 250",
					"SEF 250 *REAR*": "SEF 250",

					"SEF 250 Factory *FRONT*": "SEF 250 Factory",
					"SEF 250 Factory *REAR*": "SEF 250 Factory",

					"SEF 250 Racing *FRONT*": "SEF 250 Racing",
					"SEF 250 Racing *REAR*": "SEF 250 Racing",

					"SE 300 *FRONT*": "SE 300",
					"SE 300 *REAR*": "SE 300",

					"SE 300 Factory *FRONT*": "SE 300 Factory",
					"SE 300 Factory *REAR*": "SE 300 Factory",

					"SE 300 Racing *FRONT*": "SE 300 Racing",
					"SE 300 Racing *REAR*": "SE 300 Racing",

					"SE 300 Xtrem *FRONT*": "SE 300 Xtrem",
					"SE 300 Xtrem *REAR*": "SE 300 Xtrem",

					"SEF 300 *FRONT*": "SEF 300",
					"SEF 300 *REAR*": "SEF 300",

					"SEF 300 Factory *FRONT*": "SEF 300 Factory",
					"SEF 300 Factory *REAR*": "SEF 300 Factory",

					"SEF 300 Racing *FRONT*": "SEF 300 Racing",
					"SEF 300 Racing *REAR*": "SEF 300 Racing",

					"SEF 450 *FRONT*": "SEF 450",
					"SEF 450 *REAR*": "SEF 450",

					"SEF 450 Factory *FRONT*": "SEF 450 Factory",
					"SEF 450 Factory *REAR*": "SEF 450 Factory",

					"SEF 450 Racing *FRONT*": "SEF 450 Racing",
					"SEF 450 Racing *REAR*": "SEF 450 Racing",

					"SEF 500 *FRONT*": "SEF 500",
					"SEF 500 *REAR*": "SEF 500",

					"SEF 500 Factory *FRONT*": "SEF 500 Factory",
					"SEF 500 Factory *REAR*": "SEF 500 Factory",

					"SEF 500 Racing *FRONT*": "SEF 500 Racing",
					"SEF 500 Racing *REAR*": "SEF 500 Racing",

				};
				hub_colors = {
					Silver: "Silver",
					Black: "Black",
					Red: "Red",
					Blue: "Blue",
					Gold: "Gold",
					Green: "Green",
					Orange: "Orange",
					Purple: "Purple",
					Magnesium: "Magnesium",
				};
				rim_colors = {
					Black: "Black",
					"Matte-Black": "Matte Black",
					'Blue': 'Blue',
					'Baby-Blue': 'Baby-Blue',
					'Orange': 'Orange',
					'Nardo-Grey': 'Nardo-Grey',
					'Yellow': 'Yellow',
					'Flo-Yellow': 'Flo Yellow',
					'White': 'White',
				};
				spoke_colors = {
					Silver: "Silver",
					Black: "Black",
					Blue: "Blue",
					Green: "Green",
					Orange: "Orange",
					Red: "Red",
					White: "White",
					Yellow: "Yellow",
					"Flo-Yellow": "Flo Yellow",
					"Titanium": "Titanium",
					'Nardo-Gray': 'Nardo Grey'
				};
				nipple_colors = {
					Silver: "Silver",
					Black: "Black",
					Red: "Red",
					Blue: "Blue",
					Orange: "Orange",
					Green: "Green",
					Gold: "Gold",
					Purple: "Purple",
					Magnesium: "Magnesium",
				};
				rim_size = {
					'FRONT 21x1.85': 'FRONT 21x1.85',
					"FRONT 21x1.60": "FRONT 21x1.60",
					"FRONT 19x2.15": "FRONT 19x2.15",
					"FRONT 19x2.50": "FRONT 19x2.50",
				};
				brake_rotor = {
					Wave: "Wave",
					"270MM_FLOATING": "270mm Floating",
				};
				break;
			case "Rieju": // Reiju
				models = {
					"MR 200 *FRONT*": "MR 200",
					"MR 200 *REAR*": "MR 200",

					"MR Pro 200 *FRONT*": "MR Pro 200",
					"MR Pro 200 *REAR*": "MR Pro 200",

					"MR Racing 200 *FRONT*": "MR Racing 200",
					"MR Racing 200 *REAR*": "MR Racing 200",

					"MR Ranger 200 *FRONT*": "MR Ranger 200",
					"MR Ranger 200 *REAR*": "MR Ranger 200",

					"MR 300 *FRONT*": "MR 300",
					"MR 300 *REAR*": "MR 300",

					"MR 6Days 250 *FRONT*": "MR 6Days 250",
					"MR 6Days 250 *REAR*": "MR 6Days 250",

					"MR 6Days 300 *FRONT*": "MR 6Days 300",
					"MR 6Days 300 *REAR*": "MR 6Days 300",

					"MR Alfredo Gómez Replica 300 *FRONT*": "MR Alfredo Gómez Replica 300",
					"MR Alfredo Gómez Replica 300 *REAR*": "MR Alfredo Gómez Replica 300",

					"MR Pro 300 *FRONT*": "MR Pro 300",
					"MR Pro 300 *REAR*": "MR Pro 300",

					"MR Pro 300i *FRONT*": "MR Pro 300i",
					"MR Pro 300i *REAR*": "MR Pro 300i",

					"MR Racing 300 *FRONT*": "MR Racing 300",
					"MR Racing 300 *REAR*": "MR Racing 300",

					"MR Ranger 300 *FRONT*": "MR Ranger 300",
					"MR Ranger 300 *REAR*": "MR Ranger 300",

				};
				hub_colors = {
					Silver: "Silver",
					Black: "Black",
					Red: "Red",
					Blue: "Blue",
					Gold: "Gold",
					Green: "Green",
					Orange: "Orange",
					Purple: "Purple",
					Magnesium: "Magnesium",
				};
				rim_colors = {
					Black: "Black",
					"Matte-Black": "Matte Black",
					'Blue': 'Blue',
					'Baby-Blue': 'Baby-Blue',
					'Orange': 'Orange',
					'Nardo-Grey': 'Nardo-Grey',
					'Yellow': 'Yellow',
					'Flo-Yellow': 'Flo Yellow',
					'White': 'White',
				};
				spoke_colors = {
					Silver: "Silver",
					Black: "Black",
					Blue: "Blue",
					Green: "Green",
					Orange: "Orange",
					Red: "Red",
					White: "White",
					Yellow: "Yellow",
					"Flo-Yellow": "Flo Yellow",
					"Titanium": "Titanium",
					'Nardo-Gray': 'Nardo Grey'
				};
				nipple_colors = {
					Silver: "Silver",
					Black: "Black",
					Red: "Red",
					Blue: "Blue",
					Orange: "Orange",
					Green: "Green",
					Gold: "Gold",
					Purple: "Purple",
					Magnesium: "Magnesium",
				};
				rim_size = {
					'FRONT 21x1.85': 'FRONT 21x1.85',
					"FRONT 21x1.60": "FRONT 21x1.60",
					"FRONT 19x2.15": "FRONT 19x2.15",
					"FRONT 19x2.50": "FRONT 19x2.50",
				};
				brake_rotor = {
					Wave: "Wave",
					"270MM_FLOATING": "270mm Floating",
				};
				break;
			case "Stark": //Stark
				models = {
					// "Varg *FRONT*": "Varg",

					// "Varg *REAR*": "Varg",
					"Varg MX *FRONT*": "Varg MX",
					"Varg MX *REAR*": "Varg MX",

					"Varg EX *FRONT*": "Varg EX",
					"Varg EX *REAR*": "Varg EX",

				};
				hub_colors = {
					Silver: "Silver",
					Black: "Black",
					Red: "Red",
					Blue: "Blue",
					Gold: "Gold",
					Green: "Green",
					Orange: "Orange",
					Purple: "Purple",
					Magnesium: "Magnesium",
				};
				rim_colors = {
					Black: "Black",
					"Matte-Black": "Matte Black",
					'Blue': 'Blue',
					'Baby-Blue': 'Baby-Blue',
					'Orange': 'Orange',
					'Nardo-Grey': 'Nardo-Grey',
					'Yellow': 'Yellow',
					'Flo-Yellow': 'Flo Yellow',
					'White': 'White',
				};
				spoke_colors = {
					Silver: "Silver",
					Black: "Black",
					Blue: "Blue",
					Green: "Green",
					Orange: "Orange",
					Red: "Red",
					White: "White",
					Yellow: "Yellow",
					"Flo-Yellow": "Flo Yellow",
					"Titanium": "Titanium",
					'Nardo-Gray': 'Nardo Grey'
				};
				nipple_colors = {
					Silver: "Silver",
					Black: "Black",
					Red: "Red",
					Blue: "Blue",
					Orange: "Orange",
					Green: "Green",
					Gold: "Gold",
					Purple: "Purple",
					Magnesium: "Magnesium",
				};
				rim_size = {
					'FRONT 21x1.85': 'FRONT 21x1.85',
					"FRONT 21x1.60": "FRONT 21x1.60",
					"FRONT 19x2.15": "FRONT 19x2.15",
					"FRONT 19x2.50": "FRONT 19x2.50",
				};
				brake_rotor = {
					Wave: "Wave",
					"270MM_FLOATING": "270mm Floating",
				};
				break;
			case "Alta Redshift": //Alta Redshift
				models = {
					"All years and models *FRONT": "MX",
					"Enduro *FRONT": "Enduro",
					"All years and models * REAR *": "MX",
					"Enduro * REAR *": "Enduro",
					"EX *FRONT*": "EX",
					"EX *REAR*": "EX",
					"MXR *FRONT*": "MXR",
					"MXR *REAR*": "MXR",
					"EXR *FRONT*": "EXR",
					"EXR *REAR*": "EXR",
				};
				hub_colors = {
					Silver: "Silver",
					Black: "Black",
					Red: "Red",
					Blue: "Blue",
					Gold: "Gold",
					Green: "Green",
					Orange: "Orange",
					Purple: "Purple",
					Magnesium: "Magnesium",
				};
				rim_colors = {
					Black: "Black",
					"Matte-Black": "Matte Black",
					'Blue': 'Blue',
					'Baby-Blue': 'Baby-Blue',
					'Orange': 'Orange',
					'Nardo-Grey': 'Nardo-Grey',
					'Yellow': 'Yellow',
					'Flo-Yellow': 'Flo Yellow',
					'White': 'White',
				};
				spoke_colors = {
					Silver: "Silver",
					Black: "Black",
					Blue: "Blue",
					Green: "Green",
					Orange: "Orange",
					Red: "Red",
					White: "White",
					Yellow: "Yellow",
					"Flo-Yellow": "Flo Yellow",
					"Titanium": "Titanium",
					'Nardo-Gray': 'Nardo Grey'
				};
				nipple_colors = {
					Silver: "Silver",
					Black: "Black",
					Red: "Red",
					Blue: "Blue",
					Orange: "Orange",
					Green: "Green",
					Gold: "Gold",
					Purple: "Purple",
					Magnesium: "Magnesium",
				};
				rim_size = {
					"FRONT 21x1.85": "FRONT 21x1.85",
					"FRONT 21x1.60": "FRONT 21x1.60",
					"FRONT 19x2.15": "FRONT 19x2.15",
					"FRONT 19x2.50": "FRONT 19x2.50",
				};
				brake_rotor = {
					Wave: "Wave",
					"270MM_FLOATING": "270mm Floating",
				};
				break;

			case 'Kove': //Kove
				models = {
					'450 Rally *FRONT*': '450 Rally',
					'450 Rally ABS *FRONT*': '450 Rally ABS',

					'450 Rally *REAR*': '450 Rally',
					'450 Rally ABS *REAR*': '450 Rally ABS',

					"MX250 *FRONT*": "MX250",
					"MX250 *REAR*": "MX250",

					"450R Rally *FRONT*": "450R Rally",
					"450R Rally *REAR*": "450R Rally",

					"MX450 *FRONT*": "MX450",
					"MX450 *REAR*": "MX450",

				};
				hub_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Gold': 'Gold',
					'Green': 'Green',
					'Orange': 'Orange',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium'
				};
				rim_colors = {
					'Silver': 'Silver',
					/*'White' : 'White',*/
					'Black': 'Black',
					'Matte-Black': 'Matte Black',
					/*'Red' : 'Red',
                                      'Blue' : 'Blue',
                                      'Orange' : 'Orange',
									  'Green' : 'Green',
									  'Gold' : 'Gold',
									  'Purple' : 'Purple',
									  'Magnesium' : 'Magnesium',
									  'Flo-Yellow': 'Flo Yellow'*/
				};
				spoke_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Blue': 'Blue',

					'Green': 'Green',
					'Orange': 'Orange',
					'Red': 'Red',
					'White': 'White',
					'Yellow': 'Yellow',
					'Flo-Yellow': 'Flo Yellow',
					'Nardo-Gray': 'Nardo Grey'
				};
				nipple_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Orange': 'Orange',
					'Green': 'Green',
					'Gold': 'Gold',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium'
				};
				rim_size = {
					'FRONT 21x1.85': 'FRONT 21x1.85',
					'FRONT 21x1.60': 'FRONT 21x1.60',
					'21x1.85 (OEM SIZE)': '21x1.85 (OEM SIZE)',
				};
				brake_rotor = {
					'Wave': 'Wave',
					'270MM_FLOATING': '270mm Floating'
				};
				break;
			case 'Kayo': //Kove
				models = {
					"T4 230 *FRONT*": "T4 230",
					"T4 230 *REAR*": "T4 230",
				};
				hub_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Gold': 'Gold',
					'Green': 'Green',
					'Orange': 'Orange',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium'
				};
				rim_colors = {
					'Silver': 'Silver',
					'White' : 'White',
					'Black': 'Black',
					'Matte-Black': 'Matte Black',
					'Red' : 'Red',
					'Blue' : 'Blue',
					'Orange' : 'Orange',
					'Green' : 'Green',
					'Gold' : 'Gold',
					'Purple' : 'Purple',
					'Magnesium' : 'Magnesium',
					'Flo-Yellow': 'Flo Yellow'
				};
				spoke_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Blue': 'Blue',

					'Green': 'Green',
					'Orange': 'Orange',
					'Red': 'Red',
					'White': 'White',
					'Yellow': 'Yellow',
					'Flo-Yellow': 'Flo Yellow',
					'Nardo-Gray': 'Nardo Grey'
				};
				nipple_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Orange': 'Orange',
					'Green': 'Green',
					'Gold': 'Gold',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium'
				};
				rim_size = {
					'FRONT 21x1.85': 'FRONT 21x1.85',
					'FRONT 21x1.60': 'FRONT 21x1.60',
					'21x1.85 (OEM SIZE)': '21x1.85 (OEM SIZE)',
				};
				brake_rotor = {
					'Wave': 'Wave',
					'270MM_FLOATING': '270mm Floating'
				};
				break;
			case 'SWM': //Kove
				models = {
					"RS 125 R *FRONT*": "RS 125 R",
					"RS 125 R *REAR*": "RS 125 R",

					"RE 300 R *FRONT*": "RE 300 R",
					"RE 300 R *REAR*": "RE 300 R",

					"RS 300 R *FRONT*": "RS 300 R",
					"RS 300 R *REAR*": "RS 300 R",

					"RS 300 R Six Days *FRONT*": "RS 300 R Six Days",
					"RS 300 R Six Days *REAR*": "RS 300 R Six Days",
				};
				hub_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Gold': 'Gold',
					'Green': 'Green',
					'Orange': 'Orange',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium'
				};
				rim_colors = {
					'Silver': 'Silver',
					'White' : 'White',
					'Black': 'Black',
					'Matte-Black': 'Matte Black',
					'Red' : 'Red',
					'Blue' : 'Blue',
					'Orange' : 'Orange',
					'Green' : 'Green',
					'Gold' : 'Gold',
					'Purple' : 'Purple',
					'Magnesium' : 'Magnesium',
					'Flo-Yellow': 'Flo Yellow'
				};
				spoke_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Blue': 'Blue',

					'Green': 'Green',
					'Orange': 'Orange',
					'Red': 'Red',
					'White': 'White',
					'Yellow': 'Yellow',
					'Flo-Yellow': 'Flo Yellow',
					'Nardo-Gray': 'Nardo Grey'
				};
				nipple_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Orange': 'Orange',
					'Green': 'Green',
					'Gold': 'Gold',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium'
				};
				rim_size = {
					'FRONT 21x1.60': 'FRONT 21x1.60',
					'21x1.85 (OEM SIZE)': '21x1.85 (OEM SIZE)',
				};
				brake_rotor = {
					'Wave': 'Wave',
					'270MM_FLOATING': '270mm Floating'
				};
				break;
		}

		var model_element = $("#bike_model");
		var hub_colors_element = $("#hub_color");
		var rim_colors_element = $("#rim_color");
		var spoke_colors_element = $("#spoke_color");
		var nipple_colors_element = $("#nipple_color");
		var rim_size_element = $("#rim_size");
		var brake_rotor_element = $("#brake_rotor");
		var sprocket_size_element = $("#sprocket_size");

		var model_select = model_element.prop("options");
		var hub_colors_select = hub_colors_element.prop("options");
		// var rim_colors_select = rim_colors_element.prop("options");
		var spoke_colors_select = spoke_colors_element.prop("options");
		var nipple_colors_select = nipple_colors_element.prop("options");
		var rim_size_select = rim_size_element.prop("options");
		var brake_rotor_select = brake_rotor_element.prop("options");
		var sprocket_size_select = sprocket_size_element.prop("options");

		$("option", model_element).remove();
		$("option", hub_colors_element).remove();
		$("option", rim_colors_element).remove();
		$("option", spoke_colors_element).remove();
		$("option", nipple_colors_element).remove();
		$("option", rim_size_element).remove();
		$("option", brake_rotor_element).remove();

		$.each(models, function (val, text) {
			var new_opt = new Option(text, val);

			model_select[model_select.length] = new_opt;
			if (val.indexOf("*FRONT") != -1 || text.indexOf("*FRONT") != -1)
				new_opt.className = "front";
			else new_opt.className = "rear";
		});

		if ($("select#wheel_type").val() == "REAR") {
			if ($("select#bike_model").val() == "DR650SE *REAR*") {
				rim_size = {
					"REAR 18x2.15": "REAR 18x2.15",
					"REAR 18x2.50": "REAR 18x2.50",
					"REAR 17X2.50": "REAR 17X2.50",
					"REAR 17X3.50": "REAR 17X3.50",
					"REAR 19x2.15": "REAR 19x2.15",
					"REAR 19x2.50": "REAR 19x2.50",
					"REAR 19x3.00": "REAR 19x3.00"
				}
			} else {
				$("select#bike_model option.front").appendTo("select#hidden_bike_model");
				rim_size = {
					"REAR 18x2.15": "REAR 18x2.15",
					"REAR 19x2.15": "REAR 19x2.15",
					"REAR 18x2.50": "REAR 18x2.50",
					"REAR 19x3.00": "REAR 19x3.00",
					//'REAR 19x2.50' : 'REAR 19x2.50'
				};
			}
		} else {
			$("select#bike_model option.rear").appendTo("select#hidden_bike_model");
		}

		// color append function start
		var hubColorsSelect = $('#hub_colors_select'); // Assuming you have a select element with the id 'hub_colors_select'
		var hubColorWrapper = $('.hub_color_wrapper');
		var hiddenInput = $('#hub_color');
		hubColorWrapper.empty();

		$.each(hub_colors, function (index, colorValue) {
			// Create a new color swatch element
			const formattedColor = colorValue.replace(" ", "-").toLowerCase();
			var colorSwatch = $('<div>', {
				class: 'color-swatch',
				'data-value': colorValue.replace(" ", "-"),
				style: `background: url(${images}${formattedColor}.svg?v=1717478021);`,
				'title': colorValue
			});
			hubColorWrapper.append(colorSwatch);

			colorSwatch.on('click', function () {
				hubColorWrapper.find('.color-swatch').removeClass('active');
				$(this).addClass('active');
				hiddenInput.val(colorValue);

			});

		});

		$('.hub_color_wrapper .color-swatch:first').click();
		var initialColorValue = hiddenInput.val();
		hubColorWrapper.find('.color-swatch[data-value="' + initialColorValue + '"]').addClass('active');
		// color append function end

		var anodizedRim = ['silver', 'matte black', 'black'];
		var powderCoatedRim = [];
		// color append function start
		var rimColorsSelect = $('#rim_colors_select'); // Assuming you have a select element with the id 'rim_colors_select'
		var rimColorWrapper = $('.rim_color_wrapper');
		var hiddenInput = $('#rim_color');
		// rimColorWrapper.empty();
		// console.log(rim_colors);
		// $.each(rim_colors, function(index, colorValue) {
		// 	// Create a new color swatch element
		//           var colorname = colorValue.toLowerCase();
		//           var dataCategory = anodizedRim.includes(colorname) ? "anodized" : "powder-coat"; 
		//           // console.log({dataCategory});
		// 				const formattedColor = colorValue.replace(" ", "-").toLowerCase();
		// 	var colorSwatch = $('<div>', {
		// 		class: 'color-swatch',
		// 		'data-value': colorValue.replace(" ", "-"),
		//               "data-category": dataCategory,
		// 		style: `background: url(${images}${formattedColor}.svg?v=1717478021);`,
		//               title: colorValue
		// 	});
		// 	rimColorWrapper.append(colorSwatch);

		// 	colorSwatch.on('click', function() {
		// 		rimColorWrapper.find('.color-swatch').removeClass('active');
		// 		$(this).addClass('active');
		// 		hiddenInput.val(colorValue);
		// 	});

		// });

		$('.rim_color_wrapper .color-swatch:first').click();
		var initialColorValue = hiddenInput.val();
		rimColorWrapper.find('.color-swatch[data-value="' + initialColorValue + '"]').addClass('active');
		// color append function end

		// color append function start
		var spokeColorsSelect = $('#spoke_colors_select'); // Assuming you have a select element with the id 'spoke_colors_select'
		var spokeColorWrapper = $('.spoke_color_wrapper');
		var hiddenInput = $('#spoke_color');
		spokeColorWrapper.empty();
		// console.log(spoke_colors)

		$.each(spoke_colors, function (index, colorValue) {
			// Create a new color swatch element
			const formattedColor = colorValue.replace(" ", "-").toLowerCase();
			var colorSwatch = $('<div>', {
				class: 'color-swatch',
				'data-value': colorValue.replace(" ", "-"),
				style: `background: url(${images}${formattedColor}.svg?v=1717478021);`,
				title: colorValue
			});
			spokeColorWrapper.append(colorSwatch);

			colorSwatch.on('click', function () {
				spokeColorWrapper.find('.color-swatch').removeClass('active');
				$(this).addClass('active');
				hiddenInput.val(colorValue);
			});

		});
		$('.spoke_color_wrapper .color-swatch:first').click();
		var initialColorValue = hiddenInput.val();
		spokeColorWrapper.find('.color-swatch[data-value="' + initialColorValue + '"]').addClass('active');
		// color append function end



		// color append function start
		var nippleColorsSelect = $('#nipple_colors_select'); // Assuming you have a select element with the id 'nipple_colors_select'
		var nippleColorWrapper = $('.nipple_color_wrapper');
		var hiddenInput = $('#nipple_color');
		nippleColorWrapper.empty();

		$.each(nipple_colors, function (index, colorValue) {
			// Create a new color swatch element
			const formattedColor = colorValue.replace(" ", "-").toLowerCase();
			var colorSwatch = $('<div>', {
				class: 'color-swatch',
				'data-value': colorValue.replace(" ", "-"),
				style: `background: url(${images}${formattedColor}.svg?v=1717478021);`,
				title: colorValue
			});
			nippleColorWrapper.append(colorSwatch);

			colorSwatch.on('click', function () {
				nippleColorWrapper.find('.color-swatch').removeClass('active');
				$(this).addClass('active');
				hiddenInput.val(colorValue);
			});

		});
		$('.nipple_color_wrapper .color-swatch:first').click();
		var initialColorValue = hiddenInput.val();
		nippleColorWrapper.find('.color-swatch[data-value="' + initialColorValue + '"]').addClass('active');
		// color append function end

		var rimSizeSelect = $('select#rim_size');

		$.each(rim_size, function (value, text) {
			// Create a new option element and append it to the select element
			rimSizeSelect.append($('<option>', {
				value: value,
				text: text
			}));
		});

		var brakeRotorSelect = $('select#brake_rotor');

		$.each(brake_rotor, function (value, text) {
			// Create a new option element and append it to the select element
			brakeRotorSelect.append($('<option>', {
				value: value,
				text: text
			}));
		});

		if ($("select#wheel_type").val() == 1) {
			//front
			$("#sprocket").show();
			sprockethide();
			var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/sprocket.png";
			var imageArr6 = [image_name];
			var divArr6 = ["resultAreaID_1_7"];
			imageObj6 = new BL_ImageLoader(divArr6, imageArr6);
		} else {
			//rear
			// $("#sprocket").hide();
			$("#resultAreaID_1_7").hide();
		}

		if ($("select#rim_type").val() == "Elite") {
			var select = $("#rim_type");
			select
				.empty()
				.append(
					'<option class="category" selected="selected" value="Standard">Standard</option><option class="category"  value="Elite">Elite</option>'
				);
		} else {}

		if ($("select#bike_make").val() == "Husaberg") {
			if ($("select#bike_model").val() == "2004 - 14 All FE /FC *FRONT*") {
				console.log('Debug Husaberg FC Brake Rotor');
				var select = $("#brake_rotor");
				select.closest("tr").css("display", "block");
				select
					.empty()
					.append(
						'<option value="Wave">Wave</option><option value="270MM_FLOATING">270mm Floating</option>'
					);
			}
		}

		$(".rim-color-type .rim-type-wrap.anodized").click();
		bikeyear()
	}); // Ends 

	// Bike model
	$(document).on("change", 'select#bike_model', function () {
		var enable_cush_drive = [
			'2017+ CRF250L *REAR*',
			'CRF250L ABS *REAR*',
			'2017+ CRF250L Rally *REAR*',
			'CRF250L Rally ABS *REAR*',
			'CRF300L *REAR*',
			'CRF300L ABS *REAR*',
			'CRF300L Rally *REAR*',
			'CRF300L Rally ABS *REAR*'
		];
		var selectedModel = $('#bike_model').val();
		if ($('select#bike_make').val() === "Honda" && enable_cush_drive.includes(selectedModel)) {
			select = $('#cush_drive');
			select.empty().append('<option class="category" value="unavailable">Standard</option>', '<option class="category" value="Cush Drive">Cush Drive</option>');

		}

	});


	$(document).on("change",'select#bike_make', function () {
		var enable_cush_drive = [
			'2017+ CRF250L *REAR*',
			'CRF250L ABS *REAR*',
			'2017+ CRF250L Rally *REAR*',
			'CRF250L Rally ABS *REAR*',
			'CRF300L *REAR*',
			'CRF300L ABS *REAR*',
			'CRF300L Rally *REAR*',
			'CRF300L Rally ABS *REAR*'
		];
		var selectedModel = $('#bike_model').val();
		if ($('select#bike_make').val() === "Honda" && enable_cush_drive.includes(selectedModel)) {
			select = $('#cush_drive');
			select.empty().append('<option class="category" value="unavailable">Standard</option>', '<option class="category" value="Cush Drive">Cush Drive</option>');

		} else if ($('select#bike_model').val() === `2004 - 13 CRF250R *REAR*` || $('select#bike_model').val() === `2002 - 12 CRF450R *REAR*` || $('select#bike_model').val() === `CRF450R Works Edition *REAR*` || $('select#bike_model').val() === `CRF450L *REAR*` || $('select#bike_model').val() === `CRF450RL *REAR*` || $('select#bike_model').val() === `2004 - 2017 CRF250X *REAR*` || $('select#bike_model').val() === `2002 - 2017 CRF450X *REAR*` || $('select#bike_model').val() === `2009 - 17 YZ250F *REAR*` || $('select#bike_model').val() === `2015 - 2017 YZ250FX *REAR*` || $('select#bike_model').val() === `2016 - 2017 YZ250X *REAR*` || $('select#bike_model').val() === `2016 - 2017 YZ450FX *REAR*` || $('select#bike_model').val() === `2001 - 17 WR250F *REAR*` || $('select#bike_model').val() === `1999 YZ400F *REAR*` || $('select#bike_model').val() === `1998 YZ400F *REAR*` || $('select#bike_model').val() === `2000 - 08 YZ426F *REAR*` || $('select#bike_model').val() === `2000 - 17 DRZ400 S * REAR *` || $('select#bike_model').val() === `2000 - 17 DRZ400 SE * REAR *` || $('select#bike_model').val() === `2000 - 17 DRZ400 E * REAR *` || $('select#bike_model').val() == `EXC125 *REAR*` || $('select#bike_model').val() == `EXC-F350 *REAR*` || $('select#bike_model').val() == `EXC520 *REAR*` || $('select#bike_model').val() == `XC-W250 TPI *REAR*` || $('select#bike_model').val() == `XCF-W250 *REAR*` || $('select#bike_model').val() == `XC-W300 TPI *REAR*` || $('select#bike_model').val() == `XC-F450 *REAR*` || $('select#bike_model').val() == `XC-W500 *REAR*` || $('select#bike_model').val() == `XC-F505 *REAR*` || $('select#bike_model').val() == `SX450 *REAR*` || $('select#bike_model').val() == `EXC200 *REAR*` || $('select#bike_model').val() == `EXC-F250 *REAR*` || $('select#bike_model').val() == `EXC300 *REAR*` || $('select#bike_model').val() == `EXC380 *REAR*` || $('select#bike_model').val() == `EXC400 *REAR*` || $('select#bike_model').val() == `EXC450 *REAR*` || $('select#bike_model').val() == `EXC350 *REAR*` || $('select#bike_model').val() == `EXC-F500 *REAR*` || $('select#bike_model').val() == `EXC-F450 *REAR*` || $('select#bike_model').val() == `XC250 TPI *REAR*` || $('select#bike_model').val() == `XC300 TPI *REAR*` || $('select#bike_model').val() == `XC-W300 TPI Six Days *REAR*` || $('select#bike_model').val() == `SX-F450 Factory Edition *REAR*` || $('select#bike_model').val() == `TX125 *REAR*` || $('select#bike_model').val() == `TE250I *REAR*` || $('select#bike_model').val() == `TE300I *REAR*` || $('select#bike_model').val() == `TX300 *REAR*` || $('select#bike_model').val() == `FC350 *REAR*` || $('select#bike_model').val() == `FE350 *REAR*` || $('select#bike_model').val() == `FX350 *REAR*` || $('select#bike_model').val() == `FE450 *REAR*` || $('select#bike_model').val() == `FX450 *REAR*` || $('select#bike_model').val() == `EXC525 *REAR*` || $('select#bike_model').val() == `EXC530 *REAR*` || $('select#bike_model').val() == `EXC-R530 *REAR*` || $('select#bike_model').val() == `XC150 *REAR*` || $('select#bike_model').val() == `XC-W150 *REAR*` || $('select#bike_model').val() == `XC200 *REAR*` || $('select#bike_model').val() == `XC-W200 *REAR*` || $('select#bike_model').val() == `XC250 *REAR*` || $('select#bike_model').val() == `XC-W250 *REAR*` || $('select#bike_model').val() == `XC-F250 *REAR*` || $('select#bike_model').val() == `XC-F350 *REAR*` || $('select#bike_model').val() == `XCF-W350 *REAR*` || $('select#bike_model').val() == `XC300 *REAR*` || $('select#bike_model').val() == `XC-W300 *REAR*` || $('select#bike_model').val() == `XC400 *REAR*` || $('select#bike_model').val() == `XC-W400 *REAR*` || $('select#bike_model').val() == `XC450 *REAR*` || $('select#bike_model').val() == `XC-W450 *REAR*` || $('select#bike_model').val() == `XC525 *REAR*` || $('select#bike_model').val() == `XC-W525 *REAR*` || $('select#bike_model').val() == `XC530 *REAR*` || $('select#bike_model').val() == `XC-W530 *REAR*` || $('select#bike_model').val() == `SX125 *REAR*` || $('select#bike_model').val() == `SX144 *REAR*` || $('select#bike_model').val() == `SX150 *REAR*` || $('select#bike_model').val() == `SX200 *REAR*` || $('select#bike_model').val() == `SX250 *REAR*` || $('select#bike_model').val() == `SXF250 *REAR*` || $('select#bike_model').val() == `SXF350 *REAR*` || $('select#bike_model').val() == `SX380 *REAR*` || $('select#bike_model').val() == `SX400 *REAR*` || $('select#bike_model').val() == `SXC400 *REAR*` || $('select#bike_model').val() == `SX-RFS450 *REAR*` || $('select#bike_model').val() == `SX-F450 *REAR*` || $('select#bike_model').val() == `Varg *REAR*` || $('select#bike_model').val() == `SX-F505 *REAR*` || $('select#bike_model').val() == `SX520 *REAR*` || $('select#bike_model').val() == `SX525 *REAR*` || $('select#bike_model').val() == `SXC625 *REAR*` || $('select#bike_model').val() === `2014 - 17 TE300 *REAR*` || $('select#bike_model').val() === `2014 - 17 FC450 *REAR*` || $('select#bike_model').val() === `2014 - 17 FE501 *REAR*` || $('select#bike_model').val() === `TE150 *REAR*` || $('select#bike_model').val() === `TX300i *REAR*` || $('select#bike_model').val() === `FC450 Rockstar Edition *REAR*` || $('select#bike_model').val() === `2003 - 17 WR450F*REAR*` || $('select#bike_model').val() === `2009 - 17 YZ250F *REAR*` || $('select#bike_model').val() === `2002 - 12 CRF450R *REAR*` || $('select#bike_model').val() === `CRF450R Works Edition *REAR*` || $('select#bike_model').val() === `2013 - 2017 CRF450R *REAR*` || $('select#bike_model').val() === `2017+ CRF450RX *REAR*` || $('select#bike_model').val() === `CRF250RX *REAR*` || $('select#bike_model').val() === `2004 - 14 All FE/FC *REAR*` || $('select#bike_model').val() === `FE *REAR*` || $('select#bike_model').val() === `2009 - 11 450X *REAR*` || $('select#bike_model').val() === `2009 - 15 YZ450F *REAR*` || $('select#bike_model').val() === `WR426 *REAR*` || $('select#bike_model').val() === `2000 - 07 KLX400 *REAR*` || $('select#bike_model').val() === `1996 - 04 XR 250 *REAR*` || $('select#bike_model').val() === `1996 - 04 XR 400 *REAR*` || $('select#bike_model').val() === `1993 - 2017 XR650L *REAR*` || $('select#bike_model').val() == `2008 – 2013 KTM 690 ENDURO * REAR *` || $('select#bike_model').val() == `790 Adventure *REAR*` || $('select#bike_model').val() == `790 Adventure R *REAR*` || $('select#bike_model').val() == `890 Adventure *REAR*` || $('select#bike_model').val() == `890 Adventure R *REAR*` || $('select#bike_model').val() == `950 Adventure *REAR*` || $('select#bike_model').val() == `990 Adventure *REAR*` || $('select#bike_model').val() == `1090 Adventure *REAR*` || $('select#bike_model').val() == `1190 Adventure *REAR*` || $('select#bike_model').val() == `1290 Adventure ABS *REAR*` || $('select#bike_model').val() == `1290 Adventure R *REAR*` || $('select#bike_model').val() == `1290 Super Adventure S *REAR*` || $('select#bike_model').val() == `2014 – 2017 KTM 690 ENDURO ABS * REAR *` || $('select#bike_model').val() == `RR *REAR*` || $('select#bike_model').val() == `RS *REAR*` || $('select#bike_model').val() == `450 Rally *FRONT*` || $('select#bike_model').val() == `450 Rally ABS *FRONT*` || $('select#bike_model').val() == `450 Rally *REAR*` || $('select#bike_model').val() == `450 Rally ABS *REAR*`) {
			// document.getElementById("cush_drive").disabled = false;
			select = $('#cush_drive');
			select.empty().append('<option class="category" value="unavailable">Standard</option>', '<option class="category" value="Cush Drive">Cush Drive</option>');
			if ($('select#cush_drive').val() != "unavailable") {
				/*document.getElementById('rotor-text').style.margin='120px 0px 0px 0px';
				document.getElementById('rotor-text').style.top='420px';
				document.getElementById('resultAreaID_1_6').style.width='175px';
				document.getElementById('resultAreaID_1_6').style.height='106px';
				document.getElementById('resultAreaID_1_6').style.top='420px';*/
				// $('#resultAreaID_1_4').show();
			} else {
				// document.getElementById('rotor-text').style.margin = '';
				// document.getElementById('rotor-text').style.top = '';
				// document.getElementById('resultAreaID_1_6').style.width = '';
				// document.getElementById('resultAreaID_1_6').style.height = '';
				// document.getElementById('resultAreaID_1_6').style.top = '';
				// $('#resultAreaID_1_4').hide();

			}
		} else {
			// document.getElementById("cush_drive").disabled = true;
			// select = $('#cush_drive');
			// select.empty().append(' <option class="category" value="unavailable" selected="selected">Standard</option>');



		}

		//Fron suspension Logic//
		if ($('select#wheel_type').val() == "FRONT" & $('select#bike_make').val() == 'Sherco') {
			$('#frontsuspension').show();

		} else {
			$('#frontsuspension').hide();
		}


		//Model Year Show		
		if ($('select#bike_make').val() == 'Husqvarna' || $('select#bike_make').val() == 'Honda' || $('select#bike_make').val() == 'KTM' || $('select#bike_make').val() == 'Yamaha' || $('select#bike_make').val() == 'Kawasaki' || $('select#bike_make').val() == 'Suzuki' || $('select#bike_make').val() == 'Husaberg' || $('select#bike_make').val() == 'GasGas' || $('select#bike_make').val() == 'BMW' || $('select#bike_make').val() == 'Beta' || $('select#bike_make').val() == 'TM' || $('select#bike_make').val() == 'Sherco' || $('select#bike_make').val() == 'Stark' || $('select#bike_make').val() == 'Alta Redshift' || $('select#bike_make').val() == 'Kove')

		{
			$('#bikeyear').show();
			// $('#frontsuspension').show();


		} else {
			$('#bikeyear').hide();
			//  $('#frontsuspension').hide();

		}
		// Hide Blue rim color
		// rimcolorhideblue();

	});
	// bike-years
	var bikeyear = function () {
		//Bike Year Start
		//Declare Selected Bike Model Variable
		
		var sel_bike_model = $('select#bike_model').val();
		var sel_year = $('#bike_year');
		var previous_year = sel_year.val();
		var sel_bike_make = $('#bike_make').val();
		// console.info('YEAR CHANGE EVENT');
		// console.log($('#wheel_type').val());
		// console.log($('#bike_make').val());
		// console.info(sel_bike_model);
		// console.log(sel_bike_model);
		//Option Year Variable
		var y81 = '<option value="1981">1981</option>';
		var y82 = '<option value="1982">1982</option>';
		var y83 = '<option value="1983">1983</option>';
		var y84 = '<option value="1984">1984</option>';
		var y85 = '<option value="1985">1985</option>';
		var y86 = '<option value="1986">1986</option>';
		var y87 = '<option value="1987">1987</option>';
		var y88 = '<option value="1988">1988</option>';
		var y89 = '<option value="1989">1989</option>';
		var y90 = '<option value="1990">1990</option>';
		var y91 = '<option value="1991">1991</option>';
		var y92 = '<option value="1992">1992</option>';
		var y93 = '<option value="1993">1993</option>';
		var y94 = '<option value="1994">1994</option>';
		var y95 = '<option value="1995">1995</option>';
		var y96 = '<option value="1996">1996</option>';
		var y97 = '<option value="1997">1997</option>';
		var y98 = '<option value="1998">1998</option>';
		var y99 = '<option value="1999">1999</option>';
		var y00 = '<option value="2000">2000</option>';
		var y01 = '<option value="2001">2001</option>';
		var y02 = '<option value="2002">2002</option>';
		var y03 = '<option value="2003">2003</option>';
		var y04 = '<option value="2004">2004</option>';
		var y05 = '<option value="2005">2005</option>';
		var y06 = '<option value="2006">2006</option>';
		var y07 = '<option value="2007">2007</option>';
		var y08 = '<option value="2008">2008</option>';
		var y09 = '<option value="2009">2009</option>';
		var y10 = '<option value="2010">2010</option>';
		var y11 = '<option value="2011">2011</option>';
		var y12 = '<option value="2012">2012</option>';
		var y13 = '<option value="2013">2013</option>';
		var y14 = '<option value="2014">2014</option>';
		var y15 = '<option value="2015">2015</option>';
		var y16 = '<option value="2016">2016</option>';
		var y17 = '<option value="2017">2017</option>';
		var y18 = '<option value="2018">2018</option>';
		var y19 = '<option value="2019">2019</option>';
		var y20 = '<option value="2020">2020</option>';
		var y21 = '<option value="2021">2021</option>';
		var y22 = '<option value="2022">2022</option>';
		var y23 = '<option value="2023">2023</option>';
		var y24 = '<option value="2024">2024</option>';
		var y25 = '<option value="2025">2025</option>';
		var y26 = '<option value="2026">2026</option>';
		var y27 = '<option value="2027">2027</option>';
		//Global Usage
		//else if(sel_bike_model === "") {sel_year.empty().append();}
		//y86 + y87 + y88 + y89 + y90 + y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19


		


		
		//model Kove front
		// var selected_make = $('#bike_make').val();
		// if(selected_make == "Kove"){
		// 	sel_year.empty().append(y23 + y24 + y25 + y26);
		// 	return true;
		// }

		// Model Kove updated
		if (sel_bike_model == "450 Rally *FRONT*" || sel_bike_model == "450 Rally *REAR*") {
			sel_year.empty().append(y23 + y24 + y25 + y26);
		} else if (sel_bike_model == "450 Rally ABS *FRONT*" || sel_bike_model == "450 Rally ABS *REAR*") {
			sel_year.empty().append(y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "MX250 *FRONT*" || sel_bike_model === "MX250 *REAR*") {
			sel_year.empty().append(y24 + y25 + y26);
		} else if (sel_bike_model === "450R Rally *FRONT*" || sel_bike_model === "450R Rally *REAR*") {
			sel_year.empty().append(y26);
		}

		else if (sel_bike_model === "MX450 *FRONT*" || sel_bike_model === "MX450 *REAR*") {
			sel_year.empty().append(y26);
		}

		//Model Husaber that share models woth Husqvarna
		else if (sel_bike_model === "FE350 *FRONT*" && sel_bike_make == 'Husaberg' || sel_bike_model === "FE350 *REAR*" && sel_bike_make == 'Husaberg') {
			console.log('Debug husaber, logging bike make:', sel_bike_make);
			sel_year.empty().append(y13 + y14);
		}
		else if (sel_bike_model === "FX450 *FRONT*" && sel_bike_make == 'Husaberg' || sel_bike_model === "FX450 *REAR*" && sel_bike_make == 'Husaberg') {
			sel_year.empty().append(y10 + y11 + y12 + y13 + y14);
		}

		//Model Husqvarna Front

		if (sel_bike_model == "SM 125 *FRONT*" || sel_bike_model == "TXC 125 *FRONT*" || sel_bike_model == "WR 125 *FRONT*" || sel_bike_model == "SM 250 *FRONT*" || sel_bike_model == "SM 449 *FRONT*" || sel_bike_model == "TC 449 *FRONT*" || sel_bike_model == "TE 449 *FRONT*" || sel_bike_model == "TXC 449 *FRONT*" || sel_bike_model == "WR 449 *FRONT*" || sel_bike_model == "CR 449 *FRONT*" || sel_bike_model == "SM 450 *FRONT*" || sel_bike_model == "TE 450 *FRONT*" || sel_bike_model == "WR 450 *FRONT*" || sel_bike_model == "CR 450 *FRONT*" || sel_bike_model == "SM 510 *FRONT*" || sel_bike_model == "WR 510 *FRONT*" || sel_bike_model == "CR 510 *FRONT*" || sel_bike_model == "SM 610 *FRONT*" || sel_bike_model == "TC 610 *FRONT*" || sel_bike_model == "TE 610 *FRONT*" || sel_bike_model == "TXC 610 *FRONT*" || sel_bike_model == "WR 610 *FRONT*" || sel_bike_model == "CR 610 *FRONT*") {
			sel_year.empty().append(y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13);
		} else if (sel_bike_model === "701 Enduro ABS *FRONT*" || sel_bike_model === "701 Enduro ABS *REAR*") {
			sel_year.empty().append(y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model == "CR 125 *FRONT*" || sel_bike_model === "CR 125 *REAR*") {
			sel_year.empty().append(y90 + y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04);
		} else if (sel_bike_model === "WRE 125 *FRONT*" || sel_bike_model === "WRE 125 *REAR*") {
			sel_year.empty().append(
				y90 + y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 +
				y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10
			);
		}

		else if (sel_bike_model === "CR 150 *FRONT*" || sel_bike_model === "CR 150 *REAR*") {
			sel_year.empty().append(y90 + y91 + y92);
		} else if (sel_bike_model == "CR 250 *FRONT*" || sel_bike_model === "CR 250 *REAR*" ) {
			sel_year.empty().append(y90 + y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04);
		} else if (sel_bike_model === "TE 250 *FRONT*" || sel_bike_model === "TE 250 *REAR*") {
			sel_year.empty().append(y90 + y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00 + y01 + y02 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "TE 300 *FRONT*" || sel_bike_model === "TE 300 *REAR*") {
			sel_year.empty().append(y90 + y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00 + y01 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "TX 250 *FRONT*" || sel_bike_model === "TX 250 *REAR*") {
			sel_year.empty().append(y17 + y18 + y19);
		} else if (sel_bike_model === "TX 300 *FRONT*" || sel_bike_model === "TX 300 *REAR*") {
			sel_year.empty().append(y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model == "TXC 250 *FRONT*" || sel_bike_model === "TXC 250 *REAR*") {
			sel_year.empty().append(y08 + y09 + y10 + y11 + y12);
		} else if (sel_bike_model == "WR 250 *FRONT*" || sel_bike_model === "WR 250 *REAR*") {
				sel_year.empty().append(y90 + y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10);
		} else if (sel_bike_model === "TC 300 *FRONT*" || sel_bike_model === "TC 300 *REAR*") {
			sel_year.empty().append(y23 + y24 + y25 + y26);
		}
		else if (sel_bike_model === "TC 85 *FRONT*" || sel_bike_model === "TC 85 *REAR*") {
			sel_year.empty().append(y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		}

		// TC 125
		else if (sel_bike_model === "TC 125 *FRONT*" || sel_bike_model === "TC 125 *REAR*") {
			sel_year.empty().append(y00 + y01 + y02 + y03 + y04 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		}

		// WR 360: 1990–2002
		else if (sel_bike_model === "WR 360 *FRONT*" || sel_bike_model === "WR 360 *REAR*") {
			sel_year.empty().append(
				y90 + y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 +
				y00 + y01 + y02
			);
		}

		// TC 410: 1995–2000
		else if (sel_bike_model === "TC 410 *FRONT*" || sel_bike_model === "TC 410 *REAR*") {
			sel_year.empty().append(y95 + y96 + y97 + y98 + y99 + y00);
		}

		// TE 410: 1995–2000
		else if (sel_bike_model === "TE 410 *FRONT*" || sel_bike_model === "TE 410 *REAR*") {
			sel_year.empty().append(y95 + y96 + y97 + y98 + y99 + y00);
		}

		// TC 450

		else if (sel_bike_model == "TC 450 *FRONT*" || sel_bike_model === "TC 450 *REAR*") {
			sel_year.empty().append(y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 +y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		}

		// TXC 450
		else if (sel_bike_model == "TXC 450 *FRONT*" || sel_bike_model === "TXC 450 *REAR*") {
			sel_year.empty().append(y08 + y09 + y10);
		}

		// FC450 and FE450
		else if (sel_bike_model === "FE450 *REAR*" && sel_bike_make == 'Husqvarna' || sel_bike_model === "FE450 *FRONT*" && sel_bike_make == 'Husqvarna' || sel_bike_model === "2014 - 17 FC450 *FRONT*" || sel_bike_model === "2014 - 17 FC450 *REAR*") {
			sel_year.empty().append(y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		}

		// FX450
		else if (sel_bike_model === "FX 450 *REAR*" && sel_bike_make == 'Husqvarna' || sel_bike_model === "FX 450 *FRONT*" && sel_bike_make == 'Husqvarna') {
			sel_year.empty().append(y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		}

		// TC510
		else if (sel_bike_model == "TC 510 *FRONT*" || sel_bike_model === "TC 510 *REAR*" ) {
			sel_year.empty().append(y90 + y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00);
		}

		// TE510
		else if (sel_bike_model == "TE 510 *FRONT*" || sel_bike_model === "TE 510 *REAR*") {
			sel_year.empty().append(y90 + y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10);
		}

		// TXC510
		else if (sel_bike_model == "TXC 510 *FRONT*" || sel_bike_model === "TXC 510 *REAR*") {
			sel_year.empty().append(y08 + y09 + y10);
		}

		else if (sel_bike_model === "TE 511 *FRONT*" || sel_bike_model === "TE 511 *REAR*") {
			sel_year.empty().append(y11 + y12 + y13);
		}

		else if (sel_bike_model === "TXC 511 *FRONT*" || sel_bike_model === "TXC 511 *REAR*") {
			sel_year.empty().append(y11 + y12);
		}

		else if (sel_bike_model === "FE 501 *FRONT*" || sel_bike_model === "FE 501 *REAR*") {
			sel_year.empty().append(
				y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26
			);
		}

		else if (sel_bike_model === "701 Enduro *FRONT*" || sel_bike_model === "701 Enduro *REAR*") {
			sel_year.empty().append(
				y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26
			);
		}

		else if (sel_bike_model === "NORDEN 901 *FRONT*" || sel_bike_model === "NORDEN 901 *REAR*") {
			sel_year.empty().append(y24 + y25 + y26);
		}


		//Model Husqvarna Rear
		else if (sel_bike_model === "SM 125 *REAR*" || sel_bike_model === "TXC 125 *REAR*" || sel_bike_model === "WR 125 *REAR*" || sel_bike_model === "SM 250 *REAR*" || sel_bike_model === "SM 450 *REAR*" || sel_bike_model === "TE 450 *REAR*" || sel_bike_model === "WR 450 *REAR*" || sel_bike_model === "CR 450 *REAR*" || sel_bike_model === "SM 510 *REAR*" || sel_bike_model === "WR 510 *REAR*" || sel_bike_model === "CR 510 *REAR*" || sel_bike_model === "SM 610 *REAR*" || sel_bike_model === "TC 610 *REAR*" || sel_bike_model === "TE 610 *REAR*" || sel_bike_model === "TXC 610 *REAR*" || sel_bike_model === "WR 610 *REAR*" || sel_bike_model === "CR 610 *REAR*") {
			sel_year.empty().append(y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13);
		} else if (sel_bike_model === "2014 - 17 TE300 *FRONT*" || sel_bike_model === "2014 - 17 TE300 *REAR*") {
			sel_year.empty().append(y90 + y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 +
									y00 + y01 +y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model == "FC 250 *FRONT*" || sel_bike_model === "2014 - 17 FC 250 *REAR*" || sel_bike_model === "FE 250 *FRONT*" || sel_bike_model === "2014 - 17 FE 250 *REAR*" || sel_bike_model === "2014 - 17 FE501 *FRONT*" || sel_bike_model === "2014 - 17 FE501 *REAR*") {
			sel_year.empty().append(y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model == "FC 350 *FRONT*" || sel_bike_model === "FC 350 *REAR*") {
			sel_year.empty().append(y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model == "FX 350 *FRONT*" || sel_bike_model === "FX 350 *REAR*") {
			sel_year.empty().append(y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		}
		
		else if (sel_bike_model === "2014 - 17 TC125 *REAR*" || sel_bike_model === "TC125 *FRONT*") {
			sel_year.empty().append(y00 + y01 + y02 + y03 + y04 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "TC 250 *FRONT*" || sel_bike_model === "TC 250 *REAR*") {
			sel_year.empty().append(y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "TE 125 *FRONT*" || sel_bike_model === "TE 125 *REAR*") {
			sel_year.empty().append(y14 + y15 + y16);
		} else if (sel_bike_model === "TE 150 *FRONT*" || sel_bike_model === "TE 150 *REAR*") {
			sel_year.empty().append(y20 + y21 + y22 + y23 + y24 + y25 + y26);
		}
		else if (sel_bike_model === "TE300I *REAR*" || sel_bike_model === "TE300I *FRONT*") {
			sel_year.empty().append(y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "TX125 *REAR*" || sel_bike_model === "TX125 *FRONT*") {
			sel_year.empty().append(y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "TE150 *REAR*" || sel_bike_model === "TE150 *FRONT*") {
			sel_year.empty().append(y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "TX300i *REAR*" || sel_bike_model === "TX300i *FRONT*" || sel_bike_model === "TE250I *FRONT*" || sel_bike_model === "TE250I *REAR*") {
			sel_year.empty().append(y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "FC450 Rockstar Edition *REAR*" || sel_bike_model === "FC450 Rockstar Edition *FRONT*") {
			sel_year.empty().append(y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "TX300 *REAR*" || sel_bike_model === "TX300 *FRONT*") {
			sel_year.empty().append(y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "TXC 310 *FRONT*" || sel_bike_model === "TXC 310 *REAR*") {
			sel_year.empty().append(y12);
		} else if (sel_bike_model === "FC350 *REAR*" || sel_bike_model === "FC350 *FRONT*" || sel_bike_model === "FE350 *FRONT*" && sel_bike_make == 'Husqvarna' || sel_bike_model === "FE350 *REAR*" && sel_bike_make == 'Husqvarna') {
			sel_year.empty().append(y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "FX350 *FRONT*" || sel_bike_model === "FX350 *REAR*") {
			sel_year.empty().append(y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		}


		//Model Honda Front
		else if (sel_bike_model === "1995 - 99 CR125, CR250 *FRONT*" || sel_bike_model === "2000 - 11 CR125, CR250 *FRONT*") {
			sel_year.empty().append(y87 + y88 + y89 + y90 + y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07);
		} else if (sel_bike_model === "2017+ CRF250L *FRONT*" || sel_bike_model === "2017+ CRF250L *REAR*") {
			sel_year.empty().append(y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20);
		} 
		else if (sel_bike_model === "CRF300L *REAR*" || sel_bike_model === "CRF300L ABS *REAR*" || sel_bike_model === "CRF300L Rally *REAR*" || sel_bike_model === "CRF300L *FRONT*" || sel_bike_model === "CRF300L ABS *FRONT*" || sel_bike_model === "CRF300L Rally *FRONT*") {
			sel_year.empty().append(y21 + y22 + y23 + y24 + y25 + y26);
		}
		else if (sel_bike_model === "CRF300L Rally ABS *FRONT*" || sel_bike_model === "CRF300L Rally ABS *REAR*") {
			sel_year.empty().append(y21 + y22 + y23 + y24 + y25 + y26);
		}
		else if (sel_bike_model === "2017+ CRF250L Rally *FRONT*" || sel_bike_model === "2017+ CRF250L Rally *REAR*") {
			sel_year.empty().append(y12 + y13 + y14+ y15 + y16 + y17 + y18 + y19 + y20);
		}
		else if (sel_bike_model === "2017+  CRF450RX *FRONT*" || sel_bike_model === "2017+ CRF450RX *REAR*") {
			sel_year.empty().append(y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} 
		 else if (sel_bike_model === "2017+ CRF250L Rally *FRONT*" || sel_bike_model === "2017+ CRF250L Rally *REAR*" || sel_bike_model === "2017+  CRF450RX *FRONT*" || sel_bike_model === "2017+ CRF450RX *REAR*") {
			sel_year.empty().append(y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		}
		else if (sel_bike_model === "2004 - 2017 CRF250X *FRONT*" || sel_bike_model === "2004 - 2017 CRF250X *REAR*") {
			sel_year.empty().append(y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24+ y25);
		} else if (sel_bike_model === "1996 - 04 XR250 *FRONT*" || sel_bike_model === "1996 - 04 XR400 *FRONT*") {
			sel_year.empty().append(y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04);
		} else if (sel_bike_model === "2002 - 14 CRF450R *FRONT*" || sel_bike_model === "2002 - 12 CRF450R *REAR*") {
			sel_year.empty().append(y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "CRF450L *REAR*" || sel_bike_model === "CRF450L *FRONT*") {
			sel_year.empty().append(y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "CRF450RL *REAR*" || sel_bike_model === "CRF450RL *FRONT*") {
			sel_year.empty().append(y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "2003 - 2017 CRF450X *FRONT*") {
			sel_year.empty().append(y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20+ y21+ y22+ y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "1995 - 01 CR500 *FRONT*") {
			sel_year.empty().append(y87 + y88 + y89 + y90 + y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00 + y01);
		} else if (sel_bike_model === "1991 - 00 XR600 *FRONT*") {
			sel_year.empty().append(y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00);
		} else if (sel_bike_model === "1993 - 2017 XR650L *FRONT*") {
			sel_year.empty().append(y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "1993 - 2017 XR650L *REAR*") {
			sel_year.empty().append(y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "2000 - 08 XR650R *FRONT*") {
			sel_year.empty().append(y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07);
		} else if (sel_bike_model === "CRF250F *FRONT*" || sel_bike_model === "CRF250F *REAR*") {
			sel_year.empty().append(y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "2004 - 14 CRF250R *FRONT*" ||  sel_bike_model === "2004 - 13 CRF250R *REAR*" ) {
			sel_year.empty().append(y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24+ y25 + y26);
		} else if (sel_bike_model === "XR400R *FRONT*" || sel_bike_model === "XR400R *REAR*") {
			sel_year.empty().append(y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04);
		} else if (sel_bike_model === "CRF450RWE *FRONT*" || sel_bike_model === "CRF450RWE *REAR*") {
			sel_year.empty().append(y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24+ y25 + y26);
		} else if (sel_bike_model === "CRF250L RALLY ABS *FRONT*" || sel_bike_model === "CRF250L RALLY ABS *REAR*") {
			sel_year.empty().append(y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20);
		}


		// Kawasaki KLR650 Gens
		else if (sel_bike_model === "KLR650 Gen 1 *FRONT*" || sel_bike_model === "KLR650 Gen 1 *REAR*") {
			sel_year.empty().append(y87 + y88 + y89 + y90 + y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07);
		}

		else if (sel_bike_model === "KLR650 Gen 2 *FRONT*" || sel_bike_model === "KLR650 Gen 2 *REAR*") {
			sel_year.empty().append(y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18);
		}

		else if (sel_bike_model === "KLR650 Gen 3 *FRONT*" || sel_bike_model === "KLR650 Gen 3 *REAR*") {
			sel_year.empty().append(y22 + y23 + y24 + y25 + y26);
		}

		else if (sel_bike_model === "XR600R *FRONT*" || sel_bike_model === "XR600R *REAR*") {
			sel_year.empty().append(y87 + y88 + y89 + y90 + y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00);
		}

		//Model Honda REAR
		else if (sel_bike_model === "1989 - 97 CR125, CR250 *REAR*" || sel_bike_model === "2000 - 12 CR125, CR250 *REAR*") {
			sel_year.empty().append(y87 + y88 + y89 + y90 + y91 + y92 + y93 + y94);
		} else if (sel_bike_model === "1996 - 04 XR 250 *REAR*" || sel_bike_model === "1996 - 04 XR 400 *REAR*") {
			sel_year.empty().append(y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04);
		} else if (sel_bike_model === "2002 - 2017 CRF450X *REAR*") {
			sel_year.empty().append(y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20+ y21+ y22+ y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "1989 - 01 CR500 *REAR*") {
			sel_year.empty().append(y87 + y88 + y89 + y90 + y91 + y92 + y93 + y94);
		} else if (sel_bike_model === "1993 - 00 XR600 *REAR*") {
			sel_year.empty().append(y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00);
		} else if (sel_bike_model === "2000 - 08 XR650R *REAR*") {
			sel_year.empty().append(y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07);
		} else if (sel_bike_model === "CRF250L ABS *REAR*" || sel_bike_model === "CRF250L ABS *FRONT*") {
			sel_year.empty().append(y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20);
		}
		else if (sel_bike_model === "CRF450R Works Edition *REAR*" || sel_bike_model === "CRF450R Works Edition *FRONT*") {
			sel_year.empty().append(y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25);
		}

		else if (sel_bike_model === "CRF250RX *REAR*" || sel_bike_model === "CRF250RX *FRONT*" ) {
			sel_year.empty().append(y19 + y20 + y21 + y22 + y23 + y24 + y25) + y26;
		}
		else if (sel_bike_model === "CRF250RX *REAR*" || sel_bike_model === "CRF250RX *FRONT*" || sel_bike_model === "CRF450R Works Edition *REAR*" || sel_bike_model === "CRF450R Works Edition *FRONT*") {
			sel_year.empty().append(y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "CRF250RWE *FRONT*" || sel_bike_model === "CRF250RWE *REAR*") {
			sel_year.empty().append(y26);
		} else if (sel_bike_model === "XR250R *FRONT*" || sel_bike_model === "XR250R *REAR*") {
			sel_year.empty().append(y87 + y88 + y89 + y90 + y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04);
		}


		//Model Yamaha Front
		// else if (sel_bike_model === "1999 - 2000 WR400 *FRONT*") {
		// 	sel_year.empty().append(y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15);
		// } else if (sel_bike_model === "2008 - 17 WR250R (street legal) *FRONT*" || sel_bike_model === "2008 - 17 WR250R (street legal) *REAR*") {
		// 	sel_year.empty().append(y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		// } else if (sel_bike_model === "2008 - 17 WR250X (street legal converts to 21\") *FRONT*") {
		// 	sel_year.empty().append(y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16);
		// } else if (sel_bike_model === "WR450F *FRONT*" || sel_bike_model === "2003 - 17 WR450F *REAR*") {
		// 	sel_year.empty().append(y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		// } else if (sel_bike_model === "YZ125 *FRONT*" || sel_bike_model === "YZ250 *FRONT*" || sel_bike_model === "1986 - 98 YZ125, YZ250 *REAR*" || sel_bike_model === "1999 - 2017 YZ125, YZ250 *REAR*") {
		// 	sel_year.empty().append(y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		// } else if (sel_bike_model === "YZ250R *FRONT*" || sel_bike_model === "YZ125R *FRONT*") {
		// 	sel_year.empty().append(y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		// } else if (sel_bike_model === "2017+ YZ250FX *FRONT*" || sel_bike_model === "2015 - 2017 YZ250FX *REAR*") {
		// 	sel_year.empty().append(y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		// } else if (sel_bike_model === "1999 YZ400F *FRONT*") {
		// 	sel_year.empty().append(y98);
		// } else if (sel_bike_model === "2000 - 2013 YZ426F/YZ450F *FRONT*") {
		// 	sel_year.empty().append(y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13);
		// } else if (sel_bike_model === "2014 - 2015 YZ250F/YZ450F *FRONT*" || sel_bike_model === "2009 - 15 YZ450F *REAR*") {
		// 	sel_year.empty().append(y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		// } else if (sel_bike_model === "2017+ YZ250X *FRONT*" || sel_bike_model === "2016 - 2017 YZ250X *REAR*") {
		// 	sel_year.empty().append(y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		// } else if (sel_bike_model === "2016 - 2017 YZ450FX *FRONT*" || sel_bike_model === "2016 - 2017 YZ450FX *REAR*") {
		// 	sel_year.empty().append(y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		// } else if (sel_bike_model === "2009 - 17 YZ250F *REAR*" || sel_bike_model === "2001 - 13 YZ250F *FRONT*") {
		// 	sel_year.empty().append(y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		// } else if (sel_bike_model === "WR250F *FRONT*" || sel_bike_model === "2001 - 17 WR250F *REAR*") {
		// 	sel_year.empty().append(y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		// }


		//Model Yamaha REAR
		// else if (sel_bike_model === "2008 - 16 WR250X (street legal converts to 18\") *REAR*") {
		// 	sel_year.empty().append(y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16);
		// } else if (sel_bike_model === "1999 - 02 WR400/WR426 *REAR*" || sel_bike_model === "1999 - 02 WR426 *REAR*") {
		// 	sel_year.empty().append(y00 + y01 + y02);
		// } else if (sel_bike_model === "1999 YZ400F *REAR*") {
		// 	sel_year.empty().append(y98 + y99);
		// } else if (sel_bike_model === "2000 - 08 YZ426F *REAR*") {
		// 	sel_year.empty().append(y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08);
		// } else if (sel_bike_model === "WR426 *REAR*" || sel_bike_model === "WR426 *FRONT*") {
		// 	sel_year.empty().append(y01 + y02);
		// }

		// Yamaha Models update

		else if (sel_bike_model === "YZ125 *FRONT*" || sel_bike_model === "YZ 125 *REAR*") {
			sel_year.empty().append(
				y86 + y87 + y88 + y89 + y90 + y91 + y92 +
				y93 + y94 + y95 + y96 + y97 + y98 + y99 +
				y00 + y01 + y02 + y03 + y04 + y05 + y06 +
				y07 + y08 + y09 + y10 + y11 + y12 + y13 +
				y14 + y15 + y16 + y17 + y18 + y19 + y20 +
				y21 + y22 + y23 + y24 + y25 + y26
			);
		} else if (sel_bike_model ===  "YZ125 Monster Energy Yamaha Racing Edition *FRONT*" || sel_bike_model ===  "YZ125 Monster Energy Yamaha Racing Edition *REAR*") {
			sel_year.empty().append(y19 + y20 + y21 + y22 + y23 + y24 + y25);
		}
				// YZ125 50th Anniversary Edition (2024)
		else if (sel_bike_model === "YZ125 50th Anniversary Edition *FRONT*" || sel_bike_model === "YZ125 50th Anniversary Edition *REAR*") {
			sel_year.empty().append(y24);
		}

		// YZ125 70th Anniversary Edition (2026)
		else if (sel_bike_model === "YZ125 70th Anniversary Edition *FRONT*" || sel_bike_model === "YZ125 70th Anniversary Edition *REAR*") {
			sel_year.empty().append(y26);
		}

		// YZ125X (2017–2026)
		else if (sel_bike_model === "YZ125X *FRONT*" || sel_bike_model === "YZ125X *REAR*") {
			sel_year.empty().append(
				y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26
			);
		}

		// WR250F (2001–2026)
		else if (sel_bike_model === "WR250F *FRONT*" || sel_bike_model === "WR250F *REAR*") {
			sel_year.empty().append(
				y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 +
				y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 +
				y21 + y22 + y23 + y24 + y25 + y26
			);
		}

		// WR250R (2008–2020)
		else if (sel_bike_model === "WR250R *FRONT*" || sel_bike_model === "WR250R *REAR*") {
			sel_year.empty().append(
				y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 +
				y18 + y19 + y20
			);
		}

		// WR250X (2008–2012)
		else if (sel_bike_model === "WR250X *FRONT*" || sel_bike_model === "WR250X *REAR*") {
			sel_year.empty().append(
				y08 + y09 + y10 + y11 + y12
			);
		}

		// YZ250 (1986–2026)
		else if (sel_bike_model === "YZ250 *FRONT*" || sel_bike_model === "YZ250 *REAR*") {
			sel_year.empty().append(
				y86 + y87 + y88 + y89 + y90 + y91 + y92 + y93 + y94 + y95 +
				y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 +
				y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 +
				y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26
			);
		}

		// YZ250 Monster Energy (2019–2025)
		else if (sel_bike_model === "YZ250 Monster Energy Yamaha Racing Edition *FRONT*" || sel_bike_model === "YZ250 Monster Energy Yamaha Racing Edition *REAR*") {
			sel_year.empty().append(
				y19 + y20 + y21 + y22 + y23 + y24 + y25
			);
		}

		// YZ250 50th Anniversary (2024)
		else if (sel_bike_model === "YZ250 50th Anniversary Edition *FRONT*" || sel_bike_model === "YZ250 50th Anniversary Edition *REAR*") {
			sel_year.empty().append(y24);
		}

		// YZ250 70th Anniversary (2026)
		else if (sel_bike_model === "YZ250 70th Anniversary Edition *FRONT*" || sel_bike_model === "YZ250 70th Anniversary Edition *REAR*") {
			sel_year.empty().append(y26);
		}

		// YZ250F (2001–2026)
		else if (sel_bike_model === "YZ250F *FRONT*" || sel_bike_model === "YZ250F *REAR*") {
			sel_year.empty().append(
				y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 +
				y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 +
				y21 + y22 + y23 + y24 + y25 + y26
			);
		}

		// YZ250F Monster Energy (2019–2025)
		else if (sel_bike_model === "YZ250F Monster Energy Yamaha Racing Edition *FRONT*" || sel_bike_model === "YZ250F Monster Energy Yamaha Racing Edition *REAR*") {
			sel_year.empty().append(
				y19 + y20 + y21 + y22 + y23 + y24 + y25
			);
		}

		// YZ250F 50th Anniversary (2024)
		else if (sel_bike_model === "YZ250F 50th Anniversary Edition *FRONT*" || sel_bike_model === "YZ250F 50th Anniversary Edition *REAR*") {
			sel_year.empty().append(y24);
		}

		// YZ250F 70th Anniversary (2026)
		else if (sel_bike_model === "YZ250F 70th Anniversary Edition *FRONT*" || sel_bike_model === "YZ250F 70th Anniversary Edition *REAR*") {
			sel_year.empty().append(y26);
		}

		// YZ250FX (2015–2026)
		else if (sel_bike_model === "YZ250FX *FRONT*" || sel_bike_model === "YZ250FX *REAR*") {
			sel_year.empty().append(
				y15 + y16 + y17 + y18 + y19 + y20 +
				y21 + y22 + y23 + y24 + y25 + y26
			);
		}

		// YZ250X (2016–2026)
		else if (sel_bike_model === "YZ250X *FRONT*" || sel_bike_model === "YZ250X *REAR*") {
			sel_year.empty().append(
				y16 + y17 + y18 + y19 + y20 +
				y21 + y22 + y23 + y24 + y25 + y26
			);
		}

		// WR400 (2000–2002)
		else if (sel_bike_model === "WR400 *FRONT*" || sel_bike_model === "WR400 *REAR*") {
			sel_year.empty().append(y00 + y01 + y02);
		}

		// WR426F (2000–2002)
		else if (sel_bike_model === "WR426F *FRONT*" || sel_bike_model === "WR426F *REAR*") {
			sel_year.empty().append(y00 + y01 + y02);
		}

		// YZ426F (2000–2008)
		else if (sel_bike_model === "YZ426F *FRONT*" || sel_bike_model === "YZ426F *REAR*") {
			sel_year.empty().append(
				y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08
			);
		}

		// WR450F (1998–2026)
		else if (sel_bike_model === "WR450F *FRONT*" || sel_bike_model === "WR450F *REAR*") {
			sel_year.empty().append(
				y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 +
				y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 +
				y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26
			);
		}

		// YZ450F (1998–2026)
		else if (sel_bike_model === "YZ450F *FRONT*" || sel_bike_model === "YZ450F *REAR*") {
			sel_year.empty().append(
				y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 +
				y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 +
				y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26
			);
		}

		// YZ450F Monster Energy (2019–2025)
		else if (sel_bike_model === "YZ450F Monster Energy Yamaha Racing Edition *FRONT*" || sel_bike_model === "YZ450F Monster Energy Yamaha Racing Edition *REAR*") {
			sel_year.empty().append(
				y19 + y20 + y21 + y22 + y23 + y24 + y25
			);
		}

		// YZ450F 50th Anniversary (2024)
		else if (sel_bike_model === "YZ450F 50th Anniversary Edition *FRONT*" || sel_bike_model === "YZ450F 50th Anniversary Edition *REAR*") {
			sel_year.empty().append(y24);
		}

		// YZ450F 70th Anniversary (2026)
		else if (sel_bike_model === "YZ450F 70th Anniversary Edition *FRONT*" || sel_bike_model === "YZ450F 70th Anniversary Edition *REAR*") {
			sel_year.empty().append(y26);
		}

		// YZ450FX (2016–2026)
		else if (sel_bike_model === "YZ450FX *FRONT*" || sel_bike_model === "YZ450FX *REAR*") {
			sel_year.empty().append(
				y16 + y17 + y18 + y19 + y20 +
				y21 + y22 + y23 + y24 + y25 + y26
			);
		}



		//Model Kawasaki FRONT
		else if (sel_bike_model === "2003 - 05 KX125 *FRONT*") {
			sel_year.empty().append(y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05);
		} else if (sel_bike_model === "2003 - 13 KX250 *FRONT*") {
			sel_year.empty().append(y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07);
		} else if (sel_bike_model === "2004 - 14 KX250F  *FRONT*" || sel_bike_model === "2004 - 17 KX250F  *REAR*") {
			sel_year.empty().append(y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "KX250XC *FRONT*" || sel_bike_model === "KX250XC *REAR*") {
			console.log("DEBUG: Selected model:", JSON.stringify(sel_bike_model));
			sel_year.empty().append(y21 + y22);
		} else if (sel_bike_model === "2000 - 07 KLX400 *FRONT*") {
			sel_year.empty().append(y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07);
		} else if (sel_bike_model === "2006 - 14 KX450F/KLX450R *FRONT*" || sel_bike_model === "2006 - 17 KX450F *REAR*") {
			sel_year.empty().append(y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "KDX 200 *REAR*" || sel_bike_model === "KDX 220 *REAR*") {
			sel_year.empty().append(y89 + y90 + y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06);
		} else if (sel_bike_model === "KDX 250 *REAR*") {
			sel_year.empty().append(y81 + y82 + y83 + y84 + y85 + y86 + y87 + y88 + y89 + y90 + y91 + y92 + y93 + y94);
		} else if (sel_bike_model === "KX450XC *FRONT*" || sel_bike_model === "KX450XC *REAR*") {
			sel_year.empty().append(y21 + y22);
		} else if (sel_bike_model === "KLX450R *FRONT*") {
			sel_year.empty().append(y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14);
		} else if (sel_bike_model === "1994 - 04 KX500 *FRONT*") {
			sel_year.empty().append(y87 + y88 + y89 + y90 + y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04);
		} else if (sel_bike_model === "KLX 300R *FRONT*" || sel_bike_model === "KLX 300R *REAR*") {
			sel_year.empty().append(y20 + y21 + y22 + y23 + y24 + y25 + y26 );
		} else if (sel_bike_model === "KLR650 *FRONT*" || sel_bike_model === "KLR650 *REAR*") {
			sel_year.empty().append(y87 + y88 + y89 + y90 + y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "KX250X *FRONT*") {
			sel_year.empty().append(y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "KX450X *FRONT*" || sel_bike_model === "KX450X *REAR*") {
			sel_year.empty().append(y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "KX450X *FRONT*" || sel_bike_model === "KX450X *REAR*") {
			sel_year.empty().append(y21 + y22 + y23 + y24 + y25 + y26);
		}




		//Model Kawasaki Rear
		else if (sel_bike_model === "2003 - 06 KX125 *REAR*") {
			sel_year.empty().append(y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05);
		} else if (sel_bike_model === "2003 - 13 KX250 *REAR*") {
			sel_year.empty().append(y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07);
		} else if (sel_bike_model === "2000 - 07 KLX400 *REAR*") {
			sel_year.empty().append(y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07);
		} else if (sel_bike_model === "2007 - 09 KLX450R *REAR*") {
			sel_year.empty().append(y07 + y08 + y09);
		} else if (sel_bike_model === "1990 - 04 KX500 *REAR*") {
			sel_year.empty().append(y87 + y88 + y89 + y90 + y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04);
		} else if (sel_bike_model === "KDX200 *REAR*") {
			sel_year.empty().append(y89 + y90 + y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06);
		} else if (sel_bike_model === "KDX220 *REAR*") {
			sel_year.empty().append(
				y89 + y90 + y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 +
				y00 + y01 + y02 + y03 + y04 + y05 + y06
			);
		} else if (sel_bike_model === "KDX250 *REAR*") {
			sel_year.empty().append(
				y81 + y82 + y83 + y84 + y85 + y86 + y87 + y88 + y89 +
				y90 + y91 + y92 + y93 + y94
			);
		} else if (sel_bike_model === "KX250X *REAR*") {
			sel_year.empty().append(y21 + y22 + y23 + y24 + y25 + y26);
		}


		// Triumph
		else if (sel_bike_model == "TF250-X *FRONT*" || sel_bike_model == "TF250-X *REAR*" || sel_bike_model == "TF250-RC *FRONT*" || sel_bike_model == "TF250-RC *REAR*"){
			sel_year.empty().append(y25 + y26);						
		} else if (sel_bike_model === "TF250-E *FRONT*" || sel_bike_model === "TF250-E *REAR*") {
			sel_year.empty().append(y25 + y26);
		} else if (sel_bike_model === "TF450-E *FRONT*" || sel_bike_model === "TF450-E *REAR*") {
			sel_year.empty().append(y25 + y26);
		}

		else if (sel_bike_model === "TF450-RC *FRONT*" || sel_bike_model === "TF450-RC *REAR*") {
			sel_year.empty().append(y25 + y26);
		}

		//Model KTM FRONT and REAR ktm-years
		// New Models added as per arrons email 10/4/2024
		else if (sel_bike_model === "500 EXC *FRONT*" || sel_bike_model === "500 EXC *REAR*") {
			sel_year.empty().append(y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25);
		} else if (sel_bike_model === "500 EXC-F *FRONT*" || sel_bike_model === "500 EXC-F *REAR*") {
			sel_year.empty().append(y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "500 XCF-W *FRONT*" || sel_bike_model === "500 XCF-W *REAR*") {
			sel_year.empty().append(y20 + y21 + y22);
		} else if (sel_bike_model === "500 XC-W *FRONT*" || sel_bike_model === "500 XC-W *REAR*") {
			sel_year.empty().append(y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "XC 125 *FRONT*" || sel_bike_model === "XC 125 *REAR*") {
			sel_year.empty().append(y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15);
		} else if (sel_bike_model === "EXC 150 *FRONT*" || sel_bike_model === "EXC 150 *REAR*") {
			sel_year.empty().append(y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "EXC 250 *FRONT*" || sel_bike_model === "EXC 250 *REAR*") {
			sel_year.empty().append(y90 + y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "EXC 250 Six Days *FRONT*" || sel_bike_model === "EXC 250 Six Days *REAR*") {
			sel_year.empty().append(y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "SX-F 250 Factory Edition *FRONT*" || sel_bike_model === "SX-F 250 Factory Edition *REAR*") {
			sel_year.empty().append(y15 + y22);
		} else if (sel_bike_model === "EXC 300 Six Days *FRONT*" || sel_bike_model === "EXC 300 Six Days *REAR*") {
			sel_year.empty().append(
				y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 +
				y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 +
				y20 + y21 + y22 + y23 + y24 + y25 + y26
			);
		} else if (sel_bike_model === "EXC-F 350 Six Days *FRONT*" || sel_bike_model === "EXC-F 350 Six Days *REAR*") {
			sel_year.empty().append(y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "EXC-F 350 Erzbergrodeo *FRONT*" || sel_bike_model === "EXC-F 350 Erzbergrodeo *REAR*") {
			sel_year.empty().append(y19 + y20 + y21 + y22);
		} else if (sel_bike_model === "SX-F 350 *FRONT*" || sel_bike_model === "SX-F 350 *REAR*") {
			sel_year.empty().append(y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "XC-F 350 *FRONT*" || sel_bike_model === "XC-F 350 *REAR*") {
			sel_year.empty().append(y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "EXC 400 *FRONT*" || sel_bike_model === "EXC 400 *REAR*") {
			sel_year.empty().append(y90 + y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07);
		} else if (sel_bike_model === "EXC-F 450 *FRONT*" || sel_bike_model === "EXC-F 450 *REAR*") {
			sel_year.empty().append(
				y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 +
				y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 +
				y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26
			);
		} else if (sel_bike_model === "SX-F450 *FRONT*" || sel_bike_model === "SX-F450 *REAR*") {
			sel_year.empty().append(
				y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 +
				y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 +
				y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26
			);
		} else if (sel_bike_model === "EXC-F500 Six Days *FRONT*" || sel_bike_model === "EXC-F500 Six Days *REAR*") {
			sel_year.empty().append(y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "EXC-F 500 Erzbergrodeo *FRONT*" || sel_bike_model === "EXC-F 500 Erzbergrodeo *REAR*") {
			sel_year.empty().append(y19 + y20 + y21 + y22);
		} else if (sel_bike_model === "790 Adventure R Rally *FRONT*" || sel_bike_model === "790 Adventure R Rally *REAR*") {
			sel_year.empty().append(y20);
		} else if (sel_bike_model === "790 Adventure *FRONT*" || sel_bike_model === "790 Adventure *REAR*") {
			sel_year.empty().append(y18 + y19 + y20 + y21 + y22 + y23 + y24);  
		} else if (sel_bike_model === "890 Adventure L *FRONT*" || sel_bike_model === "890 Adventure L *REAR*") {
			sel_year.empty().append(y23 + y24 + y25 + y26);
		} else if (sel_bike_model === '890 Adventure *FRONT*' || sel_bike_model === '890 Adventure *REAR*') {
			sel_year.empty().append(y21 + y22 + y23 + y24 + y25 + y26);			
		} else if (sel_bike_model === "890 Adventure R Rally *FRONT*" || sel_bike_model === "890 Adventure R Rally *REAR*") {
			sel_year.empty().append(y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "1190 Adventure R *FRONT*" || sel_bike_model === "1190 Adventure R *REAR*") {
			sel_year.empty().append(y13 + y14);
		} else if (sel_bike_model === "1290 Super Adventure *FRONT*" || sel_bike_model === "1290 Super Adventure *REAR*") {
			sel_year.empty().append(y15 + y16);
		} else if (sel_bike_model === "1290 Super Adventure R *FRONT*" || sel_bike_model === "1290 Super Adventure R *REAR*") {
			sel_year.empty().append(y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "950 Adventure S *FRONT*" || sel_bike_model === "950 Adventure S *REAR*") {
			sel_year.empty().append(y04 + y05 + y06);
		} else if (sel_bike_model === "990 Adventure Baja *FRONT*" || sel_bike_model === "990 Adventure Baja *REAR*") {
			sel_year.empty().append(y13);
		} else if (sel_bike_model === "990 Adventure *FRONT*" || sel_bike_model === "990 Adventure *REAR*") {
			sel_year.empty().append(y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13);
		} else if (sel_bike_model === "990 Adventure Dakar *FRONT*" || sel_bike_model === "990 Adventure Dakar *REAR*") {
			sel_year.empty().append(y11);
		} else if (sel_bike_model === "990 Adventure R *FRONT*" || sel_bike_model === "990 Adventure R *REAR*") {
			sel_year.empty().append(y09 + y10 + y11 + y12 + y13);
		}



		// Model Kayo
		else if (sel_bike_model === "T4 230 *FRONT*" || sel_bike_model === "T4 230 *REAR*") {
			sel_year.empty().append(y20 + y21 + y22 + y23 + y24 + y25);
		}

		else if (sel_bike_model === "SX 85 *FRONT*" || sel_bike_model === "SX 85 *REAR*") {
			sel_year.empty().append(y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		}


		// New Models added as per arrons email 10/4/2024
		else if (sel_bike_model === "EXC125 *FRONT*" || sel_bike_model === "EXC125 *REAR*") {
			sel_year.empty().append(y90 + y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 +
									y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 +
									y10 + y11 + y12 + y13 + y14 + y15 + y16);
		} else if (sel_bike_model === "EXC200 *FRONT*" || sel_bike_model === "EXC200 *REAR*") {
			sel_year.empty().append(y90 + y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16);
		} else if (sel_bike_model === "EXC-F250 *FRONT*" || sel_bike_model === "EXC-F250 *REAR*") {
			sel_year.empty().append(y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "EXC300 *FRONT*" || sel_bike_model === "EXC300 *REAR*") {
			sel_year.empty().append(y90 + y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 +
									y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 +
									y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 +
									y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "SX250 *FRONT*" || sel_bike_model === "SX250 *REAR*") {
			sel_year.empty().append(y90 + y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 +
									y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 +
									y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 +
									y20 + y21 + y22 + y23 + y24 + y25 + y26);
		}  else if (sel_bike_model === "SX125 *FRONT*" ||  sel_bike_model === "SX125 *REAR*") {
			sel_year.empty().append(y90 + y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 +
									y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 +
									y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 +
									y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "EXC380 *FRONT*" || sel_bike_model === "EXC380 *REAR*") {
			sel_year.empty().append(y98 + y99 + y00 + y01 + y02 + y03);
		} else if (sel_bike_model === "EXC400 *FRONT*" || sel_bike_model === "EXC400 *REAR*") {
			sel_year.empty().append(y00 + y01 + y02 + y03 + y04 + y05 + y06);
		} else if (sel_bike_model === "SX400 *FRONT*" || sel_bike_model === "SX520 *FRONT*" || sel_bike_model === "SX400 *REAR*" || sel_bike_model === "SX520 *REAR*") {
			sel_year.empty().append(y00 + y01 + y02);
		} else if (sel_bike_model === "SXC400 *FRONT*" || sel_bike_model === "SXC400 *REAR*") {
			sel_year.empty().append(y98 + y99 + y00 + y01);
		} else if (sel_bike_model === "XC450 *FRONT*" || sel_bike_model === "XC450 *REAR*") {
			sel_year.empty().append(y03 + y04 + y05 + y06 + y07 + y08 + y09);
		} else if (sel_bike_model === "XC-W450 *FRONT*" || sel_bike_model === "XC-W450 *REAR*") {
			sel_year.empty().append(y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "EXC450 *FRONT*" || sel_bike_model === "EXC450 *REAR*") {
			sel_year.empty().append(y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11);
		} else if (sel_bike_model === "EXC350 *FRONT*" || sel_bike_model === "EXC350 *REAR*") {
			sel_year.empty().append(y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "EXC-F500 *FRONT*" || sel_bike_model === "EXC-F500 *REAR*") {
			sel_year.empty().append(y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "EXC525 *FRONT*" || sel_bike_model === "SX525 *FRONT*" || sel_bike_model === "EXC525 *REAR*" || sel_bike_model === "SX525 *REAR*") {
			sel_year.empty().append(y03 + y04 + y05 + y06 + y07);
		} else if (sel_bike_model === "EXC-R530 *FRONT*" || sel_bike_model === "SX-F505 *FRONT*" || sel_bike_model === "EXC-R530 *REAR*" || sel_bike_model === "SX-F505 *REAR*") {
			sel_year.empty().append(y08 + y09);
		} else if (sel_bike_model === "EXC530 *FRONT*" || sel_bike_model === "EXC530 *REAR*") {
			sel_year.empty().append(y08 + y09 + y10 + y11);
		} else if (sel_bike_model === "XC150 *FRONT*" || sel_bike_model === "XC150 *REAR*") {
			sel_year.empty().append(y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "XC-W150 *FRONT*" || sel_bike_model === "XC-W150 *REAR*") {
			sel_year.empty().append(y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "XC200 *FRONT*" || sel_bike_model === "XC-W200 *FRONT*" || sel_bike_model === "XC200 *REAR*" || sel_bike_model === "XC-W200 *REAR*") {
			sel_year.empty().append(y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16);
		} 
		else if (sel_bike_model === "XC250 *FRONT*" || sel_bike_model === "XC250 *REAR*") {
				sel_year.empty().append(
											y06 + y07 + y08 + y09 +
											y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 +
											y20 + y21 + y22 + y23 + y24 + y25 + y26
										);
		}
		else if (sel_bike_model === "XC300 *FRONT*" || sel_bike_model === "XC300 *REAR*") {
			sel_year.empty().append(y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		}
		else if (sel_bike_model === "XC-W300 *FRONT*" || sel_bike_model === "XC-W300 *REAR*") {
			sel_year.empty().append(y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "XC-W250 *FRONT*" || sel_bike_model === "XC-W250 *REAR*") {
			sel_year.empty().append(y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 +y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "XC-F250 *FRONT*" || sel_bike_model === "XC-F250 *REAR*") {
			sel_year.empty().append(y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "XC400 *FRONT*" || sel_bike_model === "XC400 *REAR*") {
			sel_year.empty().append(y08 + y09 + y10 + y11 + y12);
		} else if (sel_bike_model === "XC-W400 *FRONT*" || sel_bike_model === "XC-W400 *REAR*") {
			sel_year.empty().append(y07 + y08 + y09 + y10 + y11 + y12);
		} else if (sel_bike_model === "XC525 *FRONT*" || sel_bike_model === "XC-W525 *FRONT*" || sel_bike_model === "XC525 *REAR*" || sel_bike_model === "XC-W525 *REAR*") {
			sel_year.empty().append(y06 + y07);
		} else if (sel_bike_model === "XC530 *FRONT*" || sel_bike_model === "XC-W530 *FRONT*" || sel_bike_model === "XC530 *REAR*" || sel_bike_model === "XC-W530 *REAR*") {
			sel_year.empty().append(y08 + y09 + y10 + y11);
		} else if (sel_bike_model === "SX144 *FRONT*" || sel_bike_model === "SX144 *REAR*") {
			sel_year.empty().append(y07 + y08);
		} else if (sel_bike_model === "SX150 *FRONT*" || sel_bike_model === "SX150 *REAR*") {
			sel_year.empty().append(y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "SX200 *FRONT*" || sel_bike_model === "SX200 *REAR*") {
			sel_year.empty().append(y03 + y04);
		} 
		else if (sel_bike_model === "SXF250 *FRONT*" || sel_bike_model === "SXF250 *REAR*") {
				sel_year.empty().append(
											y05 + y06 + y07 + y08 + y09 +
											y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 +
											y20 + y21 + y22 + y23 + y24 + y25 + y26
										);
		}
		else if (sel_bike_model === "SXF350 *FRONT*" || sel_bike_model === "SXF350 *REAR*") {
			sel_year.empty().append(y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "SX380 *FRONT*" || sel_bike_model === "SX380 *REAR*") {
			sel_year.empty().append(y98 + y99 + y00 + y01 + y02);
		} else if (sel_bike_model === "XC400 *FRONT*" || sel_bike_model === "XC400 *REAR*") {
			sel_year.empty().append(y98 + y99 + y00 + y01);
		} else if (sel_bike_model === "SX-RFS450 *FRONT*" || sel_bike_model === "SX-RFS450 *REAR*") {
			sel_year.empty().append(y03 + y04 + y05 + y06);
		} else if (sel_bike_model === "SX-F450 *FRONT*" || sel_bike_model === "SX-F450 *REAR*") {
			sel_year.empty().append(y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "Varg *FRONT*" || sel_bike_model === "Varg *REAR*") {
			sel_year.empty().append(y23 + y24);
		} else if (sel_bike_model === "SXC625 *FRONT*" || sel_bike_model === "SXC625 *REAR*") {
			sel_year.empty().append(y03 + y04 + y05);
		} else if (sel_bike_model === "690 Enduro *FRONT*" || sel_bike_model === "2008 – 2013 KTM 690 ENDURO * REAR *") {
			sel_year.empty().append(y08 + y09 + y10 + y11 + y12 + y13);
		} else if (sel_bike_model === "690 Enduro ABS *FRONT*" || sel_bike_model === "2014 – 2017 KTM 690 ENDURO ABS * REAR *") {
			sel_year.empty().append(y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "XCF-W350 *FRONT*" || sel_bike_model === "XCF-W350 *REAR*") {
			sel_year.empty().append(y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "XC-F350 *REAR*" || sel_bike_model === "XC-F350 *FRONT*") {
			sel_year.empty().append(y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "XC-W500 *FRONT*" || sel_bike_model === "XC-W500 *REAR*") {
			sel_year.empty().append(y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "EXC-F350 *FRONT*" || sel_bike_model === "EXC-F350 *REAR*") {
			sel_year.empty().append(y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "EXC520 *FRONT*" || sel_bike_model === "EXC520 *REAR*") {
			sel_year.empty().append(y00 + y01 + y02);
		} else if (sel_bike_model === "XC-W250 TPI *FRONT*" || sel_bike_model === "XC-W250 TPI *REAR*") {
			sel_year.empty().append(y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "XCF-W250 *FRONT*" || sel_bike_model === "XCF-W250 *REAR*") {
			sel_year.empty().append(y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "XC-W300 TPI *FRONT*" || sel_bike_model === "XC-W300 TPI *REAR*") {
			sel_year.empty().append(y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "XC-F450 *FRONT*" || sel_bike_model === "XC-F450 *REAR*") {
			sel_year.empty().append(y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "XC-F505 *FRONT*" || sel_bike_model === "XC-F505 *REAR*") {
			sel_year.empty().append(y08 + y09);
		} else if (sel_bike_model === "SX450 *FRONT*" || sel_bike_model === "SX450 *REAR*") {
			sel_year.empty().append(y04 + y05 + y06);
		} else if (sel_bike_model === "790 Adventure *FRONT*" || sel_bike_model === "790 Adventure *REAR*") {
			sel_year.empty().append(y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "890 Adventure *FRONT*" || sel_bike_model === "890 Adventure *REAR*" || sel_bike_model === "890 Adventure R *REAR*" || sel_bike_model === "890 Adventure R *FRONT*") {
			sel_year.empty().append(y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "950 Adventure *FRONT*" || sel_bike_model === "950 Adventure *REAR*") {
			sel_year.empty().append(y04 + y05 + y06);
		} else if (sel_bike_model === "990 Adventure *FRONT*" || sel_bike_model === "990 Adventure *REAR*") {
			sel_year.empty().append(y07 + y08 + y09 + y10 + y11 + y12);
		} else if (sel_bike_model === "1090 Adventure *FRONT*" || sel_bike_model === "1090 Adventure *REAR*") {
			sel_year.empty().append(y17 + y18 + y19);
		} else if (sel_bike_model === "1190 Adventure *FRONT*" || sel_bike_model === "1190 Adventure *REAR*") {
			sel_year.empty().append(y13 + y14);
		} else if (sel_bike_model === "1290 Adventure ABS *FRONT*" || sel_bike_model === "1290 Adventure ABS *REAR*") {
			sel_year.empty().append(y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "XC-W300 TPI Six Days *REAR*" || sel_bike_model === "XC-W300 TPI Six Days *FRONT*") {
			sel_year.empty().append(y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "XC250 TPI *REAR*" || sel_bike_model === "XC250 TPI *FRONT*" || sel_bike_model === "XC300 TPI *REAR*" || sel_bike_model === "XC300 TPI *FRONT*" || sel_bike_model === "790 Adventure R *REAR*" || sel_bike_model === "790 Adventure R *FRONT*") {
			sel_year.empty().append(y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "SX-F450 Factory Edition *REAR*" || sel_bike_model === "SX-F450 Factory Edition *FRONT*") {
			sel_year.empty().append(y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "1290 Adventure R *REAR*" || sel_bike_model === "1290 Adventure R *FRONT*" || sel_bike_model === "1290 Super Adventure S *REAR*" || sel_bike_model === "1290 Super Adventure S *FRONT*") {
			sel_year.empty().append(y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "EXC-F450 *REAR*" || sel_bike_model === "EXC-F450 *FRONT*") {
				sel_year.empty().append(
											y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 +
											y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 +
											y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26
										);
		} else if (sel_bike_model === "1090 Adventure R *FRONT*" || sel_bike_model === "1090 Adventure R *REAR*") {
			sel_year.empty().append(y17 + y18 + y19);
		}





		//Model Suzuki Front
		else if (sel_bike_model === "2000 - 17 DRZ400 SE *FRONT*") {
			sel_year.empty().append(y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "DRZ400 SM *FRONT*" || sel_bike_model === "DRZ400 SM *REAR*") {
			sel_year.empty().append(y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} 
		else if (sel_bike_model === "2000 - 17 DRZ400 E *FRONT*" || sel_bike_model === "2000 - 17 DRZ400 E * REAR *") {
			sel_year.empty().append(y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09);
		}
		else if (sel_bike_model === "2000 - 17 DRZ400 S *FRONT*" || sel_bike_model === "2000 - 17 DRZ400 S * REAR *") {
			sel_year.empty().append(y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		}
		else if (sel_bike_model === "1996 - 2017 DR650 *FRONT*" || sel_bike_model === "1996 - 2017 DR650 * REAR *") {
			sel_year.empty().append(y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "1996 - 07 RM125 *FRONT*") {
			sel_year.empty().append(y88 + y89 + y90 + y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08);
		} else if (sel_bike_model === "1996 - 2009 RM250 *FRONT*") {
			sel_year.empty().append(y88 + y89 + y90 + y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08);
		} else if (sel_bike_model === "2004 - 06 RMZ250 *FRONT*" || sel_bike_model === "2004 - 06 RMZ250 * REAR *") {
			sel_year.empty().append(y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "2017+ RMX450 *FRONT*") {
			sel_year.empty().append(y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "2005 - 17 RMZ450 *FRONT*" || sel_bike_model === "2005 - 17 RMZ450 * REAR *") {
			sel_year.empty().append(y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		}

		else if (sel_bike_model === "DR650SE *FRONT*" || sel_bike_model === "DR650SE *REAR*") {
			sel_year.empty().append(y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		}

		else if (sel_bike_model === "RMX250 *FRONT*" || sel_bike_model === "RMX250 *REAR*") {
			sel_year.empty().append(y89 + y90 + y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98);
		}

		else if (sel_bike_model === "DRZ400 *FRONT*" || sel_bike_model === "DRZ400 *REAR*") {
			sel_year.empty().append(y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09);
		}


		//Model Suzuki Rear
		else if (sel_bike_model === "2000 - 17 DRZ400 SE * REAR *") {
			sel_year.empty().append(y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "1989 - 98 RM125 * REAR *") {
			sel_year.empty().append(y88 + y89 + y90 + y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08);
		} else if (sel_bike_model === "1989 - 98 RM250 * REAR *") {
			sel_year.empty().append(y88 + y89 + y90 + y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08);
		} else if (sel_bike_model === "2017+ RMX450 * REAR *") {
			sel_year.empty().append(y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		}


		//Model Husaberg Front and Rear
		else if (sel_bike_model === "2004 - 14 All FE/FC *FRONT*" || sel_bike_model === "FE" || sel_bike_model === "2004 - 14 All FE/FC *REAR*" || sel_bike_model === "FE *REAR*") {
			sel_year.empty().append(y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14);
		} 
		else if (sel_bike_model === "TE125 *FRONT*" || sel_bike_model === "TE125 *REAR*") {
			sel_year.empty().append(y12 + y13 + y14);
		}	
		else if (sel_bike_model === "FE250 *FRONT*" || sel_bike_model === "FE250 *REAR*") {
			sel_year.empty().append(y13 + y14);
		}
		else if (sel_bike_model === "TE250 *FRONT*" || sel_bike_model === "TE250 *REAR*") {
			sel_year.empty().append(y12 + y13 + y14);
		}
		else if (sel_bike_model === "TE300 *FRONT*" || sel_bike_model === "TE300 *REAR*") {
			sel_year.empty().append(y12 + y13 + y14);
		}
		
		else if (sel_bike_model === "FE390 *FRONT*" || sel_bike_model === "FE390 *REAR*") {
			sel_year.empty().append(y09 + y10 + y11 + y12);
		}
		else if (sel_bike_model === "FC450 *FRONT*" || sel_bike_model === "FC450 *REAR*") {
			sel_year.empty().append(y04 + y05);
		}
		else if (sel_bike_model === "FE450 *FRONT*" && sel_bike_make == 'Husaberg' || sel_bike_model === "FE450 *REAR*" && sel_bike_make == 'Husaberg') {
			sel_year.empty().append(y13 + y14);
		}
		else if (sel_bike_model === "FE450e *FRONT*" || sel_bike_model === "FE450e *REAR*") {
			sel_year.empty().append(y04 + y05 + y06 + y07 + y08);
		}

		else if (sel_bike_model === "FE570 *FRONT*" || sel_bike_model === "FE570 *REAR*") {
			sel_year.empty().append(y09 + y10 + y11 + y12);
		}
		else if (sel_bike_model === "FE650 *FRONT*" || sel_bike_model === "FE650 *REAR*") {
			sel_year.empty().append(y04 + y05 + y06 + y07 + y08);
		}


		//Model Gas Gas Front and Rear
		else if (sel_bike_model === "2003-2012 EC250-EC450 *FRONT*" || sel_bike_model === "2003-2012 EC250-EC450 *REAR*" || sel_bike_model === "EC300 *FRONT*" || sel_bike_model === "EC300 *REAR*" || sel_bike_model === "MC125 *FRONT*" || sel_bike_model === "MC125 *REAR*" || sel_bike_model === "MC250 *FRONT*"|| sel_bike_model === "MC250 *REAR*" || sel_bike_model === "MC250F *FRONT*" || sel_bike_model === "MC250F *REAR*" || sel_bike_model === "EC450F *FRONT*"|| sel_bike_model === "EC450F *REAR*" || sel_bike_model === "MC450F *FRONT*" || sel_bike_model === "MC450F *REAR*") {
			sel_year.empty().append(y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "EC200 RANGER *FRONT*" || sel_bike_model === "EC200 RANGER *REAR*" || sel_bike_model === "EC300 RANGER *FRONT*" || sel_bike_model === "EC300 RANGER *REAR*") {
			sel_year.empty().append(y20);
		} else if (sel_bike_model === "EC250 *FRONT*" || sel_bike_model === "EC250 *REAR*" || sel_bike_model === "EC250F *FRONT*" || sel_bike_model === "EC250F *REAR*") {
			sel_year.empty().append(y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "EC200 *FRONT*" || sel_bike_model === "EC200 *REAR*") {
			sel_year.empty().append(y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21);
		} else if (sel_bike_model === "EC125 *FRONT*" || sel_bike_model === "EC125 *REAR*") {
			sel_year.empty().append(y13 + y14 + y15 + y16 + y17 + y18);
		} else if (sel_bike_model === "EC450 *FRONT*" || sel_bike_model === "EC450 *REAR*") {
			sel_year.empty().append(y09 + y10 + y11 + y12);
		} else if (sel_bike_model === "Gas XC200 *FRONT*" || sel_bike_model === "Gas XC200 *REAR*" || sel_bike_model === "EC250 SIX DAYS *FRONT*" || sel_bike_model === "EC250 SIX DAYS *REAR*" || sel_bike_model === "EC300 SIX DAYS *FRONT*" || sel_bike_model === "EC300 SIX DAYS *REAR*" || sel_bike_model === "Gas XC300 *FRONT*" || sel_bike_model === "Gas XC300 *REAR*" || sel_bike_model === "Gas XC250 *FRONT*" || sel_bike_model === "Gas XC250 *REAR*") {
			sel_year.empty().append(y18 + y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "MC85 *FRONT*" || sel_bike_model === "MC85 *REAR*") {
			sel_year.empty().append(y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "EX250 *FRONT*" || sel_bike_model === "EX250 *REAR*") {
			sel_year.empty().append(y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "EX250F *FRONT*" || sel_bike_model === "EX250F *REAR*") {
			sel_year.empty().append(y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "EC300GP *FRONT*"|| sel_bike_model === "EC300GP *REAR*" ) {
			sel_year.empty().append(y25 + y26)
		} else if (sel_bike_model === "EX300 *FRONT*"|| sel_bike_model === "EX300 *REAR*" ) {
			sel_year.empty().append(y22 + y23 + y24 + y25 + y26)
		} else if (sel_bike_model === "EC350F *FRONT*"|| sel_bike_model === "EC350F *REAR*" ) {
			sel_year.empty().append(y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26)
		} else if (sel_bike_model === "EX350F *FRONT*"|| sel_bike_model === "EX350F *REAR*" || sel_bike_model === "EX450F *FRONT*"|| sel_bike_model === "EX450F *REAR*") {
			sel_year.empty().append(y21 + y22 + y23 + y24 + y25 + y26)
		} else if (sel_bike_model === "MC350F *FRONT*"|| sel_bike_model === "MC350F *REAR*" ) {
			sel_year.empty().append(y22 + y23 + y24 + y25 + y26)
		} else if (sel_bike_model === "EC500F *FRONT*"|| sel_bike_model === "EC500F *REAR*" ) {
			sel_year.empty().append(y24 + y25 + y26)
		} else if (sel_bike_model === "ES700 *FRONT*"|| sel_bike_model === "ES700 *REAR*" ) {
			sel_year.empty().append(y23 + y24 + y25 + y26)
		}

		//Model BMW Front
		else if (sel_bike_model === "2009 - 11 450X *FRONT*") {
			sel_year.empty().append(y08 + y09 + y10 + y11);
		}
		//Model BMW Rear
		else if (sel_bike_model === "2009 - 11 450X *REAR*") {
			sel_year.empty().append(y08 + y09 + y10 + y11);
		}
		//Model Beta Front and REAR
		else if (sel_bike_model === "125 RR *FRONT*" || sel_bike_model === "125 RR *REAR*") {
			sel_year.empty().append(y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "200 RR *FRONT*" || sel_bike_model === "200 RR *REAR*") {
			sel_year.empty().append(y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "250 RR *FRONT*" || sel_bike_model === "250 RR *REAR*" || sel_bike_model === "300 RR *FRONT*" || sel_bike_model === "300 RR *REAR*" || sel_bike_model === "350 RR *FRONT*" || sel_bike_model === "350 RR *REAR*" || sel_bike_model === "350 RR-S *FRONT*" || sel_bike_model === "350 RR-S *REAR*") {
			sel_year.empty().append(y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "250 RX *FRONT*" || sel_bike_model === "250 RX *REAR*" || sel_bike_model === "450 RX *FRONT*" || sel_bike_model === "450 RX *REAR*") {
			sel_year.empty().append(y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "300 X-TRAINER *FRONT*" || sel_bike_model === "300 X-TRAINER *REAR*" || sel_bike_model === "500 RR-S *FRONT*" || sel_bike_model === "500 RR-S *REAR*") {
			sel_year.empty().append(y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "350 RX *FRONT*" || sel_bike_model === "350 RX *REAR*") {
			sel_year.empty().append(y26);
		} else if (sel_bike_model === "390 RR *FRONT*" || sel_bike_model === "390 RR *REAR*") {
			sel_year.empty().append(y25 + y26);
		} else if (sel_bike_model === "390 RR-S *FRONT*" || sel_bike_model === "390 RR-S *REAR*" || sel_bike_model === "430 RR *FRONT*" || sel_bike_model === "430 RR *REAR*" || sel_bike_model === "430 RR-S *FRONT*" || sel_bike_model === "430 RR-S *REAR*") {
			sel_year.empty().append(y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "400 RR *FRONT*" || sel_bike_model === "400 RR *REAR*" || sel_bike_model === "400 RR-S *FRONT*" || sel_bike_model === "400 RR-S *REAR*" || sel_bike_model === "450 RR *FRONT*" || sel_bike_model === "450 RR *REAR*" || sel_bike_model === "450 RR-S *FRONT*" || sel_bike_model === "450 RR-S *REAR*") {
			sel_year.empty().append(y13 + y14);
		} else if (sel_bike_model === "480 RR *FRONT*" || sel_bike_model === "480 RR *REAR*") {
			sel_year.empty().append(y15 + y16);
		} else if (sel_bike_model === "498 RR *FRONT*" || sel_bike_model === "498 RR *REAR*" || sel_bike_model === "498 RR-S *FRONT*" || sel_bike_model === "498 RR-S *REAR*") {
			sel_year.empty().append(y13 + y14);
		}

		//Model TM Front And Rear
		else if (sel_bike_model === "2008 - 2017 MX 125-530 (will not fit SM) *FRONT" || sel_bike_model === "2008 - 2017 EN 125-530 (will not fit SM) *FRONT" || sel_bike_model === "2008 - 2017 MX 125-530 (will not fit SM) * REAR *" || sel_bike_model === "2008 - 2017 EN 125-530 (will not fit SM) * REAR *") {
			sel_year.empty().append(y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		}
		//Model Sherco Front and Rear
		else if (sel_bike_model === "2008 - 2017 125-300 SE-R *FRONT" || sel_bike_model === "2008 - 2017 250-450 SEF-R *FRONT" || sel_bike_model === "22008 - 2017 250-450 SER *FRONT" || sel_bike_model === "2008 - 2017 125-300 SE-R * REAR *" || sel_bike_model === "2008 - 2017 250-450 SEF-R * REAR *" || sel_bike_model === "2008 - 2017 250-450 SER * REAR *") {
			sel_year.empty().append(y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);
		}
		//Model Alta Redshift Front and REAR
		else if (sel_bike_model === "All years and models *FRONT" || sel_bike_model === "Enduro *FRONT" || sel_bike_model === "All years and models * REAR *" || sel_bike_model === "Enduro * REAR *") {
			sel_year.empty().append(y16 + y17 + y18);
		} else if (sel_bike_model === "EX *FRONT*" || sel_bike_model === "EX *REAR*" ) {
			sel_year.empty().append(y17 + y18);
		} else if (sel_bike_model === "MXR *FRONT*" || sel_bike_model === "MXR *REAR*" || sel_bike_model === "EXR *FRONT*" || sel_bike_model === "EXR *REAR*") {
			sel_year.empty().append(y18);
		}

		// New Sherco Models
		// 2010–2026
		else if (
			sel_bike_model === "SE 125 *FRONT*" || sel_bike_model === "SE 125 *REAR*" ||
			sel_bike_model === "SE 125 Factory *FRONT*" || sel_bike_model === "SE 125 Factory *REAR*" ||
			sel_bike_model === "SE 125 Racing *FRONT*" || sel_bike_model === "SE 125 Racing *REAR*" ||
			sel_bike_model === "SEF 300 *FRONT*" || sel_bike_model === "SEF 300 *REAR*" ||
			sel_bike_model === "SEF 300 Factory *FRONT*" || sel_bike_model === "SEF 300 Factory *REAR*" ||
			sel_bike_model === "SEF 300 Racing *FRONT*" || sel_bike_model === "SEF 300 Racing *REAR*" ||
			sel_bike_model === "SEF 500 *FRONT*" || sel_bike_model === "SEF 500 *REAR*" ||
			sel_bike_model === "SEF 500 Factory *FRONT*" || sel_bike_model === "SEF 500 Factory *REAR*" ||
			sel_bike_model === "SEF 500 Racing *FRONT*" || sel_bike_model === "SEF 500 Racing *REAR*"
		) {
			sel_year.empty().append(y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		}

		// 2024–2026
		else if (sel_bike_model === "SEF 125 *FRONT*" || sel_bike_model === "SEF 125 *REAR*") {
			sel_year.empty().append(y24 + y25 + y26);
		}

		// 2008–2026
		else if (
			sel_bike_model === "SE 250 *FRONT*" || sel_bike_model === "SE 250 *REAR*" ||
			sel_bike_model === "SE 250 Factory *FRONT*" || sel_bike_model === "SE 250 Factory *REAR*" ||
			sel_bike_model === "SE 250 Racing *FRONT*" || sel_bike_model === "SE 250 Racing *REAR*" ||
			sel_bike_model === "SEF 250 *FRONT*" || sel_bike_model === "SEF 250 *REAR*" ||
			sel_bike_model === "SEF 250 Factory *FRONT*" || sel_bike_model === "SEF 250 Factory *REAR*" ||
			sel_bike_model === "SEF 250 Racing *FRONT*" || sel_bike_model === "SEF 250 Racing *REAR*" ||
			sel_bike_model === "SE 300 *FRONT*" || sel_bike_model === "SE 300 *REAR*" ||
			sel_bike_model === "SE 300 Factory *FRONT*" || sel_bike_model === "SE 300 Factory *REAR*" ||
			sel_bike_model === "SE 300 Racing *FRONT*" || sel_bike_model === "SE 300 Racing *REAR*" ||
			sel_bike_model === "SEF 450 *FRONT*" || sel_bike_model === "SEF 450 *REAR*" ||
			sel_bike_model === "SEF 450 Factory *FRONT*" || sel_bike_model === "SEF 450 Factory *REAR*" ||
			sel_bike_model === "SEF 450 Racing *FRONT*" || sel_bike_model === "SEF 450 Racing *REAR*"
		) {
			sel_year.empty().append(y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		}

		// 2020–2026 (Xtrem only)
		else if (sel_bike_model === "SE 300 Xtrem *FRONT*" || sel_bike_model === "SE 300 Xtrem *REAR*") {
			sel_year.empty().append(y20 + y21 + y22 + y23 + y24 + y25 + y26);
		}

		// New Stark Models
		else if (sel_bike_model === "Varg MX *FRONT*" || sel_bike_model === "Varg MX *REAR*") {
			sel_year.empty().append(y22 + y23 + y24 + y25 + y26);
		}

		else if (sel_bike_model === "Varg EX *FRONT*" || sel_bike_model === "Varg EX *REAR*") {
			sel_year.empty().append(y24 + y25 + y26);
		}


		// Model SWM
		else if (sel_bike_model === "RS 125 R *FRONT*" || sel_bike_model === "RS 125 R *REAR*") {
			sel_year.empty().append(y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		}

		else if (sel_bike_model === "RE 300 R *FRONT*" || sel_bike_model === "RE 300 R *REAR*") {
			sel_year.empty().append(y22 + y23 + y24 + y25 + y26);
		}

		else if (sel_bike_model === "RS 300 R *FRONT*" || sel_bike_model === "RS 300 R *REAR*") {
			sel_year.empty().append(y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		}

		else if (sel_bike_model === "RS 300 R Six Days *FRONT*" || sel_bike_model === "RS 300 R Six Days *REAR*") {
			sel_year.empty().append(y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		}


		// Model Rieju
		else if (
			sel_bike_model === "MR 200 *FRONT*" || sel_bike_model === "MR 200 *REAR*" ||
			sel_bike_model === "MR Pro 200 *FRONT*" || sel_bike_model === "MR Pro 200 *REAR*" ||
			sel_bike_model === "MR Racing 200 *FRONT*" || sel_bike_model === "MR Racing 200 *REAR*" ||
			sel_bike_model === "MR Ranger 200 *FRONT*" || sel_bike_model === "MR Ranger 200 *REAR*" ||
			sel_bike_model === "MR 300 *FRONT*" || sel_bike_model === "MR 300 *REAR*" ||
			sel_bike_model === "MR 6Days 250 *FRONT*" || sel_bike_model === "MR 6Days 250 *REAR*" ||
			sel_bike_model === "MR 6Days 300 *FRONT*" || sel_bike_model === "MR 6Days 300 *REAR*" ||
			sel_bike_model === "MR Pro 300 *FRONT*" || sel_bike_model === "MR Pro 300 *REAR*" ||
			sel_bike_model === "MR Racing 300 *FRONT*" || sel_bike_model === "MR Racing 300 *REAR*" ||
			sel_bike_model === "MR Ranger 300 *FRONT*" || sel_bike_model === "MR Ranger 300 *REAR*"
		) {
			sel_year.empty().append(y20 + y21 + y22 + y23 + y24 + y25 + y26);
		}

		else if (sel_bike_model === "MR Alfredo Gómez Replica 300 *FRONT*" || sel_bike_model === "MR Alfredo Gómez Replica 300 *REAR*") {
			sel_year.empty().append(y23 + y24 + y25 + y26);
		}

		else if (sel_bike_model === "MR Pro 300i *FRONT*" || sel_bike_model === "MR Pro 300i *REAR*") {
			sel_year.empty().append(y26);
		}

		// NEW year as per AJ KTM bike-year-bad-logic
		if(sel_bike_model.includes('SX144')){
			sel_year.empty().append(y07 + y08);
		}else if(sel_bike_model.includes('SX200')){
			sel_year.empty().append(y03 + y04);
		}else if(sel_bike_model.includes('XC-W200')){
			sel_year.empty().append(y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17);
		}else if(sel_bike_model.includes('XC-W200')){
			sel_year.empty().append(y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17);
		}else if(sel_bike_model.includes('250SX')){
			sel_year.empty().append(y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25);
		}else if(sel_bike_model.includes('XC-F250')){
			sel_year.empty().append(y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		}else if(sel_bike_model.includes('XCF-W250')){
			sel_year.empty().append(y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25);
		}else if(sel_bike_model.includes('EXC-F350')){
			sel_year.empty().append(y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);
		}else if(sel_bike_model.includes('XC-F350')){
			sel_year.empty().append(y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25);
		}else if(sel_bike_model.includes('XCF-W350')){
			sel_year.empty().append(y12 + y13 + y14 + y15 + y16);
		}else if(sel_bike_model.includes('EXC400')){
			sel_year.empty().append(y03 + y04 + y05);			
		}else if(sel_bike_model.includes('XC-W450')){
			sel_year.empty().append(y07 + y08 + y09 + y10);			
		}else if(sel_bike_model.includes('EXC450')){
			sel_year.empty().append(y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11);			
		}else if(sel_bike_model.includes('SX450')){
			sel_year.empty().append(y03 + y04 + y05 + y06);			
		}else if(sel_bike_model.includes('SX-F450 Factory Edition')){
			sel_year.empty().append(y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25 + y26);			
		}else if(sel_bike_model.includes('XC-W450')){
			sel_year.empty().append(y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14);			
		}else if(sel_bike_model.includes('1290 Adventure ABS')){
			sel_year.empty().append(y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24 + y25);			
		}else{
			// sel_year.empty().append(y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19 + y20 + y21 + y22 + y23 + y24);			
		}

		if(sel_bike_model == "ES500 *FRONT*" || sel_bike_model == "ES500 *REAR*"){
			sel_year.empty().append(y23 + y24 + y25);						
		}
		// NEW year as per AJ


		if (sel_year.find(`option[value="${previous_year}"]`).length > 0) {
			sel_year.val(previous_year); // Set the previous year as selected
		} else {
			sel_year.find('option:first').prop('selected', true); // Default to the first year
		}

		

		

		speedometer();
	}

	var speedometer = function () {
		var wheel = $('select#wheel_type').val();
		var make = $('select#bike_make').val();
		var model = $('select#bike_model').val();

		const bikeMake = document.querySelector('#bike_make').value;
		const bikeYear = parseInt(document.querySelector('#bike_year').value, 10);
		// console.log({
		// 	bikeMake,bikeYear
		// });
		if (wheel == "FRONT") {				
			console.log('Debug speedometer magnets, printing bike model:', model, 'printing bike make:', make);
			if (make == "Husaberg" || make == 'KTM') {
				console.log('Debug speedometer magnets, Husaberg and KTM');
				//Show Speedometer Magnets
				$("#speedometer").show();
				// console.log( $('#sm_magnets').val());
				//Change Speedometer Options $('#sm_magnets').val()
				$('#sm_magnets').val($('#sm_magnets option:first').val());
				$('#sm_magnets').change(magnet_change);
				//Magnet Price Increase
			}else if((['Beta', 'Triumph'].includes(bikeMake) || (bikeMake === 'Husqvarna' && bikeYear >= 2014 && bikeYear <= 2025) || (bikeMake === 'GasGas' && bikeYear >= 2020 && bikeYear <= 2025))){
				//Show Speedometer Magnets
				$("#speedometer").show();
				// console.log( $('#sm_magnets').val());
				//Change Speedometer Options $('#sm_magnets').val()
				$('#sm_magnets').val($('#sm_magnets option:first').val());
				$('#sm_magnets').change(magnet_change);
				//Magnet Price Increase
			} else {
				//Hide Speedometer Magnets
				$('#sm_magnets').val($('#sm_magnets option:first').val());
				$('#sm_magnets').change(magnet_change);
				$("#speedometer").hide();
				// console.log('on front else');
			}

		} else { //Hide Speedometer Magnets
			$('#sm_magnets').val($('#sm_magnets option:first').val());
			$('#sm_magnets').change(magnet_change);
			$("#speedometer").hide();
			// console.log('on rear else');
		}
	}

	let debounceTimer;
	let tire_image = {
		"GPR 300 150/60ZR17": "https://www.warp9racing.com/smwheel/sm_images/SM-REAR-tire650.png",
		"MICHELIN 2CT 150/60R17": "https://www.warp9racing.com/smwheel/sm_images/SM-REAR-tire650.png"
	}
	let debounceTimerPrice;
	document.addEventListener('wb_price_updated', function (e) {
		var data = e.detail;
		clearTimeout(debounceTimerPrice);
		debounceTimerPrice = setTimeout(function () {
			console.log('Price Updated');
			console.log(data);
		}, 500);
	});

	const mxAdventureBasePriceExceptionModels = [
		"790 ADVENTURE",
		"790 ADVENTURE R",
		"790 ADVENTURE R RALLY",
		"890 ADVENTURE",
		"890 ADVENTURE L",
		"890 ADVENTURE R",
		"890 ADVENTURE R RALLY",
		"950 ADVENTURE",
		"950 ADVENTURE S",
		"990 ADVENTURE",
		"990 ADVENTURE BAJA",
		"990 ADVENTURE DAKAR",
		"990 ADVENTURE R",
		"1090 ADVENTURE",
		"1090 ADVENTURE R",
		"1190 ADVENTURE",
		"1190 ADVENTURE R",
		"1290 SUPER ADVENTURE",
		"1290 SUPER ADVENTURE R"
	];

	function getMxWheelBaseModel(model) {
		return String(model || "")
			.replace(/\s*\*(FRONT|REAR)\*\s*$/i, "")
			.replace(/\s+/g, " ")
			.trim()
			.toUpperCase();
	}

	function isMxAdventureBasePriceException(model) {
		return mxAdventureBasePriceExceptionModels.includes(getMxWheelBaseModel(model));
	}

	function getMxWheelBasePrice(isDealer, wheelType) {
		if (wheelType === "FRONT") {
			return isDealer ? 304 : 410;
		}

		return isDealer ? 329 : 440;
	}

	var tprice = function () {
		setupCush();
      var activeNippleColor = $('.nipple_color_wrapper .active').data('value');
      $('#nipple_color').val(activeNippleColor);
		//Change Tire image
		// clearTimeout(debounceTimer);
		// debounceTimer = setTimeout(function () {
		// 	console.log("This code runs only once after a delay!");
		// 	var selected_tire = $('#mbtire').val();
		// 	// if( selected_tire == "GPR 300 150/60ZR17"){
		// 	// 	$('div#resultAreaID_1_10 img').attr('src', "https://www.warp9racing.com/smwheel/sm_images/SM-REAR-tire650.png");
		// 	// 	$('div#resultAreaID_1_10').show();
		// 	// }else{
		// 	// 	$('div#resultAreaID_1_10 img').attr('src', "");
		// 	// 	$('div#resultAreaID_1_10').hide();
		// 	// }

		// 	if (selected_tire != "mbno") {
		// 		$('div#resultAreaID_1_10 img').attr('src', "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/SM-REAR-tire650_6d4c409a-011a-4913-a00a-2d296f7dca68.png?v=1729666392");
		// 		$('div#resultAreaID_1_10').show();
		// 	} else {
		// 		$('div#resultAreaID_1_10 img').attr('src', "");
		// 		$('div#resultAreaID_1_10').hide();
		// 	}

		// }, 500);
		if (role == "true") {
			var base_price = getMxWheelBasePrice(true, $('#wheel_type').val());
			var spoke_price = 40;
			var nipple_price = 25;
			var brake_price = 0;
			var wheel_size_price = 0;
			var rim_color = 0;
			var sprocket_bolts = 39;
			var rotor_bolts = 15;
			var rim_size = 0;
			var sprocket_price = 0;
			var magnet_price = 0;
            
			const brakeRotor = $('select#brake_rotor').val();
            const wheelType = $('#wheel_type').val();

            const brakePrices = {
                "320MM_FLOATING": {
                    "FRONT": 44,
                    "REAR": 47
                },
                "320MM_FIXED": {
                    "FRONT": 65,
                    "REAR": 20
            }
            };

            brake_price = brakePrices[brakeRotor]?.[wheelType] ?? 0;

			if ($('select#wheel_type').val() === "FRONT")
				base_price = getMxWheelBasePrice(true, "FRONT");

			if ($('select#wheel_type').val() === "FRONT" || $('select#wheel_type').val() === "REAR") {
				// if ($('select#rim_color').val() === "White" || $('select#rim_color').val() === "Red" || $('select#rim_color').val() === "Blue" || $('select#rim_color').val() === "Orange" || $('select#rim_color').val() === "Green" || $('select#rim_color').val() === "Gold" || $('select#rim_color').val() === "Purple" || $('select#rim_color').val() === "Magnesium" || $('select#rim_color').val() === "Flo-Yellow" || $('select#rim_color').val() === "Nardo-Grey" || $('select#rim_color').val() === "School-Bus-Yellow") {
				// 	rim_color = 35;
				// } else if ($('select#rim_color').val() === "Blue") {
				// 	rim_color = 45;
				// } else if ($('select#rim_color').val() === "Baby-Blue") {
				// 	rim_color = 45;
				// }
				var anodizationColors = ['Silver', 'Black', 'Red', 'Blue', 'Gold', 'Green', 'Orange', 'Purple', 'Magnesium'];
				var powderCoatColors = ['Blue', 'Baby-blue', 'Orange', 'Nardo Grey', 'Yellow', 'Flo-yellow', 'White', 'Teal', 'Illusion Violet'];
				var specialColors = ['Illusion-Violet', 'Teal'];
				var rim_color_value = $('#rim_color').val();
				var rim_type = $('.rim-type-wrap.active').data('category');
				// Pricing details
				var standardPrice = 35;
				var powderCoatPrice = 35;
				var specialColorPrice = 60;

				if (rim_type === 'anodized' && anodizationColors.includes(rim_color_value)) {
					rim_color = standardPrice;
				} else if (rim_type === 'powder-coat' && powderCoatColors.includes(rim_color_value)) {
					specialColors.includes(rim_color_value) ? rim_color = specialColorPrice : rim_color = powderCoatPrice;
				} else {
					rim_color = 35;
				}

				if (rim_type === 'anodized') {
					if (rim_color_value == "Black" || rim_color_value == "Silver" || rim_color_value == "Matte-Black") {
						rim_color = 0;
					}
				}
			}

			if ($('select#rim_type').val() === "Elite" && role == "false")
				base_price = base_price + 20;
            else if ($('select#rim_type').val() === "Elite" && role == "true")
                base_price = base_price + 12;
			if ($('select#brake_rotor').val() === "320MM_FLOATING")
				base_price = base_price + 25;

			var cushsel = $('#cush_drive');
			if (cushsel.val() == "Cush Drive") {
				base_price = base_price + 125;
			} else {
				base_price = base_price;
			}
			var carrier_css = $("#sprocket").css('display');
			if (carrier_css == "block") {
				var carrier = $('#carrier_id');
				if (carrier.val() == "Yes") {
					base_price = base_price + 125;
				} else {
					base_price = base_price;
				}
			}

			if ($('input#spoke_color').val() === "Silver")
				spoke_price = 0;
			if ($('input#spoke_color').val() === "Titanium")
				spoke_price = 179;

			if ($('#spoke_color').val() === "Teal" || $('#spoke_color').val() === "Illusion Violet") {
				spoke_price = 65;
			}

			if ($('#nipple_color').val() === "Silver" || $('input#spoke_color').val() === "Titanium")
				nipple_price = 0;

			if ($('select#brake_rotor').val() === "Wave")
				brake_price = 0;
			if ($('select#rim_size').val() === "FRONT 19x2.15" || $('select#rim_size').val() === "19x2.15") {
				wheel_size_price = 0;
			}
			if ($('select#bike_model').val() === "DR650SE *REAR*" || $('select#bike_model').val() == "2008 – 2013 KTM 690 ENDURO * REAR *" || $('select#bike_model').val() == "2014 – 2017 KTM 690 ENDURO ABS * REAR *" || $('select#bike_model').val() == "KLR650 *REAR* " || $('select#bike_model').val() == "2016 - Current 701 Enduro *REAR*" || $('select#bike_model').val() == "701 Enduro ABS *REAR*") {
				if ($('select#rim_size').val() === "REAR 17X3.50" && $('select#bike_model').val() === "DR650SE *REAR*") {
					var base_price = getMxWheelBasePrice(true, $('#wheel_type').val());
				} else {
					var base_price = getMxWheelBasePrice(true, $('#wheel_type').val());

				}
				brake_price = 0;
				var cushsel = $('#cush_drive');
				if (cushsel.val() == "Cush Drive") {
					base_price = base_price + 125;
				} else {
					base_price = base_price;
				}
				var carrier_css = $("#sprocket").css('display');
				if (carrier_css == "block") {
					var carrier = $('#carrier_id');
					if (carrier.val() == "Yes") {
						base_price = base_price + 125;
					} else {
						base_price = base_price;
					}
				}
			} else if (isMxAdventureBasePriceException($('select#bike_model').val()) && $('select#wheel_type').val() === "REAR") {
				var base_price = 529;
				brake_price = 0;
			} else if (isMxAdventureBasePriceException($('select#bike_model').val()) && $('select#wheel_type').val() === "FRONT") {
				var base_price = 469;
				brake_price = 0;
				var carrier_css = $("#sprocket").css('display');
				if (carrier_css == "block") {
					var carrier = $('#carrier_id');
					if (carrier.val() == "Yes") {
						base_price = base_price + 125;
					} else {
						base_price = base_price;
					}
				}
			} else {
				base_price = base_price;
			}


			if ($('select#bike_model').val() == "KLR650 *FRONT*" || $('select#bike_model').val() == "690 Enduro ABS *FRONT*" || $('select#bike_model').val() == "690 Enduro *FRONT*" || $('select#bike_model').val() == "701 Enduro ABS *FRONT*") {
				var base_price = getMxWheelBasePrice(true, "FRONT");
				brake_price = 0;
			}

			if ($('select#sprocket_bolts').val() === "Standard") {
				sprocket_bolts = 0;
			}
			if ($('select#bike_model').val() == "KLR650 *REAR* " || $('select#bike_model').val() == "KLR650 *FRONT*") {
				sprocket_bolts = 0;
			}
			if ($('select#rim_size').val() == "REAR 18x2.50") {
				if ($('select#bike_model').val() == "DR650SE *REAR*" || $('select#bike_model').val() == "KLR650 *REAR*") {
					rim_size = 15;
				} else {
					rim_size = 20;
				}
			} else if ($('select#rim_size').val() == "FRONT 19x2.15" || $('select#rim_size').val() === "19x2.15") {
				rim_size = 25;
			} else if ($('select#rim_size').val() == "REAR 17x3.50") {
				rim_size = 61;
			} else if ($('select#rim_size').val() == "REAR 19x3.00") {
				rim_size = 30;
			} else if ($('select#rim_size').val() == "REAR 19x2.50" || $('select#rim_size').val() == "FRONT 19x2.50") {
				rim_size = 25;
			} else {
				rim_size = rim_size;
			}
			if ($('select#sm_magnets').val() == "NO" || $('select#sm_magnets').val() == '') {
				magnet_price = 0;
			} else {
				magnet_price = 7;
			}
			//No SPROCKET
			if ($('select#sprocket_size').val() == "no" && $('#wheel_type').val() == "REAR") {
				sprocket_price = 0;
            } else if ($('#wheel_type').val() == "FRONT"){
                sprocket_price = 0;
                sprocket_bolts = 0;
            }		 
                         else {
				sprocket_price = 0;
			}

			// Sample tire data
			var tireData = [{
					size: "Dunlop MX34  80/100-21",
					price: 137
				},
				{
					size: "Dunlop MX34 100/100-18",
					price: 147
				},
				{
					size: "Dunlop MX34 110/100-18",
					price: 142
				},
				{
					size: "Dunlop MX34 120/100-18",
					price: 146
				},
				{
					size: "Dunlop MX34 100/100-19",
					price: 145
				},
				{
					size: "Dunlop MX34 110/100-19",
					price: 156
				},
				{
					size: "Dunlop MX34 120/100-19",
					price: 157
				}
			];

			// Get the selected tire size
			var mbtire = $('select#mbtire').val();

			// Find the corresponding price based on the selected tire size
			var mbtire_price = 0;

			for (var i = 0; i < tireData.length; i++) {
				if (tireData[i].size === mbtire) {
					mbtire_price = tireData[i].price;
					break;
				}
			}

			// Now, mbtire_price contains the price of the selected tire size
			// console.log("Selected Tire Size: " + mbtire);
			var mbtire = $('#mbtire').val();
			var tirePrices = {
				"DUNLOP MX34 80/100-21": 166.95,
				"SHINKO 241 21x275": 113.95,
				"TUSK EMEX T-35 80/100-21": 95.00,
				"DUNLOP MX34 100/90-19": 177.95,
				"DUNLOP MX34 110/100-18": 173.95,
				"DUNLOP MX34 110/90-19": 191.95,
				"DUNLOP MX34 120/80-19": 193.95,
				"DUNLOP MX34 120/90-18": 178.95,
				"SHINKO 241 18x4.00": 146.95,
				"TUSK EMEX T-35 100/90-19": 104.00,
				"TUSK EMEX T-35 110/90-19": 107.00,
				"TUSK EMEX T-35 120/80-19": 108.00,
				"TUSK EMEX T-35 120/90-18": 108.00,
                "DUNLOP GEOMAX AT82 80/100-21": 170.95,
                "DUNLOP GEOMAX AT82 120/90-19": 209.95,
                "DUNLOP GEOMAX AT82 110/90-19": 194.95,
                "DUNLOP GEOMAX AT82 120/90-18": 180.95,
                "DUNLOP GEOMAX AT82 110/100-18": 189.95,
                "SHINKO E804 100/90-19": 177.95,
                "SHINKO E805 120/90-18": 177.95,
                "SHINKO E805 130/80-17": 246.95,
                "DUNLOP D606 90/90-21": 215.95,
                "DUNLOP D606 120/90-18": 219.95,
                "DUNLOP D606 130/90-17": 220.95,
                "IRC VE-33 GEKKOTA 110/100-18": 170.95,
                "DUNLOP MX34 100/100-18": 184.95,
                "TUSK EMEX T-35 100/100-18": 123.99,
				"DUNLOP MX34 70/100-19": 114.95,
				"DUNLOP MX34 70/100-17": 122.95,
				"DUNLOP MX34 90/100-16": 125.95,
				"DUNLOP MX34 90/100-14": 123.95,
			};
			var selectedPrice = tirePrices[mbtire];
			if (selectedPrice !== undefined) {
				mbtire_price = selectedPrice;
			} else {
				mbtire_price = mbtire_price
			}
			
			
			if ($('select#rotor_bolts').val() === "Standard") {
				rotor_bolts = 0;
			}else{
				rotor_bolts = 21;				
			}

			var has_rim_lock = document.querySelector('#rim_lock').value;
			var rim_lock = 0;
			if(has_rim_lock == "Yes"){
				if(document.querySelector('#rim_size').value.includes('19x3.0')){
					rim_lock = 16;
				}else{
					rim_lock = 13;
				}
			} else {
				rim_lock = 0;
			}

			var price = base_price + spoke_price + nipple_price + brake_price + wheel_size_price + rim_color + sprocket_bolts + rotor_bolts + rim_size + magnet_price + mbtire_price + rim_lock + sprocket_price;
			price = roundUpIfEndsWith95(price);			
			new_base_price = price;
			const wb_price_updated = new CustomEvent('wb_price_updated', {
				detail: {
					base_price,
					spoke_price,
					nipple_price,
					brake_price,
					wheel_size_price,
					rim_color,
					sprocket_bolts,
					rim_size,
					rotor_bolts,
					magnet_price,
					mbtire_price,
					rim_lock,
					sprocket_price,
					price
				}
			});
			document.dispatchEvent(wb_price_updated);
			$('#price').text('$' + price);
			var retail_price = retailPrice();
			$('#retail-price').text('$' + retail_price);
			// console.log(retail_price);
			return true;

		} else {

			var base_price = getMxWheelBasePrice(false, $('#wheel_type').val());
			var spoke_price = 65;
			var nipple_price = 35;
			var brake_price = 0;
			var wheel_size_price = 0;
			var rim_color = 0;
			var sprocket_bolts = 59;
			var rotor_bolts = 21;
			var rim_size = 0;
			var magnet_price = 0;
			var sprocket_price = 0;

			const brakeRotor = $('select#brake_rotor').val();
            const wheelType = $('#wheel_type').val();

            const brakePrices = {
                "320MM_FLOATING": {
                    "FRONT": 58,
                    "REAR": 62
                },
                "320MM_FIXED": {
                    "FRONT": 81,
                    "REAR": 27
            }
            };

            brake_price = brakePrices[brakeRotor]?.[wheelType] ?? 0;

			if ($('select#wheel_type').val() === "FRONT")
				base_price = getMxWheelBasePrice(false, "FRONT");

			if ($('select#wheel_type').val() === "REAR" || $('select#wheel_type').val() === "FRONT") {
				// if ($('#rim_color').val() === "White" || $('#rim_color').val() === "Red" || $('#rim_color').val() === "Blue" || $('#rim_color').val() === "Orange" || $('#rim_color').val() === "Green" || $('#rim_color').val() === "Gold" || $('#rim_color').val() === "Purple" || $('#rim_color').val() === "Magnesium" || $('#rim_color').val() === "Flo-Yellow" || $('#rim_color').val() === "Nardo-Grey" || $('#rim_color').val() === "School-Bus-Yellow") {
				// 	rim_color = 50;
				// } else if ($('#rim_color').val() === "Blue") {
				// 	rim_color = 60;
				// } else if ($('#rim_color').val() === "Baby-Blue") {
				// 	rim_color = 60;
				// }

				var anodizationColors = ['Silver', 'Black', 'Red', 'Blue', 'Gold', 'Green', 'Orange', 'Purple', 'Magnesium'];
				var powderCoatColors = ['Blue', 'Baby-blue', 'Orange', 'Nardo Grey', 'Yellow', 'Flo-yellow', 'White', 'Teal', 'Illusion Violet'];
				var specialColors = ['Illusion-Violet', 'Teal'];
				var rim_color_value = $('#rim_color').val();
				var rim_type = $('.rim-type-wrap.active').data('category');
				// Pricing details
				var standardPrice = 50;
				var powderCoatPrice = 50;
				var specialColorPrice = 80;

				if (rim_type === 'anodized' && anodizationColors.includes(rim_color_value)) {
					rim_color = standardPrice;
				} else if (rim_type === 'powder-coat' && powderCoatColors.includes(rim_color_value)) {
					specialColors.includes(rim_color_value) ? rim_color = specialColorPrice : rim_color = powderCoatPrice;
				} else {
					rim_color = 50;
				}

				if (rim_type === 'anodized') {
					if (rim_color_value == "Black" || rim_color_value == "Silver" || rim_color_value == "Matte-Black") {
						rim_color = 0;
					}
				}
				// console.log("Selected rim color: " + rim_color_value);
				// console.log("Selected rim type: " + rim_type);
				// console.log("Price for selected rim color and type: $" + rim_color);
			}

			if ($('select#rim_type').val() === "Elite" && role == "false")
				base_price = base_price + 20;
            else if ($('select#rim_type').val() === "Elite" && role == "true")
                base_price = base_price + 12;
			if ($('select#brake_rotor').val() === "320MM_FLOATING")
				base_price = base_price + 49;

			var cushsel = $('#cush_drive');
			if (cushsel.val() == "Cush Drive") {
				base_price = base_price + 175;
			} else {
				base_price = base_price;
			}
			var carrier_css = $("#sprocket").css('display');
			if (carrier_css == "block") {
				var carrier = $('#carrier_id');
				if (carrier.val() == "Yes") {
					base_price = base_price + 175;
				} else {
					base_price = base_price;
				}
			}


			if ($('#spoke_color').val() === "Silver")
				spoke_price = 0;
			if ($('#spoke_color').val() === "Titanium")
				spoke_price = 249;

			if ($('#spoke_color').val() === "Teal" || $('#spoke_color').val() === "Illusion Violet") {
				spoke_price = 89;
			}

			if ($('#nipple_color').val() === "Silver" || $('#spoke_color').val() === "Titanium")
				nipple_price = 0;

			if ($('select#brake_rotor').val() === "Wave")
				brake_price = 0;

			if ($('select#rim_size').val() === "FRONT 19x2.15" || $('select#rim_size').val() === "19x2.15") {
				wheel_size_price = 0;
			}
			if ($('select#bike_model').val() === "DR650SE *REAR*" || $('select#bike_model').val() == "2008 – 2013 KTM 690 ENDURO * REAR *" || $('select#bike_model').val() == "2014 – 2017 KTM 690 ENDURO ABS * REAR *" || $('select#bike_model').val() == "KLR650 *REAR*" || $('select#bike_model').val() == "2016 - Current 701 Enduro *REAR*" || $('select#bike_model').val() == "701 Enduro ABS *REAR*") {
				// var base_price = 452;
				if ($('select#rim_size').val() === "REAR 17X3.50" && $('select#bike_model').val() === "DR650SE *REAR*") {
					console.log('DR650SE assign 17X3.50 price');
						var base_price = getMxWheelBasePrice(false, $('#wheel_type').val());
					} else {
						var base_price = getMxWheelBasePrice(false, $('#wheel_type').val());

					}
				brake_price = 0;
				var cushsel = $('#cush_drive');
				if (cushsel.val() == "Cush Drive") {
					base_price = base_price + 175;
				} else {
					base_price = base_price;
				}
				var carrier_css = $("#sprocket").css('display');
				if (carrier_css == "block") {
					var carrier = $('#carrier_id');
					if (carrier.val() == "Yes") {
						base_price = base_price + 175;
					} else {
						base_price = base_price;
					}
				}
			} else if (isMxAdventureBasePriceException($('select#bike_model').val()) && $('select#wheel_type').val() === "REAR") {
				var base_price = 737;
				brake_price = 0;
			} else if (isMxAdventureBasePriceException($('select#bike_model').val()) && $('select#wheel_type').val() === "FRONT") {
				var base_price = 649;
			} else {
				base_price = base_price;
			}

			if ($('select#bike_model').val() == "KLR650 *FRONT*" || $('select#bike_model').val() == "690 Enduro ABS *FRONT*" || $('select#bike_model').val() == "690 Enduro *FRONT*" || $('select#bike_model').val() == "701 Enduro ABS *FRONT*") {
				var base_price = getMxWheelBasePrice(false, "FRONT");
				brake_price = 0;
			}
			if ($('select#sprocket_bolts').val() === "Standard") {
				sprocket_bolts = 0;
			}
			if ($('select#bike_model').val() == "KLR650 *REAR* " || $('select#bike_model').val() == "KLR650 *FRONT*") {
				sprocket_bolts = 0;
			}
			if ($('select#rotor_bolts').val() === "Standard") {
				rotor_bolts = 0;
			}
			if ($('select#rim_size').val() == "REAR 18x2.50" || $('select#rim_size').val() == "REAR 19x2.50" || $('select#rim_size').val() == "FRONT 19x2.50") {
				if ($('select#bike_model').val() == "DR650SE *REAR*" || $('select#bike_model').val() == "KLR650 *REAR*") {
					rim_size = 25;
				} else {
					rim_size = 29;
				}
			} else if ($('select#rim_size').val() == "REAR 17x3.50") {
				rim_size = 55;
			} else if ($('select#rim_size').val() == "FRONT 19x2.15" || $('select#rim_size').val() === "19x2.15") {
				rim_size = 29;
			} else if ($('select#rim_size').val() == "REAR 19x3.00") {
				rim_size = 60;
			} else {
				rim_size = rim_size;
			}
			if ($('select#sm_magnets').val() == "NO" || $('select#sm_magnets').val() == "" || $('select#sm_magnets').val() == null) {
				magnet_price = 0;
			} else {
				magnet_price = 11;
			}
			//No SPROCKET
			if ($('select#sprocket_size').val() == "no" && $('#wheel_type').val() == "REAR") {
				sprocket_price = 0;
			} 
		     else if ($('#wheel_type').val() == "FRONT"){
			sprocket_price = 0;
            sprocket_bolts = 0;
		    }		 
            else {
				sprocket_price = 0;
			}

			// Sample tire data
			var tireData = [{
					size: "Dunlop MX34  80/100-21",
					price: 137
				},
				{
					size: "Dunlop MX34 100/100-18",
					price: 147
				},
				{
					size: "Dunlop MX34 110/100-18",
					price: 142
				},
				{
					size: "Dunlop MX34 120/100-18",
					price: 146
				},
				{
					size: "Dunlop MX34 100/100-19",
					price: 145
				},
				{
					size: "Dunlop MX34 110/100-19",
					price: 156
				},
				{
					size: "Dunlop MX34 120/100-19",
					price: 157
				}
			];

			// Get the selected tire size
			var mbtire = $('select#mbtire').val();

			// Find the corresponding price based on the selected tire size
			var mbtire_price = 0;

			for (var i = 0; i < tireData.length; i++) {
				if (tireData[i].size === mbtire) {
					mbtire_price = tireData[i].price;
					break;
				}
			}

			var mbtire = $('#mbtire').val();
			var tirePrices = {
				"DUNLOP MX34 80/100-21": 166.95,
				"SHINKO 241 21x275": 113.95,
				"TUSK EMEX T-35 80/100-21": 95.00,
				"DUNLOP MX34 100/90-19": 177.95,
				"DUNLOP MX34 110/100-18": 173.95,
				"DUNLOP MX34 110/90-19": 191.95,
				"DUNLOP MX34 120/80-19": 193.95,
				"DUNLOP MX34 120/90-18": 178.95,
				"SHINKO 241 18x4.00": 146.95,
				"TUSK EMEX T-35 100/90-19": 104.00,
				"TUSK EMEX T-35 110/90-19": 107.00,
				"TUSK EMEX T-35 120/80-19": 108.00,
				"TUSK EMEX T-35 120/90-18": 108.00,
                "DUNLOP GEOMAX AT82 80/100-21": 170.95,
                "DUNLOP GEOMAX AT82 120/90-19": 209.95,
                "DUNLOP GEOMAX AT82 110/90-19": 194.95,
                "DUNLOP GEOMAX AT82 120/90-18": 180.95,
                "DUNLOP GEOMAX AT82 110/100-18": 189.95,
                "SHINKO E804 100/90-19": 177.95,
                "SHINKO E805 120/90-18": 177.95,
                "SHINKO E805 130/80-17": 246.95,
                "DUNLOP D606 90/90-21": 215.95,
                "DUNLOP D606 120/90-18": 219.95,
                "DUNLOP D606 130/90-17": 220.95,
                "IRC VE-33 GEKKOTA 110/100-18": 170.95,
                "DUNLOP MX34 100/100-18": 184.95,
                "TUSK EMEX T-35 100/100-18": 123.99,
				"DUNLOP MX34 70/100-19": 114.95,
				"DUNLOP MX34 70/100-17": 122.95,
				"DUNLOP MX34 90/100-16": 125.95,
				"DUNLOP MX34 90/100-14": 123.95,
			};
			var selectedPrice = tirePrices[mbtire];
			if (selectedPrice !== undefined) {
				mbtire_price = selectedPrice;
			} else {
				mbtire_price = mbtire_price
			}

			if ($('select#rotor_bolts').val() === "Standard") {
				rotor_bolts = 0;
			}else{
				rotor_bolts = 21;				
			}

			var has_rim_lock = document.querySelector('#rim_lock').value;
			var rim_lock = 0;
			if(has_rim_lock == "Yes"){
				if(document.querySelector('#rim_size').value.includes('19x3.0')){
					rim_lock = 26;
				}else{
					rim_lock = 21;
				}
			}  else {
				rim_lock = 0;
			}

			var price = base_price + spoke_price + nipple_price + brake_price + wheel_size_price + rim_color + sprocket_bolts + rotor_bolts + rim_size + magnet_price + mbtire_price + rim_lock + sprocket_price;
			price = roundUpIfEndsWith95(price)
			$('#price').text('$' + price);
			new_base_price = price;
			const wb_price_updated = new CustomEvent('wb_price_updated', {
				detail: {
					base_price,
					spoke_price,
					nipple_price,
					brake_price,
					wheel_size_price,
					rim_color,
					sprocket_bolts,
					rim_size,
					rotor_bolts,
					magnet_price,
					mbtire_price,
					rim_lock,
					sprocket_price,
					price
				}
			});
			document.dispatchEvent(wb_price_updated);


		}
	}
	// get Retail Price retail-price
	var retailPrice = function () {
		var base_price = getMxWheelBasePrice(false, $('#wheel_type').val());
		var spoke_price = 65;
		var nipple_price = 35;
		var brake_price = 49;
		var wheel_size_price = 0;
		var rim_color = 0;
		var sprocket_bolts = 59;
		var rotor_bolts = 21;
		var rim_size = 0;
		var magnet_price = 0;
		var sprocket_price = 0;

		const brakeRotor = $('select#brake_rotor').val();
            const wheelType = $('#wheel_type').val();

            const brakePrices = {
                "320MM_FLOATING": {
                    "FRONT": 58,
                    "REAR": 62
                },
                "320MM_FIXED": {
                    "FRONT": 81,
                    "REAR": 27
            }
            };

            brake_price = brakePrices[brakeRotor]?.[wheelType] ?? 0;

		if ($('select#wheel_type').val() === "FRONT")
			base_price = getMxWheelBasePrice(false, "FRONT");

		if ($('select#wheel_type').val() === "REAR" || $('select#wheel_type').val() === "FRONT") {
			// if ($('#rim_color').val() === "White" || $('#rim_color').val() === "Red" || $('#rim_color').val() === "Blue" || $('#rim_color').val() === "Orange" || $('#rim_color').val() === "Green" || $('#rim_color').val() === "Gold" || $('#rim_color').val() === "Purple" || $('#rim_color').val() === "Magnesium" || $('#rim_color').val() === "Flo-Yellow" || $('#rim_color').val() === "Nardo-Grey" || $('#rim_color').val() === "School-Bus-Yellow") {
			// 	rim_color = 50;
			// } else if ($('#rim_color').val() === "Blue") {
			// 	rim_color = 60;
			// } else if ($('#rim_color').val() === "Baby-Blue") {
			// 	rim_color = 60;
			// }

			var anodizationColors = ['Silver', 'Black', 'Red', 'Blue', 'Gold', 'Green', 'Orange', 'Purple', 'Magnesium'];
			var powderCoatColors = ['Blue', 'Baby-blue', 'Orange', 'Nardo Grey', 'Yellow', 'Flo-yellow', 'White', 'Teal', 'Illusion Violet'];
			var specialColors = ['Illusion-Violet', 'Teal'];
			var rim_color_value = $('#rim_color').val();
			var rim_type = $('.rim-type-wrap.active').data('category');
			// Pricing details
			var standardPrice = 50;
			var powderCoatPrice = 50;
			var specialColorPrice = 80;

			if (rim_type === 'anodized' && anodizationColors.includes(rim_color_value)) {
				rim_color = standardPrice;
			} else if (rim_type === 'powder-coat' && powderCoatColors.includes(rim_color_value)) {
				specialColors.includes(rim_color_value) ? rim_color = specialColorPrice : rim_color = powderCoatPrice;
			} else {
				rim_color = 50;
			}

			if (rim_type === 'anodized') {
				if (rim_color_value == "Black" || rim_color_value == "Silver" || rim_color_value == "Matte-Black") {
					rim_color = 0;
				}
			}
			// console.log("Selected rim color: " + rim_color_value);
			// console.log("Selected rim type: " + rim_type);
			// console.log("Price for selected rim color and type: $" + rim_color);
		}

        if ($('select#rim_type').val() === "Elite" && role == "false")
            base_price = base_price + 20;
        else if ($('select#rim_type').val() === "Elite" && role == "true")
            base_price = base_price + 12;
		if ($('select#brake_rotor').val() === "320MM_FLOATING")
			base_price = base_price + 49;

		var cushsel = $('#cush_drive');
		if (cushsel.val() == "Cush Drive") {
			base_price = base_price + 175;
		} else {
			base_price = base_price;
		}
		var carrier_css = $("#sprocket").css('display');
		if (carrier_css == "block") {
			var carrier = $('#carrier_id');
			if (carrier.val() == "Yes") {
				base_price = base_price + 175;
			} else {
				base_price = base_price;
			}
		}

		if ($('#spoke_color').val() === "Silver")
			spoke_price = 0;
		if ($('#spoke_color').val() === "Titanium")
			spoke_price = 249;

		if ($('#spoke_color').val() === "Teal" || $('#spoke_color').val() === "Illusion Violet") {
			spoke_price = 89;
		}

		if ($('#nipple_color').val() === "Silver" || $('#spoke_color').val() === "Titanium")
			nipple_price = 0;

		if ($('select#brake_rotor').val() === "Wave")
			brake_price = 0;

		if ($('select#rim_size').val() === "FRONT 19x2.15" || $('select#rim_size').val() === "19x2.15") {
			wheel_size_price = 0;
		}
		if ($('select#bike_model').val() === "DR650SE *REAR*" || $('select#bike_model').val() == "2008 – 2013 KTM 690 ENDURO * REAR *" || $('select#bike_model').val() == "2014 – 2017 KTM 690 ENDURO ABS * REAR *" || $('select#bike_model').val() == "KLR650 *REAR*" || $('select#bike_model').val() == "2016 - Current 701 Enduro *REAR*" || $('select#bike_model').val() == "701 Enduro ABS *REAR*") {
			// var base_price = 452;
			console.log('waaaaaaa');
			if ($('select#rim_size').val() === "REAR 17X3.50" && $('select#bike_model').val() === "DR650SE *REAR*") {
				console.log('DR650SE assign 17X3.50 price');
					var base_price = getMxWheelBasePrice(false, $('#wheel_type').val());
				} else {
					var base_price = getMxWheelBasePrice(false, $('#wheel_type').val());

				}
			brake_price = 0;
			var cushsel = $('#cush_drive');
			if (cushsel.val() == "Cush Drive") {
				base_price = base_price + 175;
			} else {
				base_price = base_price;
			}
			var carrier_css = $("#sprocket").css('display');
			if (carrier_css == "block") {
				var carrier = $('#carrier_id');
				if (carrier.val() == "Yes") {
					base_price = base_price + 175;
				} else {
					base_price = base_price;
				}
			}
		} else if (isMxAdventureBasePriceException($('select#bike_model').val()) && $('select#wheel_type').val() === "REAR") {
			var base_price = 737;
			brake_price = 0;
		} else if (isMxAdventureBasePriceException($('select#bike_model').val()) && $('select#wheel_type').val() === "FRONT") {
			var base_price = 649;
		} else {
			base_price = base_price;
		}

		if ($('select#bike_model').val() == "KLR650 *FRONT*" || $('select#bike_model').val() == "690 Enduro ABS *FRONT*" || $('select#bike_model').val() == "690 Enduro *FRONT*" || $('select#bike_model').val() == "701 Enduro ABS *FRONT*") {
			var base_price = getMxWheelBasePrice(false, "FRONT");
			brake_price = 0;
		}
		if ($('select#sprocket_bolts').val() === "Standard") {
			sprocket_bolts = 0;
		}
		if ($('select#bike_model').val() == "KLR650 *REAR* " || $('select#bike_model').val() == "KLR650 *FRONT*") {
			sprocket_bolts = 0;
		}
		if ($('select#rotor_bolts').val() === "Standard") {
			rotor_bolts = 0;
		}
		if ($('select#rim_size').val() == "REAR 18x2.50" || $('select#rim_size').val() == "REAR 19x2.50" || $('select#rim_size').val() == "FRONT 19x2.50") {
			if ($('select#bike_model').val() == "DR650SE *REAR*" || $('select#bike_model').val() == "KLR650 *REAR*") {
				rim_size = 25;
			} else {
				rim_size = 29;
			}
		} else if ($('select#rim_size').val() == "REAR 17x3.50") {
			rim_size = 55;
		} else if ($('select#rim_size').val() == "FRONT 19x2.15" || $('select#rim_size').val() === "19x2.15") {
			rim_size = 29;
		} else if ($('select#rim_size').val() == "REAR 19x3.00") {
			rim_size = 60;
		} else {
			rim_size = rim_size;
		}
		if ($('select#sm_magnets').val() == "NO" || $('select#sm_magnets').val() == "" || $('select#sm_magnets').val() == null) {
			magnet_price = 0;
		} else {
			magnet_price = 11;
		}
		//No SPROCKET
		if ($('select#sprocket_size').val() == "no" && $('#wheel_type').val() == "REAR") {
			sprocket_price = 0;
		} else if ($('#wheel_type').val() == "FRONT"){
			sprocket_price = 0;
            sprocket_bolts = 0;
		}		 
        else {
			sprocket_price = 0;
		}

		// Sample tire data
		var tireData = [{
				size: "Dunlop MX34  80/100-21",
				price: 137
			},
			{
				size: "Dunlop MX34 100/100-18",
				price: 147
			},
			{
				size: "Dunlop MX34 110/100-18",
				price: 142
			},
			{
				size: "Dunlop MX34 120/100-18",
				price: 146
			},
			{
				size: "Dunlop MX34 100/100-19",
				price: 145
			},
			{
				size: "Dunlop MX34 110/100-19",
				price: 156
			},
			{
				size: "Dunlop MX34 120/100-19",
				price: 157
			}
		];

		// Get the selected tire size
		var mbtire = $('select#mbtire').val();

		// Find the corresponding price based on the selected tire size
		var mbtire_price = 0;

		for (var i = 0; i < tireData.length; i++) {
			if (tireData[i].size === mbtire) {
				mbtire_price = tireData[i].price;
				break;
			}
		}

		var mbtire = $('#mbtire').val();
		var tirePrices = {
			"DUNLOP MX34 80/100-21": 166.95,
			"SHINKO 241 21x275": 113.95,
			"TUSK EMEX T-35 80/100-21": 95.00,
			"DUNLOP MX34 100/90-19": 177.95,
			"DUNLOP MX34 110/100-18": 173.95,
			"DUNLOP MX34 110/90-19": 191.95,
			"DUNLOP MX34 120/80-19": 193.95,
			"DUNLOP MX34 120/90-18": 178.95,
			"SHINKO 241 18x4.00": 146.95,
			"TUSK EMEX T-35 100/90-19": 104.00,
			"TUSK EMEX T-35 110/90-19": 107.00,
			"TUSK EMEX T-35 120/80-19": 108.00,
			"TUSK EMEX T-35 120/90-18": 108.00,
			"DUNLOP GEOMAX AT82 80/100-21": 170.95,
			"DUNLOP GEOMAX AT82 120/90-19": 209.95,
			"DUNLOP GEOMAX AT82 110/90-19": 194.95,
			"DUNLOP GEOMAX AT82 120/90-18": 180.95,
			"DUNLOP GEOMAX AT82 110/100-18": 189.95,
			"SHINKO E804 100/90-19": 177.95,
			"SHINKO E804 90/90-21": 197.95,
			"SHINKO E805 120/90-18": 177.95,
			"SHINKO E805 130/80-17": 246.95,
			"DUNLOP D606 90/90-21": 215.95,
			"DUNLOP D606 120/90-18": 219.95,
			"DUNLOP D606 130/90-17": 220.95,
			"IRC VE-33 GEKKOTA 110/100-18": 170.95,
			"IRC GX20 GEKKOTA 90/90-21": 143.95,
            "DUNLOP MX34 100/100-18": 184.95,
            "TUSK EMEX T-35 100/100-18": 123.99,
			"DUNLOP MX34 70/100-19": 114.95,
			"DUNLOP MX34 70/100-17": 122.95,
			"DUNLOP MX34 90/100-16": 125.95,
			"DUNLOP MX34 90/100-14": 123.95,
		};
		var selectedPrice = tirePrices[mbtire];
		if (selectedPrice !== undefined) {
			mbtire_price = selectedPrice;
		} else {
			mbtire_price = mbtire_price
		}

		if ($('select#rotor_bolts').val() === "Standard") {
			rotor_bolts = 0;
		} else {
			rotor_bolts = 21;
		}

		var has_rim_lock = document.querySelector('#rim_lock').value;
		var rim_lock = 0;
		if(has_rim_lock == "Yes"){
			if(document.querySelector('#rim_size').value.includes('19x3.0')){
				rim_lock = 26;
			}else{
				rim_lock = 21;
			}
		}  else {
			rim_lock = 0;
		}
		var price = base_price + spoke_price + nipple_price + brake_price + wheel_size_price + rim_color + sprocket_bolts + rotor_bolts + rim_size + magnet_price + mbtire_price + rim_lock + sprocket_price;
		// console.log({
		// 	detail: {
		// 		base_price,
		// 		spoke_price,
		// 		nipple_price,
		// 		brake_price,
		// 		wheel_size_price,
		// 		rim_color,
		// 		sprocket_bolts,
		// 		rim_size,
		// 		rotor_bolts,
		// 		magnet_price,
		// sprocket_price,
		// 		mbtire_price,
		// 		price
		// 	}
		// })
		price = roundUpIfEndsWith95(price);
		return price;
		
	}
	// get Retail Price

	$('select#rim__type').change(function () {
		if ($('select#rim_size').val() == "21x1.85 (OEM SIZE)" || $('select#rim_type').val() == "Elite" || $('select#rim_size').val() == "REAR 19x2.50" || $('select#rim_size').val() == "FRONT 19x2.50" || $('select#rim_size').val() == "REAR 18x2.50") {
			var rim_color_wrapper = $('.rim_color_wrapper');
			rim_color_wrapper.empty().append(`<div class="color-swatch active show"  data-category="anodized"  data-value="Black" style="background: url(${images}black.svg?v=1717478021);">`);
			$('#rim_color').val('Black');
			var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/rim-" + $('#rim_color').val() + "-" + $('select#wheel_type').val() + ".png";
			var imageArr2 = [image_name];
			var divArr2 = ["resultAreaID_1_1"];
			$('#resultAreaID_1_1 img').attr('src', image_name);
		} else {
			if ($('select#bike_model').val() == "890 Adventure *FRONT*" || $('select#bike_model').val() == "890 Adventure R *FRONT*" || $('select#bike_model').val() == "790 Adventure *FRONT*" || $('select#bike_model').val() == "790 Adventure R *FRONT*" || $('select#bike_model').val() == "950 Adventure *FRONT*" || $('select#bike_model').val() == "990 Adventure *FRONT*" || $('select#bike_model').val() == "1090 Adventure *FRONT*" || $('select#bike_model').val() == "1190 Adventure *FRONT*" || $('select#bike_model').val() == "1290 Adventure ABS *FRONT*" || $('select#bike_model').val() == "1290 Adventure R *FRONT*" || $('select#bike_model').val() == "1290 Super Adventure S *FRONT*") {
				//Rim Type
				var select = $('#rim_type');
				select.empty().append('<option id="Elite" class="category" value="Elite">Elite</option>');
				var rim_color_wrapper = $('.rim_color_wrapper');
				rim_color_wrapper.empty().append(`<div class="color-swatch active show"  data-category="anodized"  data-value="Black" style="background: url(${images}black.svg?v=1717478021);">`);
				$('#rim_color').val('Black');
				var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/rim-" + $('#rim_color').val() + "-" + $('select#wheel_type').val() + ".png";
				var imageArr2 = [image_name];
				var divArr2 = ["resultAreaID_1_1"];
				$('#resultAreaID_1_1 img').attr('src', image_name);
			} else {
				if ($('select#rim_size').val() == "FRONT 21x1.60" || $('select#rim_size').val() == "REAR 18x2.15" || $('select#rim_size').val() == "REAR 19x2.15") {
					var select = $('#rim_color');
					//Rim Color Temp Hide
					//Temp Hide Anodized Color <option class="opdis" value="Anodized" disabled>Anodized</option><option class="category" value="Black">Black</option><option class="category" value="Blue">Blue</option><option class="category" value="Green">Green</option><option class="category" value="Gold">Gold</option><option class="category" value="Magnesium">Magnesium</option><option class="category" value="Matte-Black">Matte Black</option><option class="category" value="AOrange">Orange</option><option class="category" value="Purple">Purple</option><option class="category" value="Red"></option><option class="category" value="Silver">Silver</option><option class="opdis" value="Powder-Coated" disabled>Powder Coated</option><option class="category" value="Blue">Blue</option><option class="category" value="Baby-Blue">Baby Blue</option><option class="category" value="Flo-Yellow">Flo Yellow</option><option class="category" value="Nardo-Grey">Nardo Grey</option><option class="category" value="Orange">Orange</option><option class="category" value="School-Bus-Yellow">School Bus Yellow</option><option class="category" value="White">White</option>
					select.empty().append('<option class="opdis" value="Anodized" disabled>Anodized</option><option class="category" value="Black">Black</option><option class="category" value="Matte-Black">Matte Black</option><option class="opdis" value="Powder-Coated" disabled>Powder Coated</option><option class="category" value="Blue">Blue</option><option class="category" value="Baby-Blue">Baby Blue</option><option class="category" value="Flo-Yellow">Flo Yellow</option><option class="category" value="Nardo-Grey">Nardo Grey</option><option class="category" value="Orange">Orange</option><option class="category" value="School-Bus-Yellow">School Bus Yellow</option><option class="category" value="White">White</option>');
					var rim_color_wrapper = $('.rim_color_wrapper');
					rim_color_wrapper.empty().append(`<div class="color-swatch active show"  data-category="anodized"  data-value="Black" style="background: url(${images}black.svg?v=1717478021);"></div>
                <div class="color-swatch"  data-category="anodized" data-value="Matte-Black" style="background: url(${images}matte-black.svg?v=1717478021);"></div>
                <div class="color-swatch"  data-category="powder-coat" data-value="Blue" style="background: url(${images}blue.svg?v=1717478021);"></div>
                <div class="color-swatch"  data-category="powder-coat" data-value="Baby-Blue" style="background: url(${images}baby-blue.svg?v=1717478021);"></div>
                <div class="color-swatch"  data-category="powder-coat" data-value="Flo-Yellow" style="background: url(${images}flo-yellow.svg?v=1717478021);"></div>
                <div class="color-swatch"  data-category="powder-coat" data-value="Nardo-Grey" style="background: url(${images}nardo-grey.svg?v=1717478021);"></div>
                <div class="color-swatch"  data-category="powder-coat" data-value="Orange" style="background: url(${images}orange.svg?v=1717478021);"></div>
                <div class="color-swatch"  data-category="powder-coat" data-value="School-Bus-Yellow" style="background: url(${images}school-bus-yellow.svg?v=1717478021);"></div>
                <div class="color-swatch"  data-category="powder-coat" data-value="White" style="background: url(${images}white.svg?v=1717478021);"></div>`);
				} else if ($('select#wheel_type').val() === "REAR") {
					if ($('select#rim_size').val() == "REAR 18x2.50" || $('select#rim_size').val() == "REAR 19x2.50" || $('select#rim_size').val() == "18X2.50 (OEM SIZE)" || $('select#rim_size').val() == "21x1.85 (OEM SIZE)") {
						//Rim Color Temp Hide
						//Temp Hide Anodized Color <option class="opdis" value="Anodized" disabled>Anodized</option><option class="category" value="Black">Black</option><option class="category" value="Silver">Silver</option>
						var rim_color_wrapper = $('.rim_color_wrapper');
						rim_color_wrapper.empty().append(`<div class="color-swatch active show" data-category="anodized"   data-value="Black" style="background: url(${images}black.svg?v=1717478021);">`);
					}

				} else {
					var select = $('#rim_color');
					//Rim Color Temp Hide
					//Temp Hide Anodized Color <option class="opdis" value="Anodized" disabled>Anodized</option><option class="category" value="Black">Black</option><option class="category" value="Silver">Silver</option><option class="category" value="Matte-Black">Matte Black</option>
					var rim_color_wrapper = $('.rim_color_wrapper');
					rim_color_wrapper.empty().append(`<div class="color-swatch active" data-value="Black" style="background: url(${images}black.svg?v=1717478021);"><div class="color-swatch" data-value="Matte-Black" style="background: url(${images}matte-black.svg?v=1717478021);">`);
				}
				$('#rim_color').val('Black');
				var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/rim-" + $('#rim_color').val() + "-" + $('select#wheel_type').val() + ".png";
				// console.log(image_name);
				var imageArr2 = [image_name];
				var divArr2 = ["resultAreaID_1_1"];
				$('#resultAreaID_1_1 img').attr('src', image_name);
			}
		}


	});

	function hideShowRimColor() {
		// console.log('COLOR SWITCH RUNNING')
		var rim_type = $('select#rim_type').val();
		var rim_size = $('select#rim_size').val();

		var selected_make = $('#bike_make').val();
		var selected_model = $('#bike_model').val();
		var selected_wheel_type = $('#wheel_type').val();
		var selected_rim_size = $('#rim_size').val();
		// // For Front / KTM / Adventure / 2.15 / 1.85
		// if(
		// 	selected_wheel_type == "FRONT" && 
		// 	selected_make == "KTM" && 
		// 	(
		// 		selected_model == '790 Adventure *FRONT*' || 
		// 		selected_model == '890 Adventure *FRONT*' || 
		// 		selected_model == '950 Adventure *FRONT*' || 
		// 		selected_model == '990 Adventure *FRONT*' || 
		// 		selected_model == '1090 Adventure *FRONT*' || 
		// 		selected_model == '1190 Adventure *FRONT*' || 
		// 		selected_model == '1290 Adventure ABS *FRONT*'
				
		// 	)
		// 	&& (
		// 		selected_rim_size == "FRONT 21x2.15" ||
		// 		selected_rim_size == "FRONT 21x1.85" 

		// 	)
		// ){
		// 	$(".rim-type-wrap.powder-coat").show();
		// 	$('.rim_color_wrapper .color-swatch:not([data-value="Black"])').each(function(){
		// 		$(this).removeClass('show');
		// 	});
		// 	$('[data-category="anodized"]').click();
		// 	$('.rim_color_wrapper [data-category="anodized"][data-value="Black"]').click();
		// }
		// else 
		if (rim_type == 'Elite') {
			// Elite rims are only available in black.
			$(".rim-type-wrap.powder-coat").hide();
			$(".rim-type-wrap.anodized").trigger("click");
			applyEliteBlackRimOnly();

		} else {
			//show all rims
			$(".rim-type-wrap.powder-coat").show();
			// $(".rim-type-wrap.anodized").trigger("click");       
		}
	}
	$('select#wheel_type').change(hideShowRimColor);
	$('select#bike_model').change(hideShowRimColor);
	$('select#bike_make').change(hideShowRimColor);
	$('select#rim_size').change(hideShowRimColor);

	$('select#rim_type').change(function () {
		var rim_type = $('select#rim_type').val();
		var rim_size = $('select#rim_size').val();
		var rimcolor = hideShowRimColor();
		if(rim_type == 'Standard'){
			$('[data-category="anodized"]').click();
			$('.rim_color_wrapper [data-category="anodized"][data-value="Black"]').click();
		}

		
	});

	$('select#bike_model').change(speedometer);
	$('select#bike_make').change(bikeyear);
	$('select#bike_model').change(spoketitanium);
	$('select#bike_make').change(speedometer);
	$('select#bike_year').change(spoketitanium);
	$('select#rim_size').change(spoketitanium);
	$('select#wheel_type').change(spoketitanium);

	$('select#wheel_type').change(function () {
		var bikeModelSelect = document.getElementById("bike_model");
		const selectedText = bikeModelSelect.options[bikeModelSelect.selectedIndex].text;

		var select_model = $('select#bike_model');
		$("option:selected", select_model).removeAttr("selected");
		$('select#hidden_bike_model option').appendTo('select#bike_model');
		switch (this.value) {
			default:
			case 'FRONT':
				$('select#bike_model option.rear').appendTo('select#hidden_bike_model');
				break;
			case 'REAR':
				$('select#bike_model option.front').appendTo('select#hidden_bike_model');
				break;
		}
		select_model.val(select_model.find('option').first().val()).change();

		var bikeModelSelect = document.getElementById("bike_model");
		var options = bikeModelSelect.options;

		for (let i = 0; i < options.length; i++) {
			if (options[i].text === selectedText) {
				bikeModelSelect.selectedIndex = i;
				break;
			}
		}

		select_model.change();
		$('#rotor_bolts').prop('selectedIndex', 0);
	});

	$('select#wheel_type').change(function () {
		// $('#hub_color').prop('selectedIndex', 0);
		console.log('slected bike model:', $('select#bike_model').val());
		//BRAKE TYPE
		if ($('select#bike_model').val() == '790 Adventure *FRONT*' || $('select#bike_model').val() == '790 Adventure R *FRONT*' || $('select#bike_model').val() == '890 Adventure *FRONT*' || $('select#bike_model').val() == '890 Adventure R *FRONT*' || $('select#bike_model').val() == '950 Adventure *FRONT*' || $('select#bike_model').val() == '990 Adventure *FRONT*' || $('select#bike_model').val() == '1090 Adventure *FRONT*' || $('select#bike_model').val() == '1190 Adventure *FRONT*' || $('select#bike_model').val() == '1290 Adventure ABS *FRONT*' || $('select#bike_model').val() == "1290 Adventure R *FRONT*" || $('select#bike_model').val() == "1290 Super Adventure S *FRONT*") {
			//Rim Type
			var select = $('#rim_type');
			select.empty().append('<option id="Elite" class="category" value="Elite">Elite</option>');
			//Dual Rotor
			var select = $('#brake_rotor');
			select.empty().append('<option value="Dual">Dual</option>');
			var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/dual-rotor-" + $('select#wheel_type').val() + ".png";
			$('#resultAreaID_1_6 img').attr('src', image_name);
			// imageObj5 = new BL_ImageLoader(divArr5, imageArr5);
		} 
		else if ($('select#bike_model').val() === '690 Enduro *FRONT*') {
			console.log('690 Enduro *FRONT* selected');
		}
		else {
			// console.log('bike wheel type : ' + $('select#wheel_type').val());
			var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/brake-" + $('select#brake_rotor').val() + "-" + $('select#wheel_type').val() + ".png";
			var wheeltype = $('select#wheel_type').val();
			if (wheeltype == 'FRONT') {
				var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/apex-rotor.png?v=1709797046";
			} else {
				var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/rear-apex-rotor.png?v=1709797379";
			}
			$('#resultAreaID_1_6 img').attr('src', image_name);
			// imageObj5 = new BL_ImageLoader(divArr5, imageArr5);
		}
		//HUB COLOR
		var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/hub-" + $('#hub_color').val() + "-" + $('select#wheel_type').val() + ".png";
		var imageArr1 = [image_name];
		var divArr1 = ["resultAreaID_1_0"];
		$('#resultAreaID_1_0 img').attr('src', image_name);
		// imageObj = new BL_ImageLoader(divArr1, imageArr1);
		//RIM COLOR
		var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/rim-" + $('#rim_color').val() + "-" + $('select#wheel_type').val() + ".png";
		var imageArr2 = [image_name];
		var divArr2 = ["resultAreaID_1_1"];
		$('#resultAreaID_1_1 img').attr('src', image_name);
		// imageObj2 = new BL_ImageLoader(divArr2, imageArr2);
		//SPOKE COLOR
		var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/spokes-" + $('#spoke_color').val() + "-" + $('select#wheel_type').val() + ".png";
		var imageArr3 = [image_name];
		var divArr3 = ["resultAreaID_1_2"];
		$('#resultAreaID_1_2 img').attr('src', image_name);
		// imageObj3 = new BL_ImageLoader(divArr3, imageArr3);
		//NIPPLE COLOR
		var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/nipple-" + $('#nipple_color').val() + "-" + $('select#wheel_type').val() + ".png";
		var imageArr4 = [image_name];
		var divArr4 = ["resultAreaID_1_3"];
		$('#resultAreaID_1_3 img').attr('src', image_name);
		// imageObj4 = new BL_ImageLoader(divArr4, imageArr4);
		// $("#resultAreaID_1_3").find("img").unwrap();

		// console.log(imageArr1, imageArr2, imageArr3, imageArr4);

		//SPROCKET SIZE
		if ($('#speedometer').css('display') != 'none') {
			$("#sm_magnets").val(1);
			if ($("select#sm_magnets").val() == "BLACK" || $("select#sm_magnets").val() == "BLUE" || $("select#sm_magnets").val() == "ORANGE") {
				$("#resultAreaID_1_7").show();
				var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/magnet-" + $('select#sm_magnets').val() + '-' + $('select#wheel_type').val() + ".png";
				var imageArr6 = [image_name];
				var divArr6 = ["resultAreaID_1_7"];
				$('#resultAreaID_1_7 img').attr('src', image_name);
				// imageObj6 = new BL_ImageLoader(divArr6, imageArr6);
			} else if ($("select#sm_magnets").val() == "NO") {
				$("#resultAreaID_1_7").hide();
			} else {
				var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/sprocket.png";
				var imageArr6 = [image_name];
				var divArr6 = ["resultAreaID_1_7"];
				$('#resultAreaID_1_7 img').attr('src', image_name);
				// imageObj6 = new BL_ImageLoader(divArr6, imageArr6);
			}
		} else {
			if ($('select#wheel_type').val() == 'FRONT') {
				// $('#sprocket').hide();
				$('#resultAreaID_1_7').hide();
                sprocket_bolts = 0;
			} else {
				var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/sprocket.png";
				var imageArr6 = [image_name];
				var divArr6 = ["resultAreaID_1_7"];
				$('#resultAreaID_1_7 img').attr('src', image_name);
				// imageObj6 = new BL_ImageLoader(divArr6, imageArr6);
			}

		}


		// if ($('select#bike_make').val() == 'KTM' && $('select#wheel_type').val() == 'REAR') {
		// 	var select = $('#sprocket_size');
		// 	select.empty().append('<option class="category" value="40 Teeth">40 Teeth</option><option class="category" value="44 Teeth">44 Teeth</option><option class="category" value="45 Teeth">45 Teeth</option><option class="category" value="47 Teeth">47 Teeth</option><option class="category" value="48 Teeth">48 Teeth</option><option class="category" value="49 Teeth">49 Teeth</option><option class="category" value="50 Teeth">50 Teeth</option><option class="category" value="51 Teeth">51 Teeth</option><option class="category" value="52 Teeth">52 Teeth</option><option class="category" value="53 Teeth">53 Teeth</option><option value="no">No Sprocket</option>');
		// } else {
		// 	var select = $('#sprocket_size');
		// 	select.empty().append('<option class="category" value="40 Teeth">40 Teeth</option><option class="category" value="44 Teeth">44 Teeth</option><option class="category" value="47 Teeth">47 Teeth</option><option class="category" value="48 Teeth">48 Teeth</option><option class="category" value="49 Teeth">49 Teeth</option><option class="category" value="50 Teeth">50 Teeth</option><option class="category" value="51 Teeth">51 Teeth</option><option class="category" value="52 Teeth">52 Teeth</option><option class="category" value="53 Teeth">53 Teeth</option><option value="no">No Sprocket</option>');
		// }


		if ($('select#wheel_type').val() == 'FRONT') {
			// $('#sprocket').hide();
			$('#resultAreaID_1_7').hide();
            sprocket_bolts = 0;
		} else {
			// $('#sprocket').show();
			sprockethide();
		}

		if ($('select#bike_make').val() === "Honda" || $('select#bike_make').val() === "Husqvarna" || $('select#bike_make').val() === "Kawasaki" || $('select#bike_make').val() === "KTM" || $('select#bike_make').val() === "Suzuki" || $('select#bike_make').val() === "GasGas") {
			if ($('select#wheel_type').val() === "REAR") {
				// document.getElementById("cush_drive").disabled = false;
				// var select = $('#cush_drive');

				// var enable_cush_drive = [
				// 	'2017+ CRF250L *REAR*',
				// 	'CRF250L ABS *REAR*',
				// 	'2017+ CRF250L Rally *REAR*',
				// 	'CRF250L Rally ABS *REAR*',
				// 	'CRF300L *REAR*',
				// 	'CRF300L ABS *REAR*',
				// 	'CRF300L Rally *REAR*',
				// 	'CRF300L Rally ABS *REAR*'
				// ];
				// var selectedModel = $('#bike_model').val();
				// if ($('select#bike_make').val() === "Honda" && enable_cush_drive.includes(selectedModel)) {
				// 	select.empty().append('<option class="category" value="unavailable">Standard</option><option class="category" value="Cush Drive">Cush Drive</option>');

				// } else {
				// 	select.empty().append('<option class="category" value="unavailable">Standard</option>');
				// }
			}
		}
		// if ($('select#wheel_type').val() == 'FRONT')

		// {
		// 	$('#cush_drive1').hide();
		// } else {
		// 	$('#cush_drive1').show();
		// }

		if ($('select#bike_model').val() == "1991 - 2012 KTM ALL 125-525 EXC/EXC-F/XC-W/XCF-W/SX/SXF * REAR *" || $('select#bike_model').val() == "2008 - 2017 EN 125-530 (will not fit SM) *REAR*" || $('select#bike_model').val() == "2008 - 2017 EN 125-530 (will not fit SM) * REAR *" || $('select#bike_model').val() == "2008 - 2017 125-300 SE-R * REAR *" || $('select#bike_model').val() == "2008 - 2017 250-450 SER * REAR *" || $('select#bike_model').val() == "2008 - 2017 250-450 SEF-R * REAR *" || $('select#bike_model').val() == "All years and models * REAR *" || $('select#bike_model').val() == "Enduro * REAR *" || $('select#bike_model').val() == "2013 - 2017 All models *REAR*" || $('select#bike_model').val() == "1989 - 97 CR125, CR250 *REAR*" || $('select#bike_model').val() == "2000 - 12 CR125, CR250 *REAR*" || $('select#bike_model').val() == "2017+ CRF250L *REAR*" || $('select#bike_model').val() == "CRF300L *REAR*" || $('select#bike_model').val() == "CRF300L ABS *REAR*" || $('select#bike_model').val() == "CRF300L Rally *REAR*" || $('select#bike_model').val() == "CRF300L Rally ABS *REAR*" || $('select#bike_model').val() == "CRF250L ABS *REAR*" || $('select#bike_model').val() == "2017+ CRF250L Rally *REAR*" || $('select#bike_model').val() == "2004 - 13 CRF250R *REAR*" || $('select#bike_model').val() == "2004 - 2017 CRF250X *REAR*" || $('select#bike_model').val() == "1996 - 04 XR 400 *REAR*" || $('select#bike_model').val() == "2002 - 12 CRF450R *REAR*" || $('select#bike_model').val() == "CRF450R Works Edition *REAR*" || $('select#bike_model').val() == "CRF450L *REAR*" || $('select#bike_model').val() == "CRF450RL *REAR*" || $('select#bike_model').val() == "2002 - 2017 CRF450X *REAR*" || $('select#bike_model').val() == "2017+ CRF450RX *REAR*" || $('select#bike_model').val() == "CRF250RX *REAR*") {


			// var select = $('#sprocket_size');
			// select.empty().append('<option class="category" value="40 Teeth">40 Teeth</option><option class="category" value="41 Teeth">41 Teeth</option><option class="category" value="42 Teeth">42 Teeth</option><option class="category" value="44 Teeth">44 Teeth</option><option class="category" value="45 Teeth">45 Teeth</option><option class="category" value="47 Teeth">47 Teeth</option><option class="category" value="48 Teeth">48 Teeth</option><option class="category" value="49 Teeth">49 Teeth</option><option class="category" value="50 Teeth">50 Teeth</option><option class="category" value="51 Teeth">51 Teeth</option><option class="category" value="52 Teeth">52 Teeth</option><option value="no">No Sprocket</option>');
		}
		// nosprocket();
		if ($('select#bike_model').val() === "DR650SE *REAR*" || $('select#bike_model').val() == "2008 – 2013 KTM 690 ENDURO * REAR *" || $('select#bike_model').val() == "2014 – 2017 KTM 690 ENDURO ABS * REAR *" || $('select#bike_model').val() == "KLR650 *REAR*" || $('select#bike_model').val() == "2016 - Current 701 Enduro *REAR*" || $('select#bike_model').val() == "701 Enduro ABS *REAR*") {
			$('#sprocketbolts').css("display", "none");

		} else {
			if ($('select#wheel_type').val() == "FRONT") {
				$('#sprocketbolts').css("display", "none");
                sprocket_bolts = 0;
			} else {
				$('#sprocketbolts').css("display", "block");
			}
		}
		//Fron suspension Logic//
		if ($('select#wheel_type').val() == "FRONT" & $('select#bike_make').val() == 'Sherco') {
			$('#frontsuspension').show();
		} else {
			$('#frontsuspension').hide();

		}
		//Bike Make 
		if ($('select#bike_make').val() == "Alta Redshift" || $('select#bike_make').val() == "GasGas" || $('select#bike_make').val() == "Husaberg" || $('select#bike_make').val() == "Beta" || $('select#bike_make').val() == "TM" || $('select#bike_make').val() == "Honda" || $('select#bike_make').val() == "Kawasaki" || $('select#bike_make').val() == "KTM" || $('select#bike_make').val() == "Yamaha") {
			var select = $('#spoke_color');
			select.empty().append('<option class="category" value="Silver">Silver</option><option class="category" value="Black">Black</option><option class="category" value="Blue">Blue</option><option class="category" value="Green">Green</option><option class="category" value="Orange">Orange</option><option class="category" value="Red"></option><option class="category" value="White">White</option><option class="category" value="Yellow">Yellow</option><option class="category" value="Flo-Yellow">Flo Yellow</option><option class="category" value="Titanium">Titanium</option>');
		} else {
			var select = $('#spoke_color');
			select.empty().append('<option class="category" value="Silver">Silver</option><option class="category" value="Black">Black</option><option class="category" value="Blue">Blue</option><option class="category" value="Green">Green</option><option class="category" value="Orange">Orange</option><option class="category" value="Red"></option><option class="category" value="White">White</option><option class="category" value="Yellow">Yellow</option><option class="category" value="Flo-Yellow">Flo Yellow</option>');
		}
		// hide320mm();
		//Nipple Spoke Color
		nipplespokecolor();
		nipplecolorreset();
	});

	function setRimType(){
		// console.info('WORKING')
		var selected_make = $('#bike_make').val();
		var selected_model = $('#bike_model').val();
		var selected_wheel_type = $('#wheel_type').val();
		
		switch (selected_wheel_type) {
			case 'FRONT':
				if ($('select#bike_model').val() == '1996 - 2017 DR650 *FRONT*') {
					var rim_size = {
						'FRONT 21x1.60': 'FRONT 21x1.60',
						'FRONT 19x2.15': 'FRONT 19x2.15',
						"FRONT 19x2.50": "FRONT 19x2.50",
						'FRONT 21x1.85 (OEM Size)': 'FRONT 21x1.85 (OEM Size)',
					};
				} else if ($('select#bike_model').val() == 'KLR650 Gen 3 *FRONT*') {
					var rim_size = {
						'FRONT 21x1.60': 'FRONT 21x1.60',
						'FRONT 21x1.85': 'FRONT 21x1.85',
					};
				}
				else if ($('select#bike_model').val() == 'SX 85 *FRONT*') {
					var rim_size = {
						'FRONT 19X1.60': 'FRONT 19X1.60',
						'FRONT 17X1.40': 'FRONT 17X1.40',
					}
				}
				else if ($('select#bike_model').val() == 'KLR650 *FRONT*') {
					var rim_size = {
						'FRONT 21x1.60': 'FRONT 21x1.60',
						'FRONT 21x1.85 ( OEM SIZE )': 'FRONT 21x1.85 ( OEM SIZE )',
						'FRONT 19x2.15': 'FRONT 19x2.15',
						"FRONT 19x2.50": "FRONT 19x2.50",
					};
				}
				// last KTM rims update FRONT
				else if
					(
						$('select#bike_model').val() == '950 Adventure *FRONT*' || 
						$('select#bike_model').val() == '950 Adventure S *FRONT*' ||
						$('select#bike_model').val() == '990 Adventure *FRONT*' ||
						$('select#bike_model').val() == '990 Adventure Baja *FRONT*' ||
						$('select#bike_model').val() == '990 Adventure Dakar *FRONT*' ||
						$('select#bike_model').val() == '990 Adventure R *FRONT*'
					) {
					var rim_size = {
						'FRONT 21x2.15': 'FRONT 21x2.15',
					};
				}
				else {
					var rim_size = {
						'FRONT 21x1.85': 'FRONT 21x1.85',
						'FRONT 21x1.60': 'FRONT 21x1.60',
						'FRONT 19x2.15': 'FRONT 19x2.15',
						"FRONT 19x2.50": "FRONT 19x2.50",
					};
				}

				break;
			case 'REAR':
				if ($('select#bike_model').val() == 'SX 85 *REAR*') {
					var rim_size = {
						'REAR 16X1.85': 'REAR 16X1.85',
						'REAR 14X1.60': 'REAR 14X1.60',
					}
				} else if ($('select#bike_model').val() == 'KLR650 Gen 3 *REAR*') {
					var rim_size = {
						'REAR 17X2.50': 'REAR 17X2.50',
					}
				}
				// last KTM rims update REAR
				else if
					(
						$('select#bike_model').val() == '950 Adventure *REAR*' || 
						$('select#bike_model').val() == '950 Adventure S *REAR*' || 
						$('select#bike_model').val() == '990 Adventure *REAR*' || 
						$('select#bike_model').val() == '990 Adventure Baja *REAR*' ||
						$('select#bike_model').val() == '990 Adventure Dakar *REAR*' ||
						$('select#bike_model').val() == '990 Adventure R *REAR*'
					) 
					{
					var rim_size = {
						'REAR 18x4.25"': 'REAR 18x4.25"'
					};
				}
				else if ($('select#bike_model').val() == 'DR650SE *REAR*') {
					var rim_size = {
						"REAR 18x2.15": "REAR 18x2.15",
						"REAR 18x2.50": "REAR 18x2.50",
						"REAR 17X2.50": "REAR 17X2.50",
						"REAR 17X3.50": "REAR 17X3.50",
						"REAR 19x2.15": "REAR 19x2.15",
						"REAR 19x2.50": "REAR 19x2.50",
						"REAR 19x3.00": "REAR 19x3.00"
					};
				} else if ($('select#bike_model').val() == 'KLR650 *REAR*') {
					var rim_size = {
						'REAR 17x1.85 ( OEM SIZE )': 'REAR 17x1.85 ( OEM SIZE )',
						'REAR 18x2.15': 'REAR 18x2.15',
						'REAR 18x2.50': 'REAR 18x2.50',
						'REAR 19x2.15': 'REAR 19x2.15',
						'REAR 19x2.50': 'REAR 19x2.50',
						'REAR 19x3.00': 'REAR 19x3.00'
					};
				}else {
					$('select#bike_model option.front').appendTo('select#hidden_bike_model');
					var rim_size = {
						'REAR 18x2.15': 'REAR 18x2.15',
						'REAR 18x2.50': 'REAR 18x2.50',
						'REAR 19x2.15': 'REAR 19x2.15',
						'REAR 19x2.50': 'REAR 19x2.50',
						'REAR 19x3.00': 'REAR 19x3.00'
					};
				}
				break;
		}

		if(selected_wheel_type == "FRONT" && $('#bike_make').val() == "Kove"){
			var rim_size = {
					'FRONT 21x1.60"': 'FRONT 21x1.60"',
					'21x1.85 (OEM SIZE)': '21x1.85 (OEM SIZE)',
				};

		}else if(selected_wheel_type == "REAR" && $('#bike_make').val() == "Kove"){
			var rim_size = {
					'REAR 18x2.15': 'REAR 18X2.15',
					'18X2.50 (OEM SIZE)': "18X2.50 (OEM SIZE)",
				};

		}
		// 790 and 890 Adventure
		// KTM 950 Adventure
		// KTM 990 Adventure
		// KTM 1090 Adventure
		// KTM 1190 Adventure
		// KTM 1290 Adventure
		var selected_model_text = $("#bike_model").val();
		selected_model_text = selected_model_text.toLowerCase();

		if (
			selected_wheel_type == "FRONT" && 
			selected_make == "KTM" && 
			(
				selected_model == '790 Adventure *FRONT*' || 
				selected_model == '790 Adventure R *FRONT*' ||
				selected_model == '1290 Adventure ABS *FRONT*' ||
				selected_model == '1290 Adventure R *FRONT*' ||
				selected_model == '1290 Super Adventure S *FRONT*'
			)
		){
			var rim_size = {
				'FRONT 21x1.85': 'FRONT 21x1.85',
				'FRONT 21x2.15': 'FRONT 21x2.15',
				'FRONT 19x2.15': 'FRONT 19x3.00',
			}
		}
		if(
			selected_wheel_type == "FRONT" && 
			selected_make == "KTM" && 
			(
				selected_model == '890 Adventure R *FRONT*' || 
				selected_model == '890 Adventure *FRONT*' ||
				selected_model == '1090 Adventure *FRONT*' || 
				selected_model == '1190 Adventure *FRONT*'
				// selected_model_text.includes('adventure')
				
			)
		){
			var rim_size = {
				'FRONT 21x1.60': 'FRONT 21x1.60',
				'FRONT 21x1.85': 'FRONT 21x1.85',
				'FRONT 21x2.15': 'FRONT 21x2.15',
				'FRONT 19x2.15': 'FRONT 19x2.15',
				"FRONT 19x2.50": "FRONT 19x2.50",
			};
			// console.info('WORKING - KTM 790 Adventure front selected')
		}
		if (
			selected_wheel_type == "REAR" && 
			selected_make == "KTM" && 
			(
				selected_model == '790 Adventure *REAR*' || 
				selected_model == '790 Adventure R *REAR*' ||
				selected_model == '1290 Adventure ABS *REAR*' ||
				selected_model == '1290 Adventure R *REAR*' ||
				selected_model == '1290 Super Adventure S *REAR*'
			)
		){
			var rim_size = {
				'REAR 18x2.50': 'REAR 18x2.50',
				'REAR 18x4.25': 'REAR 18x4.25'
			};
		}  
		if(
				selected_wheel_type == "REAR" && 
				selected_make == "KTM" && 
				(
					selected_model == '890 Adventure *REAR*' || 
					selected_model == '890 Adventure R *REAR*' || 
					selected_model == '1090 Adventure *REAR*' || 
					selected_model == '1190 Adventure *REAR*'
					// selected_model_text.includes('adventure')
				)
			){
			var rim_size = {
				'REAR 18x2.15': 'REAR 18x2.15',
				'REAR 18x2.50': 'REAR 18x2.50',
				'REAR 18x4.25': 'REAR 18x4.25',
				'REAR 19x2.15': 'REAR 19x2.15',
				'REAR 19x2.50': 'REAR 19x2.50',
				'REAR 19x3.00': 'REAR 19x3.00'
			};
		}
		
		var rimSizeSelect = $('select#rim_size');
		rimSizeSelect.empty();
		$.each(rim_size, function (value, text) {
			// Create a new option element and append it to the select element
			rimSizeSelect.append($('<option>', {
				value: value,
				text: text
			}));
		});

		var rimSizeVal = rimSizeSelect.val();
		var wheel_type = $('select#wheel_type').val();
		// console.log({wheel_type});
		if (wheel_type == 'REAR') {
			if (rimSizeVal == 'REAR 18x2.15' || rimSizeVal == 'REAR 18x2.50') {
				var mbtire = $('select#mbtire');
				mbtire.empty();
				$.each(mbtireRearOptions18, function (value, text) {
					var option = $('<option>', {
						value: value,
						text: text
					});

					// Add the 'selected' attribute to the first option
					if (mbtire.is(':empty')) {
						option.prop('selected', true);
					}

					mbtire.append(option);
				});
			} 
			// else if (rimSizeVal == 'REAR 16X1.85' || rimSizeVal == 'REAR 14X1.60') {
			// 	var mbtire = $('select#mbtire');
			// 	mbtire.empty();
			// 	$.each(ktm85RearOptions, function(value, text) {
					
			// 		var option = $('<option>', {
			// 			value: value,
			// 			text: text
			// 		});

			// 		console.log('populating tire options for SX 85');
			// 		mbtire.append(option);
			// 	});
			// 	return;
			// }
			else {
				var mbtire = $('select#mbtire');
				mbtire.empty();
				$.each(mbtireRearOptions19, function (value, text) {
					// mbtire.append($('<option>', {
					//     value: value,
					//     text: text
					// }));
					var option = $('<option>', {
						value: value,
						text: text
					});

					// Add the 'selected' attribute to the first option
					if (mbtire.is(':empty')) {
						option.prop('selected', true);
					}

					mbtire.append(option);
				});
			}
		} else {
			// check rim size value
			var mbtire = $('select#mbtire');
			mbtire.empty();
			$.each(mbtireFrontOptions, function (value, text) {
				// mbtire.append($('<option>', {
				//     value: value,
				//     text: text
				// }));
				var option = $('<option>', {
					value: value,
					text: text
				});

				// Add the 'selected' attribute to the first option
				if (mbtire.is(':empty')) {
					option.prop('selected', true);
				}

				mbtire.append(option);
			});
		}

		// console.log("on wheel change : ", mbtire.val());
		tprice()
	}
	
	$('select#wheel_type').change(setRimType);
	$('select#bike_model').change(setRimType);
	$('select#bike_year').change(setRimType);

	$('select#rim_size').change(function () {
		var rimSize = this.value;
    var wheelType = $('#wheel_type').val();

    if (rimSize === "FRONT 21x2.15" || rimSize === "FRONT 21x1.85" || rimSize === "21x1.85 (OEM SIZE)" || rimSize === "REAR 18x4.25") {
			// console.log("enter rimsize validation", wheelType, rimSize);
        // Only show black anodized and powder coat options
        var select = $('#rim_color');
        select.empty().append(`
            <option class="category" value="Black">Black</option>
            <option class="category" value="Blue">Blue</option>
            <option class="category" value="Baby-Blue">Baby Blue</option>
            <option class="category" value="Flo-Yellow">Flo Yellow</option>
            <option class="category" value="Nardo-Grey">Nardo Grey</option>
            <option class="category" value="Orange">Orange</option>
            <option class="category" value="School-Bus-Yellow">School Bus Yellow</option>
            <option class="category" value="White">White</option>
        `);

        var rim_color_wrapper = $('.rim_color_wrapper');
        rim_color_wrapper.empty().append(`
            <div class="color-swatch active show" data-category="anodized" data-value="Black" style="background: url(${images}black.svg?v=1717478021);"></div>
            <div class="color-swatch" data-category="powder-coat" data-value="Blue" style="background: url(${images}blue.svg?v=1717478021);"></div>
            <div class="color-swatch" data-category="powder-coat" data-value="Baby-Blue" style="background: url(${images}baby-blue.svg?v=1717478021);"></div>
            <div class="color-swatch" data-category="powder-coat" data-value="Flo-Yellow" style="background: url(${images}flo-yellow.svg?v=1717478021);"></div>
            <div class="color-swatch" data-category="powder-coat" data-value="Nardo-Grey" style="background: url(${images}nardo-grey.svg?v=1717478021);"></div>
            <div class="color-swatch" data-category="powder-coat" data-value="Orange" style="background: url(${images}orange.svg?v=1717478021);"></div>
            <div class="color-swatch" data-category="powder-coat" data-value="School-Bus-Yellow" style="background: url(${images}school-bus-yellow.svg?v=1717478021);"></div>
            <div class="color-swatch" data-category="powder-coat" data-value="White" style="background: url(${images}white.svg?v=1717478021);"></div>
        `);
    } else {
			var selected_spoke_color = $('#spoke_color').val();
	
			// console.log(`Selected spoke: ${selected_spoke_color}`);
			var rimSize = this.value;
	
			var spokeColorSwatches = $('.spoke_color_wrapper .color-swatch');
			var nippleColorSwatches = $('.nipple_color_wrapper .color-swatch');
			var wheel_type = $('#wheel_type').val()
	
			if (wheel_type =="FRONT" && rimSize.includes('19')) {
				// Show only silver and black spoke options
				spokeColorSwatches.each(function () {
					var value = $(this).data('value');
					$(this).toggle(value === 'Silver' || value === 'Black');
				});
				nippleColorSwatches.each(function () {
					var value = $(this).data('value');
					if(value === 'Silver'){
						$(this).show();
					}else{
						$(this).hide();
					}
				});
			} else {
				// Show all spoke options
				spokeColorSwatches.show();
				nippleColorSwatches.show();
			}
			var firstVisibleSwatch = spokeColorSwatches.filter(':visible').first();
			if (firstVisibleSwatch.length) {
				firstVisibleSwatch.trigger('click'); // Simulate click event to select
			}
	
			var firstVisibleSwatch = nippleColorSwatches.filter(':visible').first();
			// if($(`.spoke_color_wrapper .color-swatch[data-value="${selected_spoke_color}"]`).length){
			// 	$(`.spoke_color_wrapper .color-swatch[data-value="${selected_spoke_color}"]`).trigger('click');
			// }else{
			// 	if (firstVisibleSwatch.length) {
			// 		firstVisibleSwatch.trigger('click'); // Simulate click event to select
			// 	}
			// }
			if (firstVisibleSwatch.length) {
				firstVisibleSwatch.trigger('click'); // Simulate click event to select
			}
			var rimSizeVal = $('select#rim_size').val();
			var wheel_type = $('select#wheel_type').val();
			// console.log({wheel_type});
			if (wheel_type == 'REAR') {
				if (rimSizeVal == 'REAR 18x2.15' || rimSizeVal == 'REAR 18x2.50') {
					var mbtire = $('select#mbtire');
					mbtire.empty();
					$.each(mbtireRearOptions18, function (value, text) {
						// mbtire.append($('<option>', {
						//     value: value,
						//     text: text
						// }));
						var option = $('<option>', {
							value: value,
							text: text
						});
	
						// Add the 'selected' attribute to the first option
						if (mbtire.is(':empty')) {
							option.prop('selected', true);
						}
						mbtire.append(option);
					});
	
				} 
				else {
					var mbtire = $('select#mbtire');
					mbtire.empty();
					$.each(mbtireRearOptions19, function (value, text) {
						// mbtire.append($('<option>', {
						//     value: value,
						//     text: text
						// }));
						var option = $('<option>', {
							value: value,
							text: text
						});
	
						// Add the 'selected' attribute to the first option
						if (mbtire.is(':empty')) {
							option.prop('selected', true);
						}
	
						mbtire.append(option);
					});
				}
				// console.log("mbtire value : ", mbtire.val());
			} else {
				// check rim size value
				var mbtire = $('select#mbtire');
				mbtire.empty();
				$.each(mbtireFrontOptions, function (value, text) {
					// mbtire.append($('<option>', {
					//     value: value,
					//     text: text
					// }));
					var option = $('<option>', {
						value: value,
						text: text
					});
	
					// Add the 'selected' attribute to the first option
					if (mbtire.is(':empty')) {
						option.prop('selected', true);
					}
	
					mbtire.append(option);
				});
			}
    }
	

	});

	$(document).on("change", "#rim_color", function () {
		var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/rim-" + $('#rim_color').val() + "-" + $('select#wheel_type').val() + ".png";
		var imageArr2 = [image_name];
		var divArr2 = ["resultAreaID_1_1"];
		// imageObj2 = new BL_ImageLoader(divArr2, imageArr2);
		$('#resultAreaID_1_1 img').attr('src', image_name);
	});

	var rimcolorSwatches = $('.rim_color_wrapper .color-swatch');
	var rimHiddenInput = $('#rim_color');

	$(document).on("click", '.rim_color_wrapper .color-swatch', function () {
		var colorValue = $(this).data('value');
		rimcolorSwatches.removeClass('active');
		$(this).addClass('active');
		rimHiddenInput.val(colorValue);
		// console.log(colorValue);
		var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/rim-" + $('#rim_color').val() + "-" + $('select#wheel_type').val() + ".png";
		$('#resultAreaID_1_1 img').attr('src', image_name);
		tprice();
		var colorTitle = $(this).attr('title') ? $(this).attr('title') : $(this).data('value');

		$('#selected_rim_color').html(colorTitle.replaceAll('-', " "));
	});

	// Hub Color
	var hubcolorSwatches = $('.hub_color_wrapper .color-swatch');
	var hubHiddenInput = $('#hub_color');

	// $(document).on('change', 'select, input', function(){
	//     updateCushImg()
	// });
	// $(document).on("click", '.hub_color_wrapper .color-swatch', function() {
	//     updateCushImg()
	// });

	// function updateCushImg(){
	//     if ($('select#cush_drive').val() == "Cush Drive") {
	//     //Display Cush Hub
	//         var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/cush-hub-" + $('#hub_color').val() + '-' + $('select#wheel_type').val() + ".png";
	//         var imageArr1 = [image_name];
	//         var divArr1 = ["resultAreaID_1_0"];

	//     $('#resultAreaID_1_0 img').attr('src',image_name);
	//         console.log(image_name)
	//     }
	// }
	$(document).on("click", '.hub_color_wrapper .color-swatch', function () {
		var colorValue = $(this).data('value');
		hubcolorSwatches.removeClass('active');
		$(this).addClass('active');
		hubHiddenInput.val(colorValue);
		// console.log(colorValue);
		if ($('select#cush_drive').val() == "Cush Drive") {
			//Display Cush Hub
			var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/cush-hub-" + $('#hub_color').val() + '-' + $('select#wheel_type').val() + ".png";
			var imageArr1 = [image_name];
			var divArr1 = ["resultAreaID_1_0"];
			// imageObj = new BL_ImageLoader(divArr1, imageArr1);

			if ($('select#carrier_id').val() == "Yes") {

				//sprocket, carrier, and rubbers for Cush 
				var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/" + $('#hub_color').val() + "-sprocket-and-carrier500.png";
				var imageArr5 = [image_name];
				var divArr5 = ["resultAreaID_1_6"];
				$('#resultAreaID_1_6 img').attr('src', image_name);
				// imageObj5 = new BL_ImageLoader(divArr5, imageArr5);
				document.getElementById("resultAreaID_1_7").innerHTML = "";
			} else {
				if ($('select#bike_model').val() === "DR650SE *REAR*" || $('select#bike_model').val() == "2008 – 2013 KTM 690 ENDURO * REAR *" || $('select#bike_model').val() == "790 Adventure *REAR*" || $('select#bike_model').val() == "790 Adventure R *REAR*" || $('select#bike_model').val() == "890 Adventure *REAR*" || $('select#bike_model').val() == "890 Adventure R *REAR*" || $('select#bike_model').val() == "950 Adventure *REAR*" || $('select#bike_model').val() == "990 Adventure *REAR*" || $('select#bike_model').val() == "1090 Adventure *REAR*" || $('select#bike_model').val() == "1190 Adventure *REAR*" || $('select#bike_model').val() == "1290 Adventure ABS *REAR*" || $('select#bike_model').val() == "1290 Adventure R *REAR*" || $('select#bike_model').val() == "1290 Super Adventure S *REAR*" || $('select#bike_model').val() == "2014 – 2017 KTM 690 ENDURO ABS * REAR *" || $('select#bike_model').val() == "KLR650 *REAR* ") {
					document.getElementById("resultAreaID_1_7").innerHTML = "";
				} else {
					//sprocket, carrier, and rubbers for Cush 
					var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/rubbers.png";
					var imageArr7 = [image_name];
					var divArr7 = ["resultAreaID_1_7"];
					$('#resultAreaID_1_7 img').attr('src', image_name);
					// imageObj7 = new BL_ImageLoader(divArr7, imageArr7);

					var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/" + $('#hub_color').val() + "-sprocket-and-carrier500.png";
					var imageArr5 = [image_name];
					var divArr5 = ["resultAreaID_1_6"];
					$('#resultAreaID_1_6 img').attr('src', image_name);
					// imageObj5 = new BL_ImageLoader(divArr5, imageArr5);
				}
			};
			$('#resultAreaID_1_4').show();
		} else {
			var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/hub-" + $('#hub_color').val() + "-" + $('select#wheel_type').val() + ".png";
			var imageArr1 = [image_name];
			var divArr1 = ["resultAreaID_1_0"];
			$('#resultAreaID_1_0 img').attr('src', image_name);

			// imageObj = new BL_ImageLoader(divArr1, imageArr1);

			var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/sprocket.png";
			var imageArr6 = [image_name];
			var divArr6 = ["resultAreaID_1_7"];
			$('#resultAreaID_1_7 img').attr('src', image_name);
			// imageObj6 = new BL_ImageLoader(divArr6, imageArr6);
		}
		tprice();
		var colorTitle = $(this).attr('title') || $(this).data('value');
		var extratext = "Anodized";
		if (colorTitle != "Silver") {
			$('#selected_hub_color').html(extratext + ' - ' + colorTitle);
		} else {
			$('#selected_hub_color').html(colorTitle);
		}
        var activeNippleColor = $('.nipple_color_wrapper .active').data('value');
       $('#nipple_color').val(activeNippleColor);
	});

	var nipplecolorSwatches = $('.nipple_color_wrapper .color-swatch');
	var nippleHiddenInput = $('#nipple_color');
	$(document).on("click", '.nipple_color_wrapper .color-swatch', function () {
		var colorValue = $(this).data('value');
		nipplecolorSwatches.removeClass('active');
		$(this).addClass('active');
		nippleHiddenInput.val(colorValue);
		var image_name = images + "/nipple-" + $('#nipple_color').val() + "-" + $('select#wheel_type').val() + ".png";
		$('#resultAreaID_1_3 img').attr('src', image_name);
		tprice();
		var colorTitle = $(this).attr('title') || $(this).data('value');
		var extratext = "Anodized";
		if (colorTitle != "Silver") {
			$('#selected_nipple_color').html(`${colorTitle} (${extratext})`);
		} else {
			$('#selected_nipple_color').html(colorTitle);
		}
		// $('#selected_nipple_color').html(colorTitle);
	});

	// Spoke Color
	var spokecolorSwatches = $('.spoke_color_wrapper .color-swatch');
	var spokeHiddenInput = $('#spoke_color');

	$(document).on("click", '.spoke_color_wrapper .color-swatch', function () {
		var colorValue = $(this).data('value');
		spokecolorSwatches = $('.spoke_color_wrapper .color-swatch');
		spokecolorSwatches.removeClass('active');
		$(this).addClass('active');
		// console.log(spokecolorSwatches)
		// console.log('WORKING')
		// console.log(colorValue)
		spokeHiddenInput.val(colorValue);
		if ($('select#cush_drive').val() != "unavailable") {
			//Display Cush Spokes
			var image_name = images + "/cush-spokes-" + $('#spoke_color').val() + "-" + $('select#wheel_type').val() + ".png";
			$('#resultAreaID_1_2 img').attr('src', image_name);
		} else {
			//SPOKE COLOR
			var image_name = images + "/spokes-" + $('#spoke_color').val() + "-" + $('select#wheel_type').val() + ".png";
			$('#resultAreaID_1_2 img').attr('src', image_name);
		}

		var rimsize = $('select#rim_size').val();
		var spokeColor = spokeHiddenInput.val();
		var spokeColorSwatches = $('.spoke_color_wrapper .color-swatch');
		var nippleColorSwatches = $('.nipple_color_wrapper .color-swatch');
		var wheel_type = $('#wheel_type').val();
		if(rimsize){
			if (wheel_type == "FRONT" && rimsize.includes('19') && spokeColor == 'Silver') {
				nippleColorSwatches.each(function () {
					var value = $(this).data('value');
					$(this).toggle(value === 'Silver');
				});
			} else {
				nippleColorSwatches.show();
			}
		}else{
			nippleColorSwatches.show();

		}

		var firstVisibleSwatch = nippleColorSwatches.filter(':visible').first();
		if (firstVisibleSwatch.length) {
			firstVisibleSwatch.trigger('click'); // Simulate click event to select
		}
		tprice();
		var colorTitle = $(this).attr('title') || $(this).data('value');
		var extratext = "Powder Coat";
		if (colorTitle != "Silver" && colorTitle != "Titanium") {
			$('#selected_spoke_color').html(`${colorTitle} (${extratext})`);
		} else {
			$('#selected_spoke_color').html(colorTitle);
		}
		// $('#selected_spoke_color').html(colorTitle);
	});

	// change year on wheel type
	$('select#wheel_type').change(bikeyear);
	$('select#bike_model').change(bikeyear);
	$('select#wheel_type').change(speedometer);
	$('select#bike_year').change(speedometer);

	$('select#bike_make').change(tprice);
	$('select#bike_model').change(tprice);
	$('select#carrier_id').change(tprice);

	$('select#rim_size').change(tprice);
	$('select#brake_rotor').change(tprice);
	$('select#sprocket_size').change(tprice);
	$('select#wheel_type').change(tprice);
	$('select#rim_type').change(tprice);
	$('select#cush_drive').change(tprice);
	$('select#sprocket_bolts').change(tprice);
	$('select#rotor_bolts').change(tprice);
	$('select#sm_magnets').change(tprice);
	$('select#mbtire').change(tprice);
	$(document).on('change', 'select, input', function () {
		tprice();
	});
	// Function to transform the fieldName
	function transformFieldName(name) {
		return name.replace(/_/g, ' ')
			.replace(/\w\S*/g, function (txt) {
				return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
			});
	}

	// Function to transform the fieldValue
	function transformFieldValue(value) {
		return value ? value.charAt(0).toUpperCase() + value.substr(1).toLowerCase() : value;
	}

	function collectFormData() {
		var formDataArray = [];
		$('#custom-wheel-form select, #custom-wheel-form input[type="text"], #custom-wheel-form input[type="hidden"]').each(function () {
			var fieldName = $(this).attr('name');
			var fieldValue = $(this).val();
			if (fieldName) {
				var fieldData = {
					name: transformFieldName(fieldName),
					value: transformFieldValue(fieldValue)
				};
				formDataArray.push(fieldData);
			}
		});
		return formDataArray;
	}

	$('select#wheel_type').change(function() {
               setTimeout(function () {
            $('#sprocket_size').val('no').change();
        }, 500);
         });

	$('.act-btn-custom').on('click', function () {
		var selectedvariant = $('#custom-wheel-form').attr("data-variantid");

		var withtire = "45197025870072";
		var withouttire = "45197025804536";
		selectedvariant = withouttire;

		var rim_size = document.querySelector('#rim_size').value;
		var wheel_type = document.querySelector('#wheel_type').value;
		var has_tire = document.querySelector('#mbtire').value

		if(wheel_type == "FRONT"){
			if(has_tire!="mbno"){ // HAS TIRE
				if(rim_size.includes('21')){
					selectedvariant = 45907711623416;
				}
			}else{ // NO TIRE
				if(rim_size.includes('21')){
					selectedvariant = 45907680854264;
				}else if(rim_size.includes('19')){
					selectedvariant = 45907689177336;
				}
			}
		}else{
			if(has_tire!="mbno"){ // HAS TIRE
				if(rim_size.includes('18') || rim_size.includes('19')){
					selectedvariant = 45907717488888;
				}
			}else{ // NO TIRE
				if(rim_size.includes('18') || rim_size.includes('19')){
					selectedvariant = 45907699532024;
				}
			}
		}

		var totalpersonalizeitem = parseInt(new_base_price - base_price) / 0.01;
		var title = $('.product-info-heading ').text();
		// console.log(base_price, new_base_price, totalpersonalizeitem);
		var formData = collectFormData();
		if ($('#wheel_type').val() == "FRONT") {
			formData = formData.filter(function (item) {
				return item.name !== "Sprocket Bolts" && item.name !== "Sprocket Size";
			});
		}
		var properties = {};
		formData.forEach(function (field) {
			properties[field.name] = (field.value || "").trim();
		});
		properties['__extraPricing'] = totalpersonalizeitem;

		let newObject = {
			product: title,
			__parentVariant: selectedvariant
		};

		let wbproperties = {
			...newObject,
			...properties
		};


		//    var requestData = {
		// items: [
		// 	{
		// 		quantity: totalpersonalizeitem, // Adjust the quantity as needed
		// 		id: 44252901507320, // Use your actual product ID\
		// 		properties: wbproperties
		// 	},
		// 	{
		// 		quantity: 1, // Adjust the quantity as needed
		// 		id: selectedvariant, // Use your actual product ID
		// 		properties: properties
		// 	}                
		// ]
		//    };
		properties['__price'] = new_base_price;

		var requestData = {
			items: [{
				quantity: 1, // Adjust the quantity as needed
				id: selectedvariant, // Use your actual product ID
				properties: properties
			}]
		};

		const bikeModelSelect = document.getElementById("bike_model");
		const selectedModelText = bikeModelSelect.options[bikeModelSelect.selectedIndex].text;

		requestData.items[0].properties["Bike Model"] = selectedModelText;
		$.ajax({
			url: "/cart/add.js",
			type: "POST",
			data: JSON.stringify(requestData),
			contentType: "application/json",
			dataType: 'json',
			success: function (response) {
				// console.log("Item added to the cart successfully.", response);
				window.location.href = "/cart";
			},
			error: function (xhr, status, error) {
				console.error("Error adding item to the cart.", status, error);
			}
		});
	});
	$('.product.product-page').addClass('init');
	tprice();



	


	setupRimLock();
	$(document).on('change', 'select:not(#rim_lock), input', function () {
		setupRimLock();
	});

	function setupRimLock(){
		const rimSizesToCheck = ['21x1.60', '21x1.85', '17x2.50', '18x2.15', '18x2.50', '19x2.15', '19x2.50', '19x3.00'];
		const selected_rim_size = document.querySelector('#rim_size').value;
		const isRimSizeValid = rimSizesToCheck.some(rim => selected_rim_size.includes(rim));
		if(isRimSizeValid){
			document.querySelector('#rim_lock_field').style.display = "block";
		}else{
			document.querySelector('#rim_lock_field').style.display = "none";
			document.querySelector('#rim_lock').value = "Yes";
		}
		tprice();
	}
});

function roundUpIfEndsWith95(price) {
   return Math.ceil(price);
}

